import React, { useState, useEffect, useRef } from "react";
import {
  DndContext,
  useSensor,
  useSensors,
  PointerSensor,
  TouchSensor,
  closestCenter
} from "@dnd-kit/core";
import { useDraggable, useDroppable } from "@dnd-kit/core";
import { DragOverlay } from '@dnd-kit/core';



// SVG نمونه‌ها (شبیه سازی کن!)
const ScienceBook = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}
      <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#D79917"/>
      <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
      <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
      <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" strokeWidth="1.36054" strokeMiterlimit="10"/>
      <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
    </g>
  </svg>
);

const ScienceBook2 = () => (
<svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
 <g transform="scale(0.75, 0.74)">
  <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#D79917"/>
  <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
  <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
  <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" stroke-width="1.36054" stroke-miterlimit="10"/>
  <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
 </g>
</svg>

);
const ScienceBook3 = () => (
<svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
 <g transform="scale(0.75, 0.74)">

<path d="M34.726 0H5.27394C2.3612 0 0 1.40653 0 3.14157V96.8581C0 98.5931 2.3612 99.9997 5.27394 99.9997H34.726C37.6387 99.9997 40 98.5931 40 96.8581V3.14157C40 1.40653 37.6387 0 34.726 0Z" fill="#7B6B59"/>
<path opacity="0.2" d="M6.6438 96.8584V3.16232C6.6438 1.42834 9.00686 0.020752 11.9178 0.020752H5.27394C2.36298 0.020752 0 1.42834 0 3.16232V96.8584C0 98.5924 2.36298 100 5.27394 100H11.9178C9.00686 100 6.6438 98.5924 6.6438 96.8584Z" fill="#1E1E1C"/>
<path opacity="0.1" d="M34.7259 0H26.6438C29.5548 0 31.9177 1.40759 31.9177 3.14157V96.8377C31.9177 98.5717 29.5548 99.9793 26.6438 99.9793H34.7259C37.6369 99.9793 40 98.5717 40 96.8377V3.14157C40 1.40759 37.6369 0 34.7259 0Z" fill="#2D1E15"/>
<path d="M36.0958 91.6152H3.39038V93.798H36.0958V91.6152Z" fill="#D8CCBA"/>
<path d="M36.0958 3.73315H3.39038V5.91592H36.0958V3.73315Z" fill="#D8CCBA"/>
<path d="M36.0958 7.28271H3.39038V9.46548H36.0958V7.28271Z" fill="#D8CCBA"/>
<path opacity="0.2" d="M8.83562 98.2861C7.26028 98.2861 5.95886 97.5109 5.95886 96.5725V3.42721C5.95886 2.48882 7.26028 1.71362 8.83562 1.71362C10.411 1.71362 11.7123 2.48882 11.7123 3.42721V96.5725C11.7123 97.5109 10.411 98.2861 8.83562 98.2861Z" fill="white" fill-opacity="0.78"/>
 </g>
</svg>
);

const ScienceBook4 = () => (
<svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">

 <g transform="scale(0.75, 0.74)">

<path d="M39.9995 3.54957L39.9995 96.4749C39.9995 98.4088 37.6092 100 34.6214 100L5.37807 100C2.42759 100 -6.84832e-08 98.4333 -1.54087e-07 96.4749L-4.21598e-06 3.54957C-4.30052e-06 1.61567 2.39024 0.0244767 5.37807 0.0244765L34.6214 0.0244752C37.5719 0.0244751 39.9995 1.59119 39.9995 3.54957Z" fill="#7A6D18"/>
<path d="M35 3L4 3L4 9L35 9L35 3Z" fill="#D79917"/>
<path d="M35 10L4 10L4 14L35 14L35 10Z" fill="#D79917"/>
<path opacity="0.2" d="M9.54264 98.6296C7.93669 98.6296 6.62952 97.7728 6.62952 96.7202L6.62951 3.01153C6.62951 1.9589 7.93668 1.10212 9.54264 1.10212C11.1486 1.10212 12.4558 1.9589 12.4558 3.01153L12.4558 96.7202C12.4558 97.7728 11.1486 98.6296 9.54264 98.6296Z" fill="white" fill-opacity="0.73"/>
 </g>

</svg>
);
const ScienceBook5 = () => (
<svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
 <g transform="scale(0.75, 0.74)">
  <path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#2A3180"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#F7C26D"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#F7C26D"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
 </g>
</svg>
);
const HistoryBook = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}
      <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#7F4F25"/>
      <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
      <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
      {/* <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" strokeWidth="1.36054" strokeMiterlimit="10"/> */}
      <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
    </g>
  </svg>
);
const HistoryBook2 = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9995 3.54957L39.9995 96.4749C39.9995 98.4088 37.6092 100 34.6214 100L5.37807 100C2.42759 100 -6.84832e-08 98.4333 -1.54087e-07 96.4749L-4.21598e-06 3.54957C-4.30052e-06 1.61567 2.39024 0.0244767 5.37807 0.0244765L34.6214 0.0244752C37.5719 0.0244751 39.9995 1.59119 39.9995 3.54957Z" fill="#7A6D18"/>
<path d="M35 3L4 3L4 9L35 9L35 3Z" fill="#D79917"/>
<path d="M35 10L4 10L4 14L35 14L35 10Z" fill="#D79917"/>
<path opacity="0.2" d="M9.54264 98.6296C7.93669 98.6296 6.62952 97.7728 6.62952 96.7202L6.62951 3.01153C6.62951 1.9589 7.93668 1.10212 9.54264 1.10212C11.1486 1.10212 12.4558 1.9589 12.4558 3.01153L12.4558 96.7202C12.4558 97.7728 11.1486 98.6296 9.54264 98.6296Z" fill="white" fill-opacity="0.73"/>
    </g>
  </svg>
);
const HistoryBook3 = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}
      <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#7F4F25"/>
      <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
      <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
      {/* <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" strokeWidth="1.36054" strokeMiterlimit="10"/> */}
      <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
    </g>
  </svg>
);
const HistoryBook4 = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

 <path d="M39.9617 0H0V100H39.9617V0Z" fill="#841625"/>
<path d="M35.1844 4.50464H4.88672V87.2749H35.1844V4.50464Z" fill="#841625" stroke="#F8B133" stroke-width="1.5696" stroke-miterlimit="10"/>
<path d="M35.1844 91.7793H4.88672V95.1577H35.1844V91.7793Z" fill="#841625" stroke="#F8B133" stroke-width="1.5696" stroke-miterlimit="10"/>
    </g>
  </svg>
);
const HistoryBook5 = () => (
<svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
 <g transform="scale(0.75, 0.74)">
  <path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#2A3180"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#F7C26D"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#F7C26D"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
 </g>
</svg>
);
const BioBook2 = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#8A644B"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#CABAA0"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#CABAA0"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
    </g>
  </svg>
);
const BioBook4 = () => (
 <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}
      <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#D79917"/>
      <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
      <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
      <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" strokeWidth="1.36054" strokeMiterlimit="10"/>
      <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
    </g>
  </svg>
);
const BioBook3 = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#8E2F00"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#CABAA0"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#CABAA0"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
    </g>
  </svg>
);
const BioBook = () => (
 <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}
      <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#D79917"/>
      <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
      <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
      <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" strokeWidth="1.36054" strokeMiterlimit="10"/>
      <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
    </g>
  </svg>
);
const BioBook5 = () => (
    <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}
      <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#7F4F25"/>
      <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
      <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
      {/* <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" strokeWidth="1.36054" strokeMiterlimit="10"/> */}
      <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
    </g>
  </svg>
);
const MathBook = () => (
   <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#624669"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#CABAA0"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#CABAA0"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
    </g>
  </svg>
);
const MathBook2 = () => (
   <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#2A3180"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#CABAA0"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#CABAA0"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
    </g>
  </svg>
);
const MathBook3 = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9995 3.54957L39.9995 96.4749C39.9995 98.4088 37.6092 100 34.6214 100L5.37807 100C2.42759 100 -6.84832e-08 98.4333 -1.54087e-07 96.4749L-4.21598e-06 3.54957C-4.30052e-06 1.61567 2.39024 0.0244767 5.37807 0.0244765L34.6214 0.0244752C37.5719 0.0244751 39.9995 1.59119 39.9995 3.54957Z" fill="#7A6D18"/>
<path d="M35 3L4 3L4 9L35 9L35 3Z" fill="#D79917"/>
<path d="M35 10L4 10L4 14L35 14L35 10Z" fill="#D79917"/>
<path opacity="0.2" d="M9.54264 98.6296C7.93669 98.6296 6.62952 97.7728 6.62952 96.7202L6.62951 3.01153C6.62951 1.9589 7.93668 1.10212 9.54264 1.10212C11.1486 1.10212 12.4558 1.9589 12.4558 3.01153L12.4558 96.7202C12.4558 97.7728 11.1486 98.6296 9.54264 98.6296Z" fill="white" fill-opacity="0.73"/>
    </g>
  </svg>
); 
const MathBook4 = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#8E2F00"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#CABAA0"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#CABAA0"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
    </g>
  </svg>
); 
const MathBook5 = () => (
   <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#624669"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#CABAA0"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#CABAA0"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
    </g>
  </svg>
);
const LiteratureBook2 = () => (
   <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#8A644B"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#CABAA0"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#CABAA0"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
    </g>
  </svg>
);
const LiteratureBook = () => (
<svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
 <g transform="scale(0.75, 0.74)">
  <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#D79917"/>
  <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
  <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
  <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" stroke-width="1.36054" stroke-miterlimit="10"/>
  <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
 </g>
</svg>
);
const LiteratureBook3 = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}

<path d="M39.9995 3.54957L39.9995 96.4749C39.9995 98.4088 37.6092 100 34.6214 100L5.37807 100C2.42759 100 -6.84832e-08 98.4333 -1.54087e-07 96.4749L-4.21598e-06 3.54957C-4.30052e-06 1.61567 2.39024 0.0244767 5.37807 0.0244765L34.6214 0.0244752C37.5719 0.0244751 39.9995 1.59119 39.9995 3.54957Z" fill="#7A6D18"/>
<path d="M35 3L4 3L4 9L35 9L35 3Z" fill="#D79917"/>
<path d="M35 10L4 10L4 14L35 14L35 10Z" fill="#D79917"/>
<path opacity="0.2" d="M9.54264 98.6296C7.93669 98.6296 6.62952 97.7728 6.62952 96.7202L6.62951 3.01153C6.62951 1.9589 7.93668 1.10212 9.54264 1.10212C11.1486 1.10212 12.4558 1.9589 12.4558 3.01153L12.4558 96.7202C12.4558 97.7728 11.1486 98.6296 9.54264 98.6296Z" fill="white" fill-opacity="0.73"/>
    </g>
  </svg>
);
const LiteratureBook4 = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}
      <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#7F4F25"/>
      <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
      <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
      {/* <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" strokeWidth="1.36054" strokeMiterlimit="10"/> */}
      <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
    </g>
  </svg>
);
const LiteratureBook5 = () => (
 <svg width="30" height="74" viewBox="0 0 30 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="scale(0.75, 0.74)"> {/* مقیاس‌دهی به 75% عرض و 74% ارتفاع برای فیت شدن در 30x74 */}
      <path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#7F4F25"/>
      <path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
      <path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
      {/* <path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" strokeWidth="1.36054" strokeMiterlimit="10"/> */}
      <path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
    </g>
  </svg>
);

const DefaultBook = () => (
  <svg width="30" height="74" viewBox="0 0 30 74" fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="30" height="74" rx="2"
          fill="#7f8c8d" stroke="#555" />
  </svg>
);

// بالای فایل BookshelfGameWithTimer.jsx
const categoryComponentMap = {
horror: [ScienceBook2, ScienceBook3],       // ✔️ فقط نام تابع/کامپوننت، نه JSX
philosophy: [BioBook, BioBook3],
memoir: [HistoryBook2, HistoryBook4],
poetry: [LiteratureBook, MathBook5],
psychological: [BioBook2, BioBook4],
adventure: [ScienceBook, ScienceBook4],
psychology: [BioBook5, MathBook2],
biography: [HistoryBook, HistoryBook3],
"science fiction": [ScienceBook5, ScienceBook],
"historical fiction": [HistoryBook5, HistoryBook2],
mystery: [MathBook, MathBook2],
drama: [MathBook, MathBook2],
thriller: [MathBook3, MathBook4],
"self-help": [LiteratureBook3, LiteratureBook5],
fiction: [LiteratureBook, LiteratureBook4],
fantasy: [ScienceBook3, ScienceBook5],
romance: [BioBook, BioBook2],
classic: [HistoryBook, HistoryBook5],

};
function simpleHash(str = '') {
  return str
    .split('')
    .reduce((h, c) => ((h << 5) - h) + c.charCodeAt(0), 0) >>> 0;
}


// const bankBooks = [
//   { id: "science2", book: <ScienceBook /> },
//   { id: "history2", book: <HistoryBook /> },
//   { id: "bio1", book: <BioBook /> },
//   { id: "math3", book: <MathBook /> },
//   { id: "literature3", book: <LiteratureBook /> }
// ];


const Slot = ({highlight}) => (
  <svg width="46" height="80" style={{opacity: highlight ? 1 : 0.9}}>
    <rect x="0" y="0" width="46" height="80" rx="7" fill="#0000"
      stroke={highlight ? "#44b151" : "#ffe193"}
      strokeDasharray="7,6" strokeWidth="3"/>
  </svg>
);

// ====== Carousel Arrow Buttons ======
const ArrowButton = ({ direction, onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={{
      background: "#fff9e3",
      border: "2px solid #ffe193",
      borderRadius: 14,
      width: 48,
      height: 48,
      cursor: disabled ? "not-allowed" : "pointer",
      position: "absolute",
     top: "50%",
     transform: "translateY(-50%)",
      [direction === "left" ? "left" : "right"]: -24,
      zIndex: 5,
      fontWeight: 900,
      fontSize: 22,
      color: "#d79917",
      boxShadow: disabled ? "none" : "0 2px 8px #0001",
        display: "flex",
      alignItems: "center",
      justifyContent: "center",
        }}
  >
    {direction === "left" ? "⟨" : "⟩"}
  </button>
);

// ====== Draggable & Droppable Book Components ======
function DroppableSlot({ id, children }) {
  const { setNodeRef, isOver } = useDroppable({ id });
  return (
    <div
      ref={setNodeRef}
      style={{
        // background: isOver ? "#e3ffe3" : "#f6ecd3",
        width: 45,
        height: 78,
        borderRadius: 7,
        margin: 6,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "2px dashed #ffe193",
        transition: "background .18s",
        position: 'relative', // اجازه می‌ده Slot خط‌چین و کتاب کنار هم باشند
        overflow: "visible",
        zIndex: 1
      }}
    >
      {children}
    </div>
  );
}



// BookshelfFrameSVG.jsx
const BookshelfFrameSVG = ({children}) => (
  <div style={{
    position:'relative',
    maxWidth: 400,
    width: '95%',
    margin: '0 auto',
    background: '#936037',
    paddingBottom: 30, // فضای میز
    borderRadius: 24
  }}>
    {/* تاج بالا */}
    <svg style={{position:'absolute', top:-28, left:0, width:'100%', zIndex:0}} width="400" height="40" viewBox="0 0 400 40">
      <rect x="0" y="12" width="400" height="35" rx="0" fill="#936037" stroke="#85552c"/>
        {/* متن تاج */}
  <text
    x="50%" y="29"
    textAnchor="middle"
    dominantBaseline="middle"
    fontFamily="serif"
    fontWeight="bold"
    fontSize="20"
    fill="#6d430b"
    style={{
      // textShadow: "0 1px 0 #ffe9b5, 0 2px 1px #b59562"
    }}
  ></text>
    </svg>

    {/* قاب چوبی دور */}
    <div style={{
      position:'absolute',
      zIndex:2,
      inset: 0,
      border: '9px solid #936037',
      borderRadius: 0,
      pointerEvents:'none'
    }}></div>

    {/* پس زمینه قفسه */}
    <div style={{
      background: '#33231C',
     
      margin: '12px 8px 0 8px',
      minHeight: 355,
      position:'relative',
      zIndex:2,
      boxShadow:'0 2px 16px #936037'
    }}>

      {/* متن و کودکان */}
      <div style={{
        position:'relative', zIndex:5, padding:'30px 14px 0 14px'
      }}>
        {children}
      </div>
    </div>

    {/* میز بانک کتاب */}
    {/* <div style={{
      position:'absolute',
      bottom:0,left:0,right:0,
      height:40,
      background: 'linear-gradient(#a0703a,#caa35e 80%)',
      borderBottomLeftRadius: 24,
      borderBottomRightRadius: 24,
      boxShadow: '0 10px 24px #99774633',
      zIndex: 6,
      borderTop: '3px solid #805628'
    }}
    /> */}
  </div>
);


// دیتا: موقعیت هر کتاب و جای خالی
const initialShelves = [
  // Science
  [
    { id: "science1", book: <ScienceBook />, fixed: true },
    { id: "science2", book: null, fixed: false },
    { id: "science3", book: <ScienceBook3 />, fixed: true },
    { id: "science4", book: <ScienceBook4 />, fixed: true },
    { id: "science5", book: <ScienceBook5 />, fixed: true },
  ],
  // History
  [
    { id: "history", book: <HistoryBook />, fixed: true },
    { id: "history2", book: <HistoryBook2 />, fixed: true },
    { id: "history3", book: null, fixed: false },
    { id: "history4", book: <HistoryBook4 />, fixed: true },
    { id: "history5", book: <HistoryBook5 />, fixed: true },
  ],
  // Biographies
  [
    { id: "bio", book: null, fixed: false },
    { id: "bio3", book: <BioBook3 />, fixed: true },
    { id: "bio2", book: <BioBook2 />, fixed: true },
    { id: "bio4", book: <BioBook4 />, fixed: true },
    { id: "bio5", book: <BioBook5 />, fixed: true },

  ],
  //MathBook
    [
    { id: "math", book: <MathBook />, fixed: true },
    { id: "math2", book: <MathBook2 />, fixed: true },
    { id: "math3", book: null, fixed: false },
    { id: "math4", book: <MathBook4 />, fixed: true },
    { id: "math5", book: <MathBook5 />, fixed: true },
   
  ],
  //Literature Book
    [
    { id: "literature", book: <LiteratureBook />, fixed: true },
    { id: "literature2", book: <LiteratureBook2 />, fixed: true },
    { id: "literature3", book: <LiteratureBook3 />, fixed: true },
    { id: "literature5", book: <LiteratureBook5 />, fixed: true },
     { id: "literature4", book: null, fixed: false },
  
  ],
];


// کتاب‌هایی که پایین Drag می‌شوند
const BookIconCartoon = ({
  title = "",
  width = 90,
  height = 130,
  color = "#fff"
}) => {
  // مختصات و ابعاد مستطیل هدف در ابعاد اصلی SVG
  const rect = {
    x: 554.346, y: 302.496, width: 993.847, height: 1440.683,
  };
  const viewBoxWidth = 1990;
  const viewBoxHeight = 2262;

  const dispRect = {
    x: rect.x * (width / viewBoxWidth),
    y: rect.y * (height / viewBoxHeight),
    width: rect.width * (width / viewBoxWidth),
    height: rect.height * (height / viewBoxHeight),
  };

  function fitFontSize(text, boxWidth, boxHeight, maxFont = 170, minFont = 18) {
    const words = text.split(" ");
    let fontSize = maxFont;
    const ctx = document.createElement("canvas").getContext("2d");

    while (fontSize >= minFont) {
      ctx.font = `${fontSize}px Vazirmatn, Tahoma, Arial`;
      let lines = [];
      let line = "";
      for (let w of words) {
        let testLine = line.length === 0 ? w : line + " " + w;
        let testWidth = ctx.measureText(testLine).width;
        if (testWidth > boxWidth) {
          lines.push(line);
          line = w;
        } else {
          line = testLine;
        }
      }
      if (line.length > 0) lines.push(line);
      if (lines.length <= 3 && lines.length * fontSize * 1.1 <= boxHeight) {
        return { fontSize, lines };
      }
      fontSize -= 4;
    }
    return { fontSize: minFont, lines: [text] };
  }

  const { fontSize, lines } = fitFontSize(
    title,
    rect.width * 0.95,   // کمی فاصله برای اطمینان
    rect.height * 0.85
  );
  const lineHeight = fontSize * 1.1;

  return (
    <svg
      width={width}
      height={height}
     viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block" }}
    >
           <g>
        <path
          style={{ fill: "#CAD7DB" }}
          d="M1626.188,1995.019h-10.758v-195.147c6.621-6.469,10.758-15.47,10.758-25.4V279.95
            c0-19.559-16.002-35.562-35.562-35.562H503.728c0,0-123.124-5.877-150.618,100.511v1538.053c0,141.652,86.068,134.48,86.068,134.48
            h1187.01c5.796-0.958,10.227-3.02,10.31-9.413C1636.657,1995.916,1626.188,1995.019,1626.188,1995.019z"
        />
        <path
          style={{ fill: "#C25857" }}
          d="M1626.188,1995.019h-10.758v-21.815H396.182c-23.277-31.62-20.606-86.279-20.606-86.279
            c2.391-90.251,128.152-76.891,128.152-76.891h1086.897c9.63,0,18.385-3.891,24.804-10.163c6.621-6.469,10.758-15.47,10.758-25.4
            V279.95c0-19.559-16.002-35.562-35.562-35.562H503.728c0,0-123.124-5.877-150.618,100.511v1538.053
            c0,141.652,86.068,134.48,86.068,134.48h1187.01c5.796-0.958,10.227-3.02,10.31-9.413
            C1636.657,1995.916,1626.188,1995.019,1626.188,1995.019z"
        />
        <g>
          <path
            style={{ fill: "#923A3B" }}
            d="M503.728,1793.299V244.388c0,0-123.124-5.877-150.618,100.511v1538.053
              C353.11,1882.952,353.11,1787.92,503.728,1793.299z"
          />
          <rect
            x="554.346"
            y="302.496"
            style={{ fill: "#923A3B" }}
            width="993.847"
            height="1440.683"
          />
        </g>
        <path
          style={{ fill: "#E99F34" }}
          d="M410.072,418.787c21.15-9.926,43.574-15.194,61.16-17.857c17.587-2.677,30.313-2.79,32.117-2.788
            l0.185,0h0.003l0.071,0.001h0.12v-30.482l-0.378-0.001c-5.263,0.048-45.842,0.377-89.679,16.607
            c-20.639,7.683-42.073,19.06-60.56,36.027v47.707c5.113-8.602,11.133-16.154,17.903-22.8
            C382.439,434.038,395.958,425.397,410.072,418.787z"
        />
        <path
          style={{ fill: "#E99F34" }}
          d="M417.503,501.745c21.207-12.383,43.137-18.938,59.654-22.291c8.254-1.68,15.145-2.569,19.884-3.032
            c2.37-0.232,4.201-0.357,5.397-0.424c0.592-0.033,1.021-0.05,1.289-0.061v-30.489h-0.141l-0.153,0.003
            c-1.232,0.077-40.669,0.766-84.665,21.263c-21.967,10.271-45.12,25.646-64.541,48.612c-0.382,0.451-0.738,0.953-1.117,1.411v59.154
            c6.527-16.181,14.899-29.628,24.393-40.883C389.515,520.804,403.35,510.001,417.503,501.745z"
        />
        <path
          style={{ fill: "#E99F34" }}
          d="M410.072,1612.746c21.151-9.926,43.574-15.194,61.16-17.856c17.587-2.678,30.313-2.791,32.117-2.788
            l0.165,0h0.001l0.071,0.001h0.14v-30.481l-0.378-0.002c-5.263,0.048-45.841,0.376-89.679,16.607
            c-20.638,7.683-42.072,19.06-60.56,36.027v47.707c5.113-8.602,11.135-16.154,17.905-22.8
            C382.439,1627.997,395.958,1619.356,410.072,1612.746z"
        />
        <path
          style={{ fill: "#E99F34" }}
          d="M417.503,1695.704c21.207-12.383,43.137-18.938,59.654-22.29c8.254-1.68,15.145-2.569,19.884-3.032
            c2.37-0.231,4.201-0.357,5.397-0.424c0.592-0.033,1.021-0.051,1.289-0.062v-30.489h-0.141l-0.153,0.003
            c-1.232,0.077-40.669,0.766-84.665,21.262c-21.967,10.271-45.12,25.646-64.541,48.612c-0.382,0.452-0.738,0.953-1.117,1.411v59.155
            c6.527-16.181,14.899-29.627,24.393-40.883C389.515,1714.763,403.35,1703.96,417.503,1695.704z"
        />
        <path
          style={{ fill: "#E26C6D" }}
          d="M1626.188,1995.019H435.591c-17.957-1.071-30.553-9.783-39.409-21.815
            c-23.277-31.62-20.606-86.279-20.606-86.279c2.391-90.251,128.152-76.891,128.152-76.891h1086.897
            c9.63,0,18.385-3.891,24.804-10.163c6.621-6.469,10.758-15.47,10.758-25.4v-16.735c0,19.559-16.002,35.562-35.562,35.562H503.728
            c-150.618-5.379-150.618,89.653-150.618,89.653c0,141.652,86.068,134.48,86.068,134.48h1187.01
            c5.796-0.958,10.227-3.02,10.31-9.413C1636.657,1995.916,1626.188,1995.019,1626.188,1995.019z"
        />
        <path
          style={{ fill: "#AAB8BC" }}
          d="M478.088,1887.605c88.317-27.438,184.301-35.53,276.259-39.571
            c99.612-4.377,199.347-1.14,298.956,1.63c98.871,2.749,197.189,2.198,296.047-0.447c49.405-1.321,99.651-3.01,148.82,2.842
            c38.865,4.625,78.013,12.994,117.259,13.467v-65.655c-6.419,6.271-15.175,10.163-24.804,10.163H503.728
            c0,0-125.761-13.36-128.152,76.891c0,0-1.038,21.265,3.828,44.939C410.188,1913.58,442.961,1898.519,478.088,1887.605z"
        />
       {lines.map((line, i) => (
        <text
          key={i}
          x={rect.x + rect.width / 2}
          y={
            rect.y +
            rect.height / 2 -
            ((lines.length - 1) / 2) * lineHeight +
            i * lineHeight
          }
          textAnchor="middle"
          dominantBaseline="middle"
          fontFamily='"Vazirmatn", "IRANSans", "Tahoma", Arial, sans-serif'
          fontSize={fontSize}
          fill="#fff"
          fontWeight="bold"
          style={{
            pointerEvents: "none",
            userSelect: "none",
            letterSpacing: "0.5px",
            textShadow: "0 2px 8px #2226",
          }}
        >
          {line}
        </text>
      ))}
       </g>
    </svg>
  );
};

const BookWithTitle = ({
  title,
  color,
  stroke,
  width = 90,
  height = 120,
}) => (
  <div style={{ position: "relative", width, height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <BookIconCartoon color={color} stroke={stroke} width={width} height={height} />
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: width,
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: "#fff",
        fontWeight: 700,
        fontSize: title.length > 19 ? "14px" : title.length > 14 ? "17px" : "20px",
        textAlign: "center",
        padding: "0 10px",
        lineHeight: 1.1,
        whiteSpace: "pre-line",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, Arial, sans-serif',
        pointerEvents: "none",
        // بهتر دیده شدن متن رو کم رنگ کن:
        textShadow: "0 2px 6px #2226",
      }}
    >
      {title}
    </div>
  </div>
);
const bookComponentMap = {
  "science2": <ScienceBook2 />,
  "history3": <HistoryBook3 />,
  "bio": <BioBook />,
  "math3": <MathBook3 />,
  "literature4": <LiteratureBook4 />
};
const FlowerPot = ({
  title = "",
  width = 200,
  height = 250,
  color = "#fff"
}) => {
return (
  <svg
 width={width}
      height={height}
      viewBox="0 0 1796 2506"
      // style={{ display: "block" }}
      xmlns="http://www.w3.org/2000/svg"
     
    >
  <g>
    <path style={{ fill:"#4EB055" }} d="M1369.226,952.51c33.009-44.176,61.928-93.249,71.117-147.625
      c-60.446,23.94-118.26,54.831-171.597,92.009c62.009-126.209,109.832-259.667,150.281-394.556
      c-33.449,30.406-66.422,61.525-98.484,93.539c20.821-62.774,34.057-127.459,29.822-193.086
      c-47.651,26.052-91.752,57.721-132.048,93.787c2.345-9.885,4.576-19.798,6.561-29.769c22.069-110.854,21.046-227.039-9.699-335.807
      c-43.6,95.914-99.471,186.288-145.634,280.794c-6.205-4.526-13.396-7.654-21.247-7.286c-2.091,0.098-4.102,0.493-6.004,1.14
      c-2.478-57.012-7.488-113.813-14.856-170.013c-39.857,75.003-64.057,164.49-79.754,259.274c-3.967,2.307-7.16,6.197-9.016,10.422
      c-20.044-96.989-46.842-192.691-78.684-286.478c-27.559,58.472-45.57,121.384-53.491,185.534c-1.039-3.044-2.006-6.113-3.07-9.149
      c-14.73-42.035-31.987-83.505-56.324-120.81c-27.46-42.091-63.718-78.319-105.388-106.413
      c-15.191,69.306-13.676,141.244-6.832,211.865c9.264,95.584,28.108,189.932,47.254,284.05c-1.687,0.684-3.167,1.732-4.43,3.049
      c-25.42-70.203-55.528-138.525-92.273-203.546c-36.881-65.264-84.029-130.049-153.308-158.684
      c3.717,54.384,7.46,108.962,18.416,162.361c36.998,180.327,152.188,332.775,238.271,495.49c1.347,2.546,2.639,5.12,3.972,7.673
      c-0.045,2.495,0.014,5,0.19,7.5c-3.553-3.867-7.281-7.578-11.298-10.874c-4.445-3.648-9.482-6.634-14.951-8.145
      c-36.667-43.513-79.543-81.306-128.982-109.38c-9.288-5.274-18.762-10.182-28.37-14.823c-0.001-0.002-0.002-0.004-0.003-0.006
      l-5.793-2.758c0.008,0.022,0.018,0.044,0.025,0.067c-26.596-12.491-54.12-23.102-81.583-33.629
      c-27.384,7.153-35.116,89.999-40.824,116.943c-7.551,35.641-12.595,71.773-16.364,107.995
      c-4.355,41.852-6.932,83.862-9.461,125.855c43.182-17.923,77.231-52.149,109.111-86.348c24.009-25.754,47.478-52.01,70.438-78.704
      c48.122,47.651,102.183,89.091,149.741,137.328c19.94,20.224,37.707,41.227,53.917,62.924
      c-17.515-16.076-37.22-30.322-59.51-41.649c-12.508-6.356-25.783-11.75-39.551-14.528c-27.632-5.575-55.262-0.103-77.62,10.596
      c-20.828,9.966-39.185,28.143-32.392,49.348c6.372,19.888,31.64,33.114,54.893,41.599c28.306,10.329,57.714,17.728,85.464,29.365
      c42.545,17.84,78.815,44.802,108.814,76.26h-8.86h-7.481c-14.343,0-26.08,11.736-26.08,26.079v37.891
      c0,11.636,7.774,21.439,18.349,24.769c0,18.595,0,44.201,0,79.384c0,183.028-161.708,279.122-161.708,573.256
      c0,53.712,14.407,104.046,39.564,147.368c3.354,5.776,6.9,11.428,10.627,16.946c7.456,11.037,15.641,21.54,24.487,31.442
      c24.325,27.229,53.644,49.905,86.514,66.596h0.001c0,33.194,71.457,36.02,132.942,36.02c61.485,0,132.942,1.412,132.942-36.02
      c95.624-48.554,161.192-147.766,161.192-262.352c0-273.71-161.707-355.694-161.707-573.255c0-35.022,0-60.224,0-78.368
      c0.641-0.079,1.299-0.094,1.925-0.219c0.646-0.128,1.245-0.367,1.874-0.542c0.94-0.263,1.888-0.503,2.782-0.868
      c0.823-0.332,1.58-0.771,2.359-1.183c0.611-0.326,1.237-0.617,1.818-0.99c0.911-0.578,1.74-1.248,2.571-1.93
      c0.354-0.294,0.722-0.564,1.061-0.876c0.924-0.845,1.755-1.766,2.551-2.734c0.164-0.203,0.338-0.394,0.496-0.601
      c0.856-1.105,1.602-2.276,2.274-3.511c0.052-0.096,0.105-0.19,0.156-0.287c0.703-1.33,1.28-2.715,1.747-4.167
      c0.006-0.019,0.012-0.04,0.019-0.06c0.792-2.485,1.337-5.079,1.337-7.817v-37.891c0-14.343-11.736-26.079-26.08-26.079h-5.654
      c0.092-0.135,0.176-0.274,0.268-0.409c42.927-63.18,108.391-121.792,191.989-145.788c28.923-8.302,58.996-12.202,88.318-19.14
      c24.088-5.699,50.733-15.871,59.392-34.875c9.233-20.261-6.864-40.465-26.38-52.805c-15.688-9.92-34.657-17.272-54.994-19.377
      c0.589-0.539,1.199-1.054,1.787-1.594C1307.055,1028.121,1339.961,991.676,1369.226,952.51z"/>
    <path style={{ fill:"#F6A654" }} d="M647.455,682.368c-0.186,0.434-0.387,0.867-0.516,1.304c-0.16,0.541-0.24,1.08-0.317,1.622
      c-0.032,0.226-0.071,0.451-0.09,0.678c-0.053,0.654-0.049,1.3,0.005,1.948c0.002,0.031,0.006,0.062,0.01,0.093
      c0.067,0.741,0.179,1.471,0.373,2.192c1.117,4.162,4.158,7.939,7.766,10.345c3.255,2.171,6.984,3.711,10.777,4.794l-0.824,0.219
      c-4.011,1.14-8.1,2.465-11.822,4.365c-3.453,1.762-6.539,4.325-8.029,7.986c-0.032,0.081-0.089,0.145-0.12,0.227
      c-0.065,0.173-0.065,0.352-0.121,0.526c-0.161,0.501-0.271,1.008-0.348,1.517c-0.245,1.597-0.082,3.185,0.41,4.71
      c0.407,1.261,0.965,2.482,1.804,3.56c0.99,1.271,2.171,2.175,3.427,2.898c3.465,1.996,7.702,2.103,11.637,0.934
      c1.872-0.556,3.672-1.374,5.269-2.4c1.18-0.758,2.299-1.622,3.383-2.535c-0.506,1.891-0.932,3.799-1.203,5.717
      c-0.553,3.924-0.23,8.025,2.041,11.388c1.482,2.195,3.719,3.564,6.197,4.152c1.054,0.25,2.137,0.4,3.246,0.345
      c0.937-0.047,1.809-0.219,2.646-0.454c6.455-1.82,9.941-8.88,10.207-15.367c0.117-2.851-0.206-5.74-0.777-8.575
      c0.885,1.219,1.805,2.419,2.768,3.577c0.936,1.128,1.914,2.217,2.947,3.239c2.817,2.786,6.3,4.976,10.355,5.162
      c0.951,0.043,1.876-0.052,2.765-0.265c2.635-0.63,4.931-2.314,6.481-4.626c4.549-6.787,0.681-15.14-5.017-19.757
      c-0.986-0.799-2.101-1.431-3.189-2.098c-0.578-0.355-1.102-0.783-1.702-1.106c-1.683-0.904-3.438-1.69-5.215-2.388
      c-0.639-0.251-1.249-0.587-1.893-0.811c0.011-0.002,0.021-0.005,0.032-0.007c1.697-0.323,3.404-0.703,5.099-1.122
      c0.058-0.014,0.113-0.038,0.17-0.053c2.152-0.538,4.283-1.148,6.323-1.96c3.542-1.411,6.788-3.639,8.629-7.048
      c0.072-0.134,0.177-0.239,0.245-0.376c1.42-2.884,1.234-6.119-0.069-8.962c-0.226-0.494-0.416-1.003-0.713-1.468
      c-4.4-6.886-13.603-6.684-20.113-3.309c-1.65,0.855-3.207,1.905-4.711,3.034c0.308-0.896,0.548-1.807,0.808-2.714
      c0.15-0.524,0.341-1.04,0.467-1.567c0.914-3.856,0.972-7.969-0.978-11.529c-0.368-0.67-0.843-1.239-1.333-1.79
      c-1.054-1.184-2.362-2.053-3.819-2.649c-0.622-0.255-1.253-0.462-1.919-0.603c-0.214-0.489-0.901-0.612-1.334-0.216
      c-0.197-0.018-0.383-0.085-0.581-0.094c-1.431-0.062-2.731,0.195-3.969,0.579c-5.825,1.809-9.488,7.989-10.294,13.983
      c-0.315,2.341-0.35,4.739-0.181,7.127c-1.617-1.759-3.312-3.447-5.139-4.947c-3.063-2.514-6.734-4.371-10.788-4.182
      c-3.736,0.175-6.908,2.422-8.695,5.644c-0.016,0.029-0.041,0.051-0.057,0.081C647.678,681.681,647.602,682.026,647.455,682.368z"/>
    <path style={{ fill:"#FCC570" }} d="M711.452,692.589c-2.51,0.636-5.007,1.253-7.548,1.749l-0.101-0.364
      c2.375-0.92,4.773-1.718,7.194-2.505c1.161-0.378,2.32-0.765,3.484-1.133c0.426-0.134,0.859-0.247,1.289-0.364
      c0.025-1.08-0.197-2.167-0.768-3.227c-0.077-0.142-0.22-0.213-0.305-0.347c-0.063,0.038-0.101,0.072-0.167,0.112
      c-0.949,0.575-1.901,1.144-2.856,1.709c-1.91,1.13-3.83,2.242-5.761,3.335c-3.807,2.156-7.617,4.105-11.666,5.762l-0.258-0.612
      c3.609-2.363,7.298-4.516,11.029-6.679c1.8-1.043,3.59-2.103,5.372-3.179c0.95-0.573,1.897-1.152,2.841-1.734
      c0.08-0.049,0.144-0.084,0.221-0.133c-0.829-0.735-1.772-1.319-2.846-1.702l-1.042,0.69c-1.087,0.728-2.166,1.467-3.238,2.218
      c-2.169,1.519-4.359,2.997-6.566,4.461l-0.279-0.362c1.947-1.83,3.959-3.544,6.094-5.151c1.044-0.786,2.097-1.56,3.157-2.324
      c-1.545-0.296-3.128-0.423-4.564-0.309c-4.124,0.329-7.978,1.718-11.364,3.951c0.82-4.245,1.473-10.41,0.466-14.896
      c-1.465,3.464-2.833,6.969-4.225,10.462l-0.767-0.212c0.267-1.328,0.521-2.666,0.934-3.956c0.385-1.203,0.793-2.399,1.222-3.588
      c0.616-1.704,1.375-3.353,2.112-5.009c-0.833-1.856-2.169-3.099-4.157-3.344c-1.075,3.987-1.455,8.157-1.976,12.238
      c-0.605,4.742-1.073,9.712-2.531,14.275l-0.371-0.049c-0.262-4.987,0.611-10.123,1.254-15.062c0.493-3.78,0.868-7.637,1.814-11.343
      c-0.357,0.054-0.701,0.087-1.091,0.194c-1.141,0.313-2.151,0.86-3.04,1.569c-0.007,1.898-0.011,3.796-0.047,5.696
      c-0.025,1.326-0.025,2.656-0.076,3.982c-0.054,1.38-0.249,2.766-0.382,4.141c-0.054,0.566-0.824,0.565-0.879,0
      c-0.133-1.375-0.325-2.761-0.381-4.141c-0.054-1.326-0.051-2.656-0.077-3.982c-0.023-1.24-0.018-2.478-0.03-3.716
      c-1.57,2.065-2.589,4.652-3.111,7.034c-0.929,4.24-0.554,8.693,0.294,12.979c-1.668-1.606-3.581-2.903-5.672-3.972
      c0.644,0.552,1.281,1.098,1.886,1.713l-0.635,0.823c-0.553-0.277-1.127-0.532-1.664-0.838l-1.463-0.965
      c-0.974-0.65-1.945-1.298-2.897-1.98c-0.384-0.275-0.767-0.551-1.151-0.826c-1.244-0.083-2.395,0.208-3.223,1.198
      c0.076,0.055,0.152,0.111,0.227,0.166c1.373,1.007,2.702,2.074,4.038,3.131c2.722,2.155,5.375,4.389,8.006,6.655l-0.559,0.724
      c-2.867-1.963-5.752-3.899-8.622-5.857c-1.338-0.913-2.682-1.815-4.009-2.742c-0.158,0.517-0.344,1.038-0.407,1.545
      c0.914,0.487,1.852,0.933,2.742,1.462c2.076,1.234,4.098,2.624,5.396,4.708l-0.263,0.203c-1.826-1.717-4.091-2.554-6.347-3.526
      c-0.499-0.214-0.989-0.45-1.486-0.669c0.671,5.471,6.207,10.065,11.059,12.908c-4.922,1.863-11.776,4.864-13.517,9.412
      c0.475-0.343,0.946-0.691,1.424-1.028c0.901-0.636,1.793-1.235,2.759-1.768l1.378-0.624c0.533-0.17,1.034-0.451,1.539-0.691
      l0.355,0.46l-1.246,1.167l-1.085,1.064c-0.825,0.701-1.68,1.337-2.55,1.98c-0.863,0.638-1.721,1.285-2.57,1.943l-0.361,0.249
      c0.032,0.342-0.024,0.661,0.068,1.017c0.031,0.119,0.123,0.167,0.16,0.279c0.608-0.377,1.201-0.779,1.806-1.159
      c1.392-0.874,2.782-1.749,4.172-2.625c0.669-0.422,1.323-0.889,2.037-1.228c0.835-0.395,1.737-0.574,2.586-0.961l0.482,0.625
      c-0.678,0.596-1.207,1.295-1.862,1.899c-0.562,0.517-1.244,0.903-1.88,1.323c-1.42,0.937-2.84,1.873-4.261,2.808
      c-0.636,0.418-1.273,0.839-1.908,1.261c0.946,0.852,2.248,1.203,3.612,1.35c0.422-0.503,0.847-1.004,1.261-1.514
      c0.621-0.764,1.313-1.442,1.992-2.152c0.65-0.681,1.33-1.337,2.004-1.996l0.174,0.102c-0.369,0.895-0.754,1.792-1.195,2.654
      c-0.437,0.855-0.852,1.701-1.398,2.496c-0.11,0.16-0.227,0.316-0.337,0.476c0.266-0.016,0.546-0.004,0.802-0.028
      c2.406-0.235,4.696-0.963,6.813-2.042c-1.662,4.172-2.946,8.407-2.301,13.058c0.191,1.38,0.664,3.098,1.409,4.724
      c0.211-0.693,0.412-1.389,0.627-2.081c1.003-3.234,2.072-6.43,3.359-9.562l0.566,0.156c-0.49,3.352-1.2,6.647-1.986,9.941
      c-0.327,1.373-0.664,2.742-1.017,4.109c0.917,1.192,2.03,2.129,3.366,2.525c0.115-0.823,0.249-1.646,0.355-2.443
      c0.252-1.881,0.499-3.767,0.841-5.633c0.707-3.853,1.287-7.744,2.298-11.523l0.494,0.067c-0.314,3.893-0.902,7.769-1.167,11.675
      c-0.133,1.956-0.322,3.909-0.459,5.865c-0.048,0.686-0.075,1.389-0.107,2.089c0.912-0.149,1.752-0.477,2.494-1.015
      c0.005-0.167,0.002-0.345,0.005-0.507c0.025-1.523,0.194-3.039,0.357-4.553c0.329-3.07,0.836-6.182,1.808-9.115l0.329,0.045
      c0.173,3.071,0.052,6.171-0.033,9.245c-0.021,0.759-0.047,1.518-0.062,2.276c1.3-1.957,2.196-4.302,2.763-6.102
      c1.111-3.52,1.62-7.136,1.622-10.764c1.357,1.848,2.935,3.537,4.791,4.987c2.667,2.083,6.349,4.156,9.647,3.101
      c-0.183-0.2-0.365-0.401-0.549-0.602c-0.984-1.08-2.004-2.139-2.937-3.265c-1.929-2.327-3.857-4.655-5.786-6.982l0.355-0.356
      c2.229,2.088,4.458,4.176,6.687,6.264c1.128,1.056,2.175,2.207,3.251,3.315l0.712,0.733c0.123-0.091,0.253-0.139,0.374-0.242
      c0.385-0.328,0.69-0.695,0.975-1.069c-2.308-2.192-4.545-4.472-6.807-6.707c-2.596-2.565-5.123-5.175-7.618-7.839l0.237-0.238
      c2.87,2.281,5.688,4.6,8.467,6.99c2.254,1.938,4.535,3.862,6.764,5.834c0.364-1.075,0.483-2.227,0.427-3.403
      c-0.095-0.078-0.192-0.153-0.286-0.231c-1.032-0.836-2.073-1.663-3.121-2.478c-1.077-0.837-2.202-1.623-3.244-2.503
      c-1.006-0.849-2.017-1.692-3.038-2.524l0.33-0.428c1.198,0.661,2.393,1.33,3.576,2.019c1.143,0.667,2.222,1.472,3.309,2.227
      c0.721,0.502,1.434,1.015,2.149,1.526c-0.285-1.291-0.701-2.548-1.187-3.669c-1.642-3.785-4.239-6.775-7.382-9.272
      c4.187-1.679,8.187-4.037,11.362-7.207c1.898-1.895,3.933-4.506,4.575-7.266c-0.141,0.042-0.282,0.09-0.424,0.128
      C713.916,691.992,712.679,692.278,711.452,692.589z"/>
    <path style={{ fill:"#F6A654" }} d="M1227.745,888.885c-0.226-0.494-0.416-1.003-0.713-1.468c-4.399-6.885-13.603-6.683-20.113-3.309
      c-1.65,0.855-3.207,1.906-4.711,3.035c0.308-0.897,0.548-1.808,0.808-2.714c0.15-0.523,0.341-1.039,0.467-1.567
      c0.914-3.856,0.972-7.969-0.978-11.529c-0.367-0.67-0.843-1.239-1.333-1.79c-1.054-1.184-2.362-2.053-3.819-2.649
      c-0.622-0.255-1.253-0.463-1.919-0.604c-0.214-0.489-0.901-0.612-1.334-0.215c-0.197-0.019-0.383-0.085-0.581-0.094
      c-1.43-0.062-2.731,0.195-3.969,0.579c-5.825,1.809-9.488,7.99-10.295,13.983c-0.315,2.342-0.349,4.74-0.181,7.128
      c-1.617-1.759-3.312-3.447-5.139-4.947c-3.063-2.513-6.734-4.371-10.788-4.181c-3.77,0.176-6.976,2.456-8.753,5.726
      c-3.902,7.179,0.723,15.139,6.824,19.207c3.255,2.171,6.984,3.711,10.777,4.795l-0.824,0.219c-4.011,1.14-8.1,2.465-11.822,4.365
      c-3.53,1.801-6.7,4.422-8.149,8.214c-1.347,3.526-0.542,7.376,1.744,10.313c0.99,1.272,2.171,2.176,3.427,2.899
      c3.465,1.996,7.702,2.103,11.637,0.934c1.872-0.556,3.672-1.373,5.269-2.399c1.181-0.759,2.299-1.623,3.384-2.535
      c-0.506,1.89-0.932,3.799-1.203,5.716c-0.553,3.924-0.23,8.025,2.041,11.388c2.112,3.128,5.726,4.681,9.443,4.497
      c8.161-0.403,12.553-8.493,12.854-15.82c0.117-2.851-0.206-5.74-0.777-8.575c1.748,2.406,3.62,4.744,5.714,6.816
      c2.817,2.787,6.3,4.976,10.355,5.162c3.77,0.173,7.173-1.799,9.245-4.891c4.549-6.787,0.681-15.14-5.017-19.756
      c-2.982-2.416-6.503-4.177-10.106-5.593c-0.639-0.251-1.249-0.587-1.893-0.811c1.708-0.325,3.425-0.707,5.13-1.129
      c2.211-0.548,4.399-1.179,6.493-2.013c3.542-1.411,6.788-3.639,8.629-7.048c0.072-0.134,0.177-0.238,0.245-0.375
      C1229.235,894.963,1229.049,891.727,1227.745,888.885z"/>
    <path style={{ fill:"#76B7DF" }} d="M1019.455,1503.336c0-35.022,0-60.224,0-78.368c0.642-0.079,1.301-0.094,1.927-0.219
      c0.639-0.127,1.235-0.363,1.856-0.537c0.947-0.265,1.899-0.506,2.799-0.874c0.817-0.333,1.578-0.767,2.352-1.18
      c0.612-0.327,1.24-0.619,1.822-0.992c0.905-0.58,1.747-1.245,2.571-1.93c0.354-0.294,0.722-0.564,1.061-0.876
      c0.915-0.846,1.762-1.764,2.55-2.732c0.165-0.203,0.339-0.396,0.498-0.604c0.845-1.105,1.609-2.276,2.273-3.509
      c0.052-0.097,0.106-0.19,0.157-0.288c0.693-1.328,1.285-2.718,1.746-4.167c0.006-0.019,0.012-0.04,0.019-0.06
      c0.792-2.485,1.337-5.079,1.337-7.817v-37.891c0-14.343-11.736-26.079-26.08-26.079h-5.653h-3.313h-10.765h-25.981h-11.593h-9.586
      h-13.878h-28.518h-15.75h-24.995h-26.955h-1.529h-8.605h-4.31h-14.019h-32.22h-8.86h-7.481c-5.379,0-10.391,1.651-14.555,4.47
      c-2.776,1.88-5.175,4.279-7.055,7.055c-0.94,1.389-1.75,2.87-2.412,4.429c-1.324,3.117-2.057,6.54-2.057,10.126v37.891
      c0,3.586,0.733,7.009,2.057,10.126c1.324,3.118,3.239,5.93,5.603,8.293c1.182,1.182,2.476,2.251,3.863,3.191
      c2.069,1.4,4.396,2.395,6.824,3.16c0,18.595,0,44.201,0,79.384c0,183.028-161.708,279.122-161.708,573.256
      c0,53.712,14.407,104.046,39.564,147.368c3.354,5.776,6.9,11.428,10.627,16.946c7.456,11.037,15.641,21.54,24.487,31.442
      c24.325,27.229,53.644,49.905,86.515,66.596l0,0c0,33.194,71.457,36.02,132.942,36.02c61.485,0,132.942,1.412,132.942-36.02
      c95.624-48.554,161.193-147.766,161.193-262.352C1181.163,1802.88,1019.455,1720.896,1019.455,1503.336z"/>
    <path style={{ fill:"#AED8F2" }} d="M1016.344,1335.21h-5.653h-3.313h-10.765h-25.981h-11.593h-9.586h-13.878h-28.518h-15.75h-24.995
      h-26.955h-1.529h-8.605h-4.31h-14.019h-32.22h-8.86h-7.481c-5.379,0-10.391,1.651-14.555,4.47c-2.776,1.88-5.175,4.279-7.055,7.055
      c-0.94,1.389-1.75,2.87-2.412,4.429c-1.324,3.117-2.057,6.54-2.057,10.126v37.891c0,3.586,0.733,7.009,2.057,10.126
      c1.324,3.118,3.239,5.93,5.603,8.293c1.182,1.182,2.476,2.251,3.863,3.191c2.069,1.4,4.396,2.395,6.824,3.16
      c2.46,0.775,5.024,1.311,7.731,1.311h90.438h64.635h2.156h96.783c1.063,0,2.081-0.168,3.111-0.293
      c0.642-0.079,1.301-0.094,1.927-0.219c0.639-0.127,1.235-0.363,1.856-0.537c0.947-0.265,1.899-0.506,2.799-0.874
      c0.817-0.333,1.578-0.767,2.352-1.18c0.612-0.327,1.24-0.619,1.822-0.992c0.905-0.58,1.747-1.245,2.571-1.93
      c0.354-0.294,0.722-0.564,1.061-0.876c0.915-0.846,1.762-1.764,2.55-2.732c0.165-0.203,0.339-0.396,0.498-0.604
      c0.845-1.105,1.609-2.276,2.273-3.509c0.052-0.097,0.106-0.19,0.157-0.288c0.693-1.328,1.285-2.718,1.746-4.167
      c0.006-0.019,0.012-0.04,0.019-0.06c0.792-2.485,1.337-5.079,1.337-7.817v-37.891
      C1042.424,1346.946,1030.688,1335.21,1016.344,1335.21z"/>
    <path style={{ fill:"none" }} d="M1044.056,459.319c-0.059-0.04-0.117-0.086-0.176-0.126c0.041,2.737,0.045,5.474,0.074,8.211
      c0.929-2.158,1.84-4.325,2.783-6.478C1045.843,460.389,1044.92,459.895,1044.056,459.319z"/>
    <path style={{ fill:"#197944" }} d="M920.645,535.397h1.013c-0.509-0.304-0.967-0.688-1.468-1.007c-0.108,0.348-0.216,0.695-0.324,1.043
      C920.124,535.427,920.387,535.401,920.645,535.397z"/>
    <path style={{ fill:"#197944" }} d="M848.297,1197.297c-0.407-0.209-0.785-0.47-1.175-0.713c-2.1,25.017-4.111,50.024-5.895,75.013
      c-1.519,21.274-2.51,42.433-1.871,63.613h26.955c-9.505-28.414-11.06-64.093-14.002-89.646
      C850.465,1229.526,849.155,1213.421,848.297,1197.297z"/>
    <path style={{ fill:"#197944" }} d="M1067.746,469.858c-7.331-2.095-14.508-5.027-21.01-8.933c-0.943,2.153-1.854,4.32-2.783,6.478
      c0.038,3.545,0.067,7.089,0.085,10.634c7.047-3.17,14.518-5.601,21.897-7.698C1066.534,470.17,1067.145,470.025,1067.746,469.858z"
      />
    <path style={{ fill:"#3A944B" }} d="M972.064,631.529c1.6,5.389,3.221,10.771,4.865,16.146c0.74,2.422,1.317,4.902,2.208,7.213
      l-4.051,45.019c-0.883-2.833-1.749-5.672-2.684-8.488c-3.148-9.478-6.542-18.885-9.996-28.255c-1.239-3.361-2.531-6.674-3.823-9.99
      c6.741,22.258,12.284,44.805,16.706,67.598c1.829,9.428,3.475,18.895,4.948,28.397c0.11-1.202,0.221-2.405,0.331-3.607
      c0.526-2.25,0.864-4.621,1.807-6.714c2.145-4.761,5.153-9.126,7.855-13.577c5.728-9.434,11.245-18.999,16.593-28.654
      c10.629-19.188,21.07-38.592,27.351-59.688c0.384-1.29-1.406-1.951-2.104-0.886c-12.875,19.64-22.926,40.933-34.541,61.327
      c-4.8,8.429-9.83,16.713-14.837,25.016l2.313-25.245c0.941-10.271,1.918-20.542,2.881-30.813l0.464-0.291
      c2.681-3.159,2.875-7.547,4.011-11.448c1.304-4.478,2.91-8.88,4.775-13.154c3.643-8.349,8.108-16.316,12.757-24.139
      c9.314-15.671,18.316-30.907,24.1-48.257c0.33-0.99-1.189-1.626-1.683-0.71c-8.823,16.353-20.32,31.326-29.927,47.235
      c-4.328,7.166-8.374,14.512-11.821,22.146c2.521-26.628,5.048-53.259,7.512-79.894c2.431-6.464,4.385-13.145,7.031-19.569
      c3.617-8.777,7.856-17.287,12.137-25.755c1.131-2.238,2.268-4.472,3.402-6.707c3.146-6.203,6.232-12.423,8.982-18.771
      c3.475-8.022,6.407-16.251,8.15-24.937c0.306-1.524-1.965-2.754-2.693-1.135c-7.674,17.068-16.412,33.664-25.033,50.272
      c-3.34,6.437-6.526,12.95-9.516,19.554c2.266-25.123,4.46-50.25,6.456-75.389c0.603-0.097,1.184-0.381,1.663-0.896
      c2.327-2.499,3.166-5.734,4.364-8.89c1.354-3.568,2.692-7.143,4.013-10.724c2.735-7.417,5.42-14.856,7.988-22.333
      c5.107-14.868,9.307-29.555,11.649-45.105l-0.674-0.284c-6.717,13.689-11.983,27.663-17.271,41.96
      c-2.652,7.169-5.257,14.351-7.984,21.491c-0.731,1.914-1.479,3.82-2.22,5.73c1.555-20.017,3.108-40.034,4.668-60.051
      c1.877-24.077,4.609-48.708,3.088-72.819l-0.705-0.096c-9.514,38.156-10.933,79.176-14.883,118.323
      c-0.467-5.545-0.864-11.097-1.429-16.633c-1.946-19.053-4.047-38.273-9.487-56.67c-0.259-0.877-1.655-0.738-1.628,0.22
      c0.549,19.634,3.531,39.114,5.337,58.672c0.889,9.63,1.63,19.274,2.22,28.927c0.421,6.889-0.035,14.297,1.51,21.1
      c-2.169,22.31-4.191,44.635-6.232,66.957c-0.291-1.018-0.582-2.031-0.863-3.032c-2.685-9.546-5.904-18.9-9.235-28.234
      c-6.656-18.648-11.705-37.398-16.505-56.583c-0.237-0.947-1.563-0.678-1.628,0.22c-1.385,19.144,5.452,38.242,11.204,56.22
      c2.8,8.751,5.743,17.468,8.37,26.273c4.055,1.57,7.422,4.512,8.889,9.106c1.344,4.212,0.665,8.834-2.281,12.213
      c-0.322,0.37-0.717,0.632-1.067,0.96c0.364,1.373,0.714,2.75,1.14,4.097c-0.18,2-0.378,3.999-0.558,5.999l-7.583,84.286
      c-0.626-2.055-1.265-4.106-1.886-6.163c-3.131-10.38-6.183-20.784-9.155-31.211c-1.296-4.546-2.591-9.094-3.892-13.64
      c-1.427,0.091-2.87,0.022-4.298-0.427c-1.178-0.371-2.267-0.889-3.283-1.512c1.511,5.832,3.077,11.649,4.703,17.445
      C965.971,610.719,968.978,621.136,972.064,631.529z"/>
    <path style={{ fill:"#3A944B" }} d="M1020.429,722.226c0.324-0.858-0.95-1.571-1.539-0.896c-11.785,13.501-20.972,29.129-30.158,44.471
      c-1.677,2.802-3.326,5.621-4.965,8.446c0.563,4.556,1.016,9.133,1.507,13.702c3.419-6.377,7.01-12.661,10.692-18.889
      C1004.927,753.899,1014.192,738.739,1020.429,722.226z"/>
    <path style={{ fill:"#3A944B" }} d="M528.679,977.856c-15.819-16.029-30.984-33.057-44.769-51.05c-2.315-3.021-4.598-6.065-6.831-9.141
      c-26.185-36.08-46.472-75.927-55.064-119.439c-27.384,7.153-35.116,89.999-40.824,116.944
      c-7.551,35.641-12.595,71.773-16.364,107.995c-4.355,41.852-6.932,83.862-9.461,125.855
      c43.182-17.923,77.231-52.149,109.111-86.348c24.009-25.755,47.478-52.01,70.439-78.705
      C532.848,981.92,530.725,979.928,528.679,977.856z"/>
    <path style={{ fill:"#3A944B" }} d="M708.219,797.86c-0.848-0.242-1.673-0.572-2.5-0.89c-0.187,0.608-0.369,1.217-0.55,1.825
      c0.842-0.273,1.683-0.556,2.524-0.795L708.219,797.86z"/>
    <path style={{ fill:"#3A944B" }} d="M687.663,1071.436c-1.241,1.045-2.507,2.055-3.799,3.025c0.853,0.695,1.707,1.39,2.561,2.085
      C686.81,1074.837,687.21,1073.131,687.663,1071.436z"/>
    <path style={{ fill:"#3A944B" }} d="M501.747,836.68c-3.776-1.374-7.549-2.758-11.317-4.151c-14.997-5.548-29.901-11.87-45.492-15.544
      c-1.104-0.26-1.788,1.251-0.78,1.851c10,5.964,20.789,10.359,31.576,14.692c5.504,2.211,11.034,4.358,16.562,6.504
      c2.765,1.073,5.532,2.141,8.301,3.202c1.186,0.456,2.373,0.909,3.56,1.362c0.686,0.262,2.027,0.546,2.891,1.002
      c0.545,0.899,1.377,1.262,2.3,1.202c2.373,5.834,4.858,11.624,7.478,17.357c-10.322-2.088-20.55-4.575-30.698-7.4
      c-11.421-3.18-22.575-7.206-33.97-10.466c-1.888-0.541-3.106,2.236-1.349,3.198c20.866,11.417,44.99,17.5,68.233,21.827
      l1.107-0.015c2.584,5.402,5.241,10.771,8.029,16.078c0.15,1.026,0.345,2.029,0.66,2.954c0.398,1.169,1.228,1.863,2.163,2.203
      c2.014,3.725,3.995,7.467,6.101,11.144c-10.544-2.109-21.027-4.573-31.326-7.654c-11.857-3.547-23.365-8.346-35.345-11.402
      c-1.911-0.487-2.91,2.057-1.313,3.114c10.342,6.845,22.408,11.016,34.154,14.823c12.054,3.906,24.304,7.028,36.76,9.354
      c0.666,0.124,1.261,0.055,1.808-0.105c5.568,9.335,11.394,18.518,17.474,27.517c-2.389-0.279-4.779-0.558-7.167-0.842
      c-5.469-0.649-10.933-1.35-16.397-2.041c-11.028-1.397-21.899-3.734-32.885-5.4c-1.61-0.245-2.92,1.971-1.206,2.861
      c10.031,5.209,20.934,7.366,31.997,9.236c5.361,0.905,10.748,1.579,16.146,2.211c2.756,0.322,5.514,0.633,8.27,0.945
      c2.026,0.23,4.315,0.835,6.361,0.536c4.226,6.061,8.523,12.064,12.94,17.96c-2.421-0.177-4.865-0.233-7.15-0.42
      c-4.453-0.363-8.905-0.726-13.358-1.088c-9.149-0.745-18.075-1.18-27.249-0.87c-1.952,0.066-2.528,3.072-0.477,3.527
      c10.444,2.317,20.833,3.525,31.467,4.628c5.365,0.556,10.727,1.141,16.096,1.638c1.566,0.145,4.268,0.552,6.462,0.268
      c5.036,6.515,10.222,12.911,15.516,19.217c-5.496-0.749-10.998-1.462-16.526-1.906c-3.639-0.292-7.293-0.268-10.939-0.127
      c-3.448,0.134-6.898,0.984-10.355,0.513c-2.155-0.293-2.987,2.478-0.906,3.286c3.025,1.173,6.35,1.63,9.574,1.865
      c3.659,0.267,7.295,0.631,10.946,0.979c7.265,0.693,14.469,1.742,21.679,2.857c0.89,0.138,1.779,0.019,2.533-0.339
      c8.008,9.239,16.293,18.236,24.858,26.962c-4.329-0.974-8.66-1.935-13.004-2.839c-4.363-0.909-8.78-1.552-13.196-2.144
      c-4.563-0.611-8.799-0.724-13.395-0.421c-1.609,0.106-2.06,2.432-0.392,2.894c8.341,2.307,16.792,4.098,25.267,5.894
      c7.943,1.684,15.784,3.265,23.335,6.238l1.212,0.018c0.866,0.841,1.729,1.684,2.584,2.536c2.378-1.841,4.963-3.45,7.657-4.824
      c0.043-0.022,0.088-0.039,0.131-0.061c-5.315-4.965-10.589-9.976-15.721-15.13c-0.357-1.627-0.96-3.241-1.449-4.872
      c-1.18-3.945-2.306-7.906-3.378-11.882c-2.144-7.951-4.071-15.961-5.779-24.018c-3.388-15.987-7.286-32.043-9.943-48.153
      c-0.152-0.924-1.664-0.704-1.628,0.22c0.652,16.499,1.678,32.576,5.085,48.807c1.692,8.06,3.603,16.074,5.732,24.03
      c0.515,1.923,1.083,3.831,1.622,5.748c-10.677-11.251-20.892-22.936-30.658-34.983l-0.19-0.435
      c-1.558-3.607-2.846-7.317-3.934-11.091c-2.126-7.375-3.399-14.922-4.723-22.47c-2.819-16.081-5.172-32.217-8.242-48.248
      c-0.207-1.084-1.907-0.815-1.899,0.257c0.12,16.682,1.863,33.115,4.19,49.632c0.857,6.075,2.067,12.123,3.565,18.086
      c-8.911-11.71-17.342-23.782-25.349-36.135l-0.002-0.248c-0.819-4.47-2.1-8.849-2.883-13.337
      c-0.822-4.714-1.481-9.432-1.834-14.206c-0.335-4.552-0.315-9.08-0.339-13.638c-0.025-4.727-0.411-9.386-0.494-14.098
      c-0.022-1.261-1.792-1.481-2.171-0.294c-0.731,2.293-1.733,4.568-2.258,6.916c-0.501,2.24-0.709,4.666-0.936,6.952
      c-0.482,4.856-0.393,9.816-0.164,14.686c0.169,3.572,0.47,7.278,0.89,10.986c-0.606-1.007-1.243-1.995-1.844-3.006
      c-3.221-5.43-6.35-10.924-9.404-16.466c-0.204-2.191-0.624-4.417-0.748-6.568c-0.179-3.114-0.127-6.218-0.101-9.334
      c0.025-3.11,0.211-6.189,0.466-9.287c0.256-3.122-0.145-6.396,0.419-9.464c0.331-1.797-2.157-2.516-2.753-0.759
      c-1.084,3.199-2.804,6.083-3.544,9.427c-0.708,3.19-1.131,6.477-1.47,9.724c-0.056,0.53-0.047,1.07-0.083,1.603
      c-6.424-12.339-12.545-24.855-18.419-37.47c-0.001-0.002-0.002-0.003-0.002-0.006l-5.794-2.758
      c0.008,0.022,0.018,0.044,0.026,0.066c0.737,2.053,1.577,4.068,2.349,6.108C504.451,837.515,502.956,837.119,501.747,836.68z"/>
    <path style={{ fill:"#3A944B" }} d="M936.185,1333.405c-0.201,0.599-0.406,1.202-0.61,1.805h13.878
      c0.029-18.854,0.901-37.698,2.429-56.491C947.363,1297.177,942.207,1315.438,936.185,1333.405z"/>
    <path style={{ fill:"#3A944B" }} d="M1175.817,717.419c0.099,0.034,0.196,0.079,0.294,0.113c0.084-0.073,0.164-0.151,0.248-0.223
      C1176.178,717.344,1175.997,717.385,1175.817,717.419z"/>
    <path style={{ fill:"#3A944B" }} d="M1350.365,402.791c-47.652,26.052-91.753,57.721-132.048,93.787
      c-37.707,33.748-72.052,71.368-102.83,111.876c-3.036,3.995-6.032,8.022-8.998,12.073c-15.917,21.74-30.852,44.241-44.714,67.404
      c-2.882,4.816-5.727,9.653-8.518,14.523c-10.814,18.867-20.91,38.148-30.342,57.733c-4.543,9.433-8.921,18.941-13.136,28.515
      c-0.418-0.371-1.017-0.458-1.479,0.123c-4.087,5.138-8.456,10.073-12.01,15.607c-2.774,4.319-5.555,8.635-8.322,12.96
      c0.319,4.252,0.688,8.496,0.953,12.756c0.792-1.324,1.602-2.637,2.392-3.962c3.224-5.414,6.326-10.906,9.473-16.366
      c-2.963,7.21-5.87,14.441-8.647,21.714c-0.969,2.537-1.816,5.117-2.763,7.662c3.59,67.324,0.723,135.521-4.658,202.922
      c-1.173,14.702-2.428,29.376-3.793,43.982c-1.812,19.379-3.776,38.802-6.033,58.193c1.485-5.72,3.021-11.427,4.625-17.116
      c21.968-77.938,54.885-152.891,95.506-222.758c2.158-3.711,4.431-7.345,6.63-11.03c2.232-3.741,4.458-7.487,6.732-11.201
      c25.849-42.22,54.318-82.671,84.817-121.622c-0.515-0.459-1.066-0.876-1.556-1.361c-3.381-3.344-6.404-7.119-9.224-11.002
      c0.922,4.577,1.443,9.24,1.254,13.841c-0.486,11.826-7.575,24.884-20.746,25.535c-6,0.295-11.833-2.21-15.242-7.259
      c-0.292-0.431-0.443-0.913-0.696-1.359c-2.924-5.163-3.421-11.193-2.599-17.021c0.436-3.095,1.126-6.177,1.941-9.228
      c-1.75,1.472-3.555,2.868-5.461,4.092c-1.074,0.69-2.227,1.297-3.4,1.868c-9.69,4.724-22.193,5.103-29.418-4.182
      c-3.689-4.74-4.989-10.955-2.815-16.645c2.338-6.12,7.457-10.349,13.153-13.256c6.009-3.067,12.608-5.205,19.081-7.045l1.33-0.354
      c-6.122-1.749-12.14-4.235-17.395-7.739c-9.847-6.567-17.311-19.414-11.014-31.001c2.868-5.278,8.042-8.956,14.128-9.241
      c6.544-0.306,12.468,2.692,17.412,6.748c2.15,1.765,4.159,3.721,6.116,5.735c0.728,0.75,1.472,1.48,2.179,2.25
      c-0.272-3.854-0.216-7.725,0.293-11.504c0.616-4.579,2.282-9.227,4.831-13.188c3.981-6.187,10.158-10.665,18.19-10.316
      c0.321,0.014,0.62,0.122,0.938,0.151c0.7-0.639,1.808-0.441,2.154,0.348c4.764,1.008,9.002,3.737,11.413,8.138
      c3.148,5.747,3.054,12.386,1.579,18.608c-0.552,2.327-1.274,4.627-2.057,6.91c2.161-1.622,4.409-3.108,6.751-4.397
      c0.288-0.159,0.561-0.35,0.853-0.501c5.793-3.002,12.879-4.351,19.286-3.183c5.216,0.951,9.992,3.537,13.178,8.524
      c1.377,2.155,2.187,4.554,2.583,7c0.533,3.298,0.225,6.696-1.32,9.834c-0.302,0.613-0.739,1.11-1.095,1.677
      c-3.028,4.826-7.819,8.115-13.083,10.236c-0.05,0.021-0.097,0.049-0.147,0.07c-5.816,2.317-12.061,3.776-18.219,4.961
      c-0.084,0.073-0.163,0.15-0.248,0.223c2.824,0.993,5.61,2.177,8.324,3.51c3.821,1.875,7.484,4.066,10.749,6.712
      c0.885,0.717,1.712,1.535,2.533,2.356c14.464-17.52,29.31-34.743,44.497-51.689c5.206-5.809,10.427-11.605,15.709-17.35
      c20.38-22.168,41.283-43.89,62.619-65.193C1341.363,533.103,1354.599,468.418,1350.365,402.791z"/>
    <path style={{ fill:"#197944" }} d="M806.491,404.39c6.996,20.501,13.415,41.193,19.27,62.049c1.596,5.687,3.221,11.367,4.732,17.078
      c7.826,29.578,14.476,59.464,19.981,89.56c1.018,5.565,1.947,11.144,2.884,16.723c2.781,16.543,5.307,33.129,7.378,49.776
      c1.957,15.735,3.501,31.486,4.85,47.246c0.546,6.372,1.014,12.748,1.468,19.124c1.754,24.666,2.84,49.359,3.358,74.072
      c0.113,5.409,0.307,10.814,0.368,16.225c0.403,35.587-0.359,71.216-1.82,106.866c-1.535,37.45-3.877,74.923-6.679,112.405
      c3.575-17.502,7.642-34.894,12.037-52.212c9.847-38.803,21.302-77.241,32.431-115.744c1.72-5.949,3.425-11.901,5.122-17.854
      c2.156-7.569,4.292-15.144,6.384-22.727c0.409-7.433,0.809-14.866,1.237-22.295c0.245-4.243,0.456-8.49,0.706-12.732
      c0.361-6.102,0.644-12.215,1.017-18.316c1.189-19.444,2.506-39.007,3.943-58.596c0.467-6.357,0.951-12.71,1.451-19.072
      c2.004-25.492,4.327-50.982,7.03-76.354c0.385-3.616,0.762-7.234,1.164-10.844c-0.792,0.4-1.605,0.755-2.459,1.007
      c-2.114,0.622-4.401,0.767-6.821,0.251c-4.324-0.923-7.999-3.807-9.471-8.042c-1.582-4.555-0.704-9.362,1.128-13.697
      c0.895-2.119,1.967-4.18,3.124-6.197c-1.523,0.717-3.071,1.368-4.657,1.879c-1.656,0.533-3.419,0.842-5.2,1.011
      c-2.703,0.258-5.453,0.116-8.005-0.607c-4.188-1.187-7.815-3.805-9.703-8.248c-1.728-4.069-1.48-8.735,1.142-12.372
      c2.819-3.912,7.259-5.954,11.86-6.946c2.251-0.485,4.561-0.775,6.879-0.987c2.419-0.221,4.841-0.333,7.246-0.385
      c0.108-0.348,0.216-0.695,0.324-1.043c-1.902-1.214-3.712-2.542-5.427-4.001c-1.407-1.197-2.807-2.41-4.018-3.782
      c-5.764-6.531-8.647-17.08-1.979-24.132c3.037-3.213,7.413-4.852,11.795-3.906c4.713,1.018,8.361,4.27,11.111,8.09
      c1.64,2.279,3.073,4.734,4.393,7.246c0.534-2.794,1.305-5.536,2.381-8.129c0.063-0.15,0.154-0.292,0.22-0.442
      c-20.044-96.989-46.842-192.691-78.684-286.478C832.424,277.328,814.412,340.24,806.491,404.39z"/>
    <path style={{ fill:"#197944" }} d="M1218.316,496.579c2.345-9.885,4.577-19.798,6.561-29.769
      c22.069-110.854,21.046-227.039-9.699-335.807c-43.6,95.914-99.471,186.288-145.633,280.794c0.839,0.612,1.664,1.246,2.467,1.905
      c4.016,3.296,7.744,7.008,11.297,10.874c-0.371-5.25-0.293-10.522,0.399-15.668c2.15-15.977,13.409-32.79,31.353-32.011
      c0.393,0.017,0.775,0.084,1.165,0.119c0.441-0.426,1.037-0.562,1.61-0.49c0.628,0.078,1.193,0.41,1.466,0.95
      c1.928,0.408,3.783,1.033,5.534,1.872c4.137,1.982,7.673,5.102,9.98,9.312c4.287,7.826,4.16,16.868,2.151,25.343
      c-0.751,3.17-1.736,6.301-2.803,9.41c3.307-2.482,6.73-4.79,10.357-6.67c2.574-1.334,5.344-2.433,8.206-3.266
      c4.792-1.394,9.841-1.999,14.719-1.612c3.896,0.309,7.665,1.272,11.1,2.988c2.007,1.003,3.897,2.255,5.622,3.803
      c1.689,1.516,3.236,3.277,4.567,5.361c4.405,6.894,5.385,15.484,1.719,22.928c-3.943,8.005-11.417,13.094-19.508,16.318
      c-7.114,2.834-14.697,4.71-22.243,6.237c-1.103,0.223-2.208,0.461-3.307,0.67c0.804,0.279,1.594,0.624,2.395,0.922
      c6.709,2.5,13.259,5.676,19.188,9.687c1.638,1.108,3.267,2.229,4.795,3.467c0.151,0.123,0.295,0.261,0.445,0.386
      c12.275,10.219,20.462,28.304,10.583,43.043c-4.556,6.795-12.036,11.13-20.323,10.75c-1.815-0.084-3.563-0.391-5.271-0.813
      c-2.093-0.518-4.105-1.261-6.033-2.2c-4.23-2.059-8.07-4.984-11.458-8.335c-2.185-2.161-4.245-4.47-6.232-6.848
      c-2.202-2.634-4.311-5.357-6.33-8.136c0.87,4.32,1.451,8.696,1.657,13.061c0.091,1.934,0.13,3.866,0.051,5.791
      c-0.573,13.94-7.893,29.113-21.478,33.525c-2.112,0.686-4.363,1.133-6.777,1.252c-3.946,0.194-7.83-0.521-11.324-2.066
      c-3.741-1.655-7.034-4.265-9.435-7.82c-4.993-7.395-5.703-16.409-4.487-25.034c0.595-4.215,1.534-8.411,2.645-12.567
      c-2.383,2.005-4.842,3.906-7.438,5.573c-5.53,3.552-12.147,6.009-18.793,6.75c-1.379,0.154-2.756,0.248-4.128,0.246
      c-1.377-0.003-2.741-0.1-4.091-0.272c-0.832,34.931-2.653,69.836-5.565,104.626c-0.62,7.403-1.422,14.84-2.154,22.265
      c-2.554,25.94-5.723,51.977-9.375,78.035c-1.156,8.247-2.306,16.487-3.544,24.729c9.432-19.585,19.528-38.865,30.342-57.733
      c2.791-4.87,5.636-9.707,8.518-14.523c13.862-23.163,28.797-45.664,44.714-67.404c2.966-4.051,5.962-8.078,8.998-12.073
      C1146.264,567.946,1180.61,530.327,1218.316,496.579z"/>
    <path style={{ fill:"#3A944B" }} d="M1324.279,1082.194c-15.688-9.92-34.658-17.273-54.994-19.377
      c-6.82-0.705-13.793-0.824-20.848-0.248c-13.999,1.145-27.816,4.944-40.982,9.79c-15.552,5.723-30.11,12.876-43.797,21.071
      c-4.997,2.992-9.885,6.11-14.644,9.377c-28.034,41.362-57.244,81.931-85.494,123.144c-10.851,15.831-21.538,31.776-31.989,47.875
      c-6.688,10.304-13.3,20.657-19.73,31.124c-5.063,8.242-10.022,19.028-15.187,30.261h10.765h3.313
      c0.091-0.135,0.176-0.274,0.268-0.409c42.927-63.18,108.391-121.792,191.989-145.788c28.923-8.302,58.997-12.202,88.318-19.14
      c24.088-5.699,50.733-15.871,59.392-34.875C1359.892,1114.739,1343.794,1094.534,1324.279,1082.194z"/>
    <path style={{ fill:"#3A944B" }} d="M809.829,1167.85l0.824-0.219c-0.564-0.161-1.102-0.41-1.661-0.592
      c0.014,0.354,0.022,0.709,0.037,1.063C809.295,1168.025,809.562,1167.926,809.829,1167.85z"/>
    <path style={{ fill:"#3A944B" }} d="M847.263,1168.326c-0.004-0.278-0.006-0.556-0.01-0.833c-0.427,0.086-0.853,0.2-1.278,0.281
      C846.413,1167.926,846.827,1168.161,847.263,1168.326z"/>
    <path style={{ fill:"#3A944B" }} d="M870.782,796.241c-0.061-5.41-0.255-10.816-0.368-16.225c-0.519-24.713-1.604-49.406-3.358-74.072
      c-0.453-6.376-0.922-12.752-1.468-19.124c-1.35-15.759-2.893-31.51-4.85-47.246c-2.071-16.647-4.598-33.233-7.378-49.776
      c-0.938-5.579-1.867-11.158-2.884-16.723c-5.505-30.097-12.155-59.982-19.981-89.56c-1.511-5.71-3.136-11.391-4.732-17.078
      c-5.855-20.856-12.274-41.548-19.27-62.049c-1.039-3.044-2.006-6.113-3.069-9.149c-14.731-42.035-31.988-83.505-56.325-120.81
      c-27.46-42.091-63.718-78.319-105.388-106.413c-15.191,69.306-13.676,141.244-6.832,211.865
      c9.264,95.583,28.108,189.932,47.254,284.05c1.484-0.601,3.096-0.963,4.883-0.885c0.199,0.009,0.384,0.075,0.581,0.094
      c0.433-0.396,1.12-0.273,1.335,0.216c2.951,0.625,5.577,2.315,7.071,5.042c1.95,3.56,1.892,7.674,0.978,11.529
      c-0.342,1.442-0.789,2.867-1.275,4.281c1.504-1.129,3.061-2.179,4.711-3.035c6.511-3.374,15.714-3.576,20.114,3.309
      c2.003,3.137,2.449,7.044,0.782,10.429c-1.794,3.642-5.194,5.957-8.875,7.424c-0.678,0.27-1.401,0.439-2.096,0.674
      c-1.159,0.393-2.305,0.813-3.494,1.125c-0.252,0.067-0.508,0.106-0.76,0.169c-0.058,0.015-0.112,0.039-0.17,0.053
      c-1.694,0.42-3.401,0.799-5.099,1.122c2.432,0.846,4.8,1.946,7.076,3.206c0.6,0.322,1.124,0.751,1.702,1.106
      c1.086,0.682,2.228,1.289,3.217,2.09c5.699,4.616,9.566,12.969,5.017,19.756c-1.555,2.321-3.861,4.009-6.508,4.635
      c-0.888,0.213-1.814,0.308-2.765,0.265c-4.055-0.187-7.537-2.376-10.355-5.162c-1.033-1.022-2.01-2.11-2.947-3.239
      c3.487,17.092,6.987,34.182,10.492,51.271c1.341,0.479,2.595,1.221,3.711,2.136c1.167,0.958,2.25,2.036,3.282,3.16
      c-0.107-1.525-0.085-3.057,0.116-4.553c0.625-4.642,3.896-9.527,9.11-9.301c0.127,0.005,0.245,0.048,0.371,0.06
      c0.277-0.253,0.715-0.175,0.852,0.137c1.885,0.399,3.562,1.479,4.516,3.221c1.246,2.274,1.209,4.901,0.625,7.364
      c-0.219,0.921-0.505,1.831-0.815,2.734c0.961-0.721,1.956-1.391,3.009-1.938c4.159-2.155,10.036-2.284,12.846,2.114
      c1.279,2.003,1.564,4.499,0.5,6.662c-1.146,2.326-3.318,3.805-5.669,4.741c-2.369,0.944-4.919,1.531-7.424,2.007
      c2.73,0.948,5.422,2.273,7.664,4.09c3.639,2.948,6.11,8.284,3.204,12.618c-1.324,1.975-3.497,3.234-5.906,3.124
      c-2.59-0.119-4.814-1.518-6.613-3.297c-1.338-1.323-2.534-2.816-3.65-4.354c0.365,1.811,0.571,3.656,0.496,5.478
      c-0.193,4.68-2.998,9.847-8.21,10.105c-0.906,0.044-1.785-0.123-2.623-0.396c0.225,1.088,0.443,2.177,0.668,3.265
      c2.326,11.243,4.689,22.477,7.032,33.716c-2.688,9.965-4.224,20.411-5.988,30.408c-1.178,6.674-2.175,13.399-2.648,20.163
      c-0.091,1.307-0.205,2.729-0.308,4.167c-3.808-10.508-7.68-20.993-11.659-31.439c0.417-1.662,0.396-3.473,0.447-5.316
      c0.123-4.489,0.092-8.981,0.223-13.472c0.252-8.664,0.823-17.304,1.579-25.938c0.776-8.86,1.823-17.652,2.959-26.47
      c-1.944,0.898-4.144,1.313-6.211,1.058c-1.361,8.095-2.435,16.285-3.197,24.453c-0.833,8.934-1.241,17.927-1.414,26.896
      c-0.026,1.35-0.04,2.704-0.06,4.057c-6.637-17.086-13.481-34.094-20.396-51.073c0.226-1.704,0.072-3.534,0.121-5.467
      c0.127-4.963,0.349-9.924,0.663-14.879c0.605-9.548,1.471-19.094,2.676-28.585c0.949-7.471,2.151-14.922,3.426-22.364
      c-0.837,0.236-1.71,0.408-2.646,0.454c-1.109,0.054-2.193-0.095-3.246-0.345c-1.47,7.054-2.762,14.164-3.762,21.412
      c-1.3,9.422-2.289,18.87-2.836,28.366c-0.136,2.346-0.18,4.697-0.273,7.045c-6.1-14.854-12.228-29.698-18.391-44.519
      c-2.53-6.086-5.06-12.172-7.59-18.257c0.522-5.826,0.297-11.868,0.296-17.761c-0.491-1.525-0.655-3.113-0.41-4.71
      c0.07-0.509,0.19-1.014,0.348-1.517c0.056-0.174,0.055-0.354,0.121-0.526c0.031-0.082,0.088-0.146,0.12-0.227
      c0.428-9.256,1.148-18.496,2.132-27.71c-0.194-0.721-0.306-1.452-0.373-2.192c-0.004-0.031-0.007-0.062-0.01-0.093
      c-0.054-0.648-0.058-1.294-0.005-1.948c0.017-0.226,0.059-0.451,0.09-0.678c0.077-0.542,0.157-1.081,0.317-1.622
      c0.126-0.437,0.331-0.87,0.516-1.304c0.147-0.342,0.223-0.687,0.407-1.026c0.016-0.03,0.041-0.052,0.057-0.081
      c2.193-18.797,4.783-37.735,8.247-56.285c0.162-0.866-1.058-1.224-1.332-0.367c-6.391,20.047-11.196,39.948-13.585,60.929
      c-1.187,10.428-2.02,20.896-2.494,31.38c-0.157,3.473-0.437,7.127-0.644,10.821c-7.079-17.028-14.16-34.056-21.237-51.085
      c0.226-3.196-0.342-6.529-0.403-9.717c-0.091-4.828,0.062-9.661,0.391-14.477c0.667-9.761,2.108-19.443,3.856-29.064
      c3.341-18.376,8.056-36.691,8.745-55.412c0.047-1.264-1.828-1.474-2.171-0.293c-5.528,19.056-9.977,38.594-13.386,58.15
      c-1.595,9.152-2.884,18.378-3.494,27.653c-0.15,2.287-0.251,4.577-0.312,6.868c-4.856-11.681-9.704-23.364-14.567-35.042
      c-0.134-2.564-0.479-5.143-0.64-7.685c-0.296-4.699-0.498-9.403-0.602-14.111c-0.235-10.589,0.028-21.185,0.753-31.752
      c1.466-21.372,5.59-42.367,8.625-63.537c0.134-0.935-1.07-1.287-1.42-0.392c-7.837,20.001-11.026,41.431-12.772,62.755
      c-0.896,10.948-1.255,21.942-1.087,32.926c0.022,1.472,0.007,3.043-0.016,4.647c-6.603-15.823-13.168-31.663-19.813-47.468
      c0.115-7.276-1.036-14.931-1.19-21.947c-0.226-10.315-0.146-20.625,0.043-30.94c0.377-20.581,1.731-41.12,2.127-61.689
      c0.011-0.563-0.868-0.698-0.995-0.134c-4.502,19.964-6.283,40.193-7.127,60.634c-0.425,10.301-0.45,20.631-0.298,30.939
      c0.026,1.751,0.004,3.583-0.026,5.441c-6.356-15.043-12.747-30.129-19.299-45.22c0.304-7.369-1.924-14.754-3.081-22.032
      c-1.495-9.398-2.917-18.797-3.88-28.267c-0.924-9.07-1.511-18.163-1.828-27.273c-0.318-9.095-0.062-18.536-1.679-27.507
      c-0.134-0.743-1.235-0.658-1.42,0c-2.468,8.772-2.544,18.448-2.508,27.507c0.039,9.448,0.483,18.902,1.235,28.319
      c0.701,8.79,1.642,17.589,3.032,26.3c-7.781-17.421-15.745-34.781-24.162-51.901c-0.495-5.414-2.355-10.93-3.43-16.154
      c-1.249-6.079-2.393-12.192-3.405-18.315c-1.042-6.311-1.867-12.644-2.585-18.999c-0.349-3.088-0.662-6.257-1.218-9.314
      c-0.588-3.228-1.788-6.304-2.363-9.519c-0.186-1.04-1.631-0.677-1.718,0.232c-0.321,3.361-1.212,6.628-1.364,10.025
      c-0.148,3.307,0.098,6.711,0.368,10.005c0.521,6.34,1.224,12.662,2.079,18.965c0.403,2.972,0.857,5.932,1.349,8.886
      c-11.788-22.539-24.305-44.621-38.089-65.789c-0.76-1.166-2.481-0.153-1.86,1.087c13.623,27.181,26.961,54.384,40.052,81.693
      c-1.036-0.802-2.076-1.601-3.09-2.418c-5.268-4.245-10.546-8.477-15.835-12.696c-5.012-3.997-10.124-7.847-15.256-11.688
      c-2.532-1.894-5.025-3.866-7.645-5.636c-3.009-2.033-6.086-3.495-9.315-5.124l-0.558,0.723c2.069,2.467,3.957,4.892,6.281,7.129
      c2.425,2.336,5.036,4.469,7.594,6.658c4.975,4.259,9.939,8.521,15.004,12.674c4.917,4.031,9.824,8.074,14.722,12.13
      c4.539,3.758,8.962,8.15,14.202,10.913c9.963,20.983,19.646,42.114,29.167,63.343c-9.943-7.793-20.265-15.062-31.099-21.571
      c-13.212-7.939-26.951-15.575-41.875-19.647c-1.074-0.293-1.664,1.185-0.745,1.767c11.699,7.402,24.117,13.558,35.863,20.914
      c11.9,7.452,23.38,15.66,34.24,24.561c1.768,1.449,5.972,6.322,9.533,7.387c3.958,8.957,8.002,17.858,11.862,26.882
      c2.655,6.208,5.275,12.431,7.903,18.651c-10.082-6.346-21.712-10.942-32.304-15.492c-15.694-6.74-31.522-15.016-48.052-19.26
      c-1.392-0.357-2.127,1.505-0.958,2.273c14.073,9.244,30.59,15.291,45.912,22.287c7.112,3.247,14.234,6.509,21.164,10.133
      c6.705,3.506,12.797,7.787,19.193,11.754c0.262,0.621,0.525,1.24,0.787,1.859c0.249,1.281,0.548,2.533,0.924,3.74
      c0.203,0.654,0.69,1.094,1.257,1.406c6.146,14.56,12.199,29.16,18.291,43.742c-12.133-5.033-24.578-9.138-37.209-12.863
      c-15.654-4.617-31.571-8.974-47.734-11.329c-1.679-0.245-2.359,1.978-0.71,2.575c14.83,5.369,30.265,8.927,45.328,13.591
      c15.04,4.657,29.776,10.351,44.065,16.969c7.201,17.264,14.381,34.536,21.565,51.808c-1.32-0.651-2.632-1.289-3.848-1.947
      c-3.794-2.053-7.603-4.081-11.414-6.102c-8.169-4.329-16.367-8.606-24.591-12.829c-15.997-8.214-32.044-16.597-48.846-22.977
      c-1.059-0.402-1.635,1.205-0.745,1.768c15.323,9.675,31.609,17.867,47.52,26.582c7.831,4.29,15.637,8.628,23.414,13.016
      c3.755,2.118,7.501,4.252,11.249,6.384c3.546,2.017,7.308,4.888,11.327,5.871c6.332,15.226,12.67,30.449,19.01,45.67
      c-3.207-2.021-6.542-3.85-9.603-5.55c-6.905-3.834-14.092-7.13-21.404-10.109c-7.338-2.99-14.83-5.585-22.375-8
      c-7.495-2.4-15.519-5.461-23.442-5.827c-1.409-0.065-1.825,1.891-0.697,2.574c6.221,3.767,13.772,5.586,20.608,7.916
      c7.617,2.597,15.18,5.37,22.6,8.491c7.126,2.997,14.111,6.353,20.823,10.193c6.439,3.683,12.166,8.582,18.496,12.341l0.225,0.539
      c6.722,16.127,13.465,32.251,20.166,48.394c-8.058-6.299-17.117-11.187-26.489-15.469c-12.851-5.87-25.88-11.639-39.255-16.078
      l-0.538,0.923c2.476,2.003,4.747,3.979,7.505,5.584c2.986,1.738,6.115,3.195,9.235,4.674c6.419,3.042,12.895,5.966,19.263,9.113
      c12.452,6.156,24.534,13.317,34.228,23.403l1.413,0.83c5.013,12.141,9.989,24.298,14.899,36.481
      c-1.329-0.961-2.631-1.841-3.699-2.629c-5.101-3.765-10.543-7.086-16.119-10.096c-5.751-3.105-11.59-6.055-17.415-9.018
      c-6.279-3.193-12.677-5.731-19.239-8.219c-0.942-0.357-1.341,1.006-0.639,1.515c5.594,4.054,11.122,7.952,17.141,11.388
      c5.516,3.149,11.076,6.223,16.538,9.466c5.009,2.973,9.983,6.01,14.676,9.468c2.448,1.803,4.801,3.74,7.036,5.802
      c2.103,1.941,3.566,3.637,6.356,4.037c4.309,10.811,8.535,21.655,12.71,32.517c-2.154-1.644-4.345-3.239-6.579-4.773
      c-4.464-3.065-9.07-5.888-13.866-8.405c-9.551-5.013-19.39-9.193-29.979-11.347c-1.386-0.282-2.486,1.766-1.029,2.44
      c9.462,4.378,19.043,8.692,28.007,14.042c4.377,2.612,8.684,5.374,12.847,8.316c2.17,1.534,4.306,3.117,6.389,4.767
      c2.136,1.692,4.052,3.611,6.576,4.675l1.387,0.107c2.824,7.45,5.579,14.925,8.318,22.406c-5.079-3.154-10.232-6.198-15.515-8.982
      c-7.847-4.135-15.792-7.909-24.005-11.259c-1.776-0.724-2.842,2.097-1.277,3.03c13.491,8.044,26.96,16.189,40.02,24.92
      c1.131,0.756,2.855,2.106,4.621,2.914l0.184,0.522c-3.853-0.603-7.702-1.249-11.531-1.944c-2.904-0.527-5.798-1.115-8.678-1.762
      c-3.003-0.675-6.048-1.024-9.073-1.604c-1.619-0.31-2.92,2.055-1.206,2.861c2.821,1.328,5.584,2.774,8.539,3.774
      c2.899,0.98,5.819,1.897,8.757,2.751c4.169,1.211,8.383,2.112,12.627,2.909c2.92-1.913,6.203-3.253,9.815-3.86
      c-0.016-0.036-0.022-0.078-0.039-0.113c0.026-2.32-0.168-4.647-0.203-6.981c-0.053-3.503,0.089-7.007,0.366-10.498
      c0.579-7.31,1.806-14.546,3.201-21.739c0.947-4.881,2.168-9.851,3.21-14.861c2.007,9.595,4.009,19.191,6.032,28.783
      c-2.656,5.805-4.908,11.735-6.449,18.106c-0.557,2.303-1.02,4.625-1.471,6.95c0.287,0.003,0.562-0.027,0.852-0.014
      c0.393,0.017,0.776,0.084,1.165,0.118c0.925-0.892,2.555-0.572,3.075,0.46c0.618,0.131,1.239,0.249,1.842,0.425
      c0.368-2.228,0.641-4.47,1.096-6.686c0.65-3.166,1.314-6.36,1.977-9.549c1.397,6.606,2.811,13.208,4.216,19.811
      c2.574,1.868,4.779,4.259,6.382,7.185c4.288,7.826,4.16,16.868,2.151,25.342c-0.262,1.104-0.582,2.197-0.893,3.292
      c0.297,1.38,0.606,2.758,0.904,4.138c2.439-1.708,4.925-3.333,7.543-4.69c8.584-4.448,19.285-6.354,28.572-3.929
      c2.98,0.778,5.807,2.007,8.375,3.745c0.684,0.463,1.344,0.968,1.988,1.504c0.985,0.82,1.924,1.719,2.802,2.717
      c0.878,0.997,1.719,2.053,2.476,3.237c1.278,2,2.228,4.152,2.9,6.369c1.643,5.423,1.42,11.275-1.181,16.558
      c-1.08,2.192-2.466,4.124-4.015,5.901c-4.109,4.711-9.618,8.077-15.493,10.418c-7.481,2.981-15.482,4.906-23.412,6.474
      c0.101,0.458,0.199,0.916,0.3,1.373c8.547,3.189,16.894,7.428,23.939,13.136c12.526,10.147,21.027,28.51,11.028,43.429
      c-4.473,6.672-11.77,10.945-19.877,10.74c1.148,5.041,2.256,10.092,3.413,15.131c5.345,23.286,10.785,46.551,16.333,69.791
      c1.574-1.781,3.533-3.227,5.679-4.323c1.194-0.609,2.467-1.078,3.721-1.582c-0.102-2.323-0.207-4.645-0.298-6.956
      c-0.507-0.298-1.066-0.515-1.554-0.841c-6.1-4.068-10.725-12.028-6.824-19.207c1.578-2.904,4.314-4.935,7.539-5.498
      c0.407-0.071,0.792-0.209,1.214-0.228c0.638-0.03,1.248,0.072,1.867,0.139c2.254,0.241,4.382,1.018,6.317,2.2
      c0.907,0.553,1.78,1.168,2.604,1.842c1.827,1.5,3.523,3.188,5.139,4.947c-0.169-2.388-0.134-4.786,0.182-7.128
      c0.978-7.268,6.1-14.917,14.263-14.562c0.199,0.009,0.384,0.076,0.581,0.094c0.433-0.396,1.12-0.273,1.334,0.216
      c2.951,0.625,5.577,2.315,7.071,5.042c1.95,3.56,1.892,7.674,0.978,11.529c-0.342,1.442-0.789,2.867-1.275,4.281
      c1.504-1.129,3.061-2.179,4.711-3.035c0.588-0.305,1.218-0.551,1.844-0.801c0.392-17.467,1.389-34.906,3.161-52.259
      c2.578-25.261,6.652-50.189,11.7-74.897c2.802-37.482,5.144-74.955,6.679-112.405C870.422,867.457,871.184,831.829,870.782,796.241
      z"/>
    <path style={{ fill:"#3A944B" }} d="M815.27,1287.119c-1.907-8.615-3.544-17.312-4.973-26.052c-8.869-28.67-16.926-57.631-24.272-86.999
      c-1.584-6.332-3.142-12.673-4.701-19.011c-5.297-21.528-10.518-43.078-15.861-64.595c-2.934-0.884-5.702-2.221-8.295-3.878
      c2.508,9.947,4.991,19.902,7.447,29.865c2.942,11.931,5.871,23.867,8.807,35.802c-1.305-2.627-2.639-5.232-4.073-7.734
      c-2.173-3.793-4.758-7.418-7.55-10.927c-1.631-3.628-3.83-7.051-5.912-10.422c-3.747-6.063-7.154-12.301-10.054-18.815
      c-2.804-6.297-5.334-12.665-7.386-19.244c-0.262,4.161-1.122,8.395-2.561,12.412c0.932,2.694,1.866,5.39,2.979,8.005
      c1.064,2.501,2.297,4.929,3.525,7.358c-0.194-0.19-0.392-0.385-0.586-0.575c-2.895-2.832-5.94-5.496-8.921-8.234
      c-0.828,1.443-1.752,2.812-2.759,4.109c-1.581,2.035-3.362,3.881-5.379,5.429c2.42,0.426,4.827,0.947,7.215,1.596
      c7.094,6.655,13.945,13.564,20.291,20.937c5.71,6.632,11.27,13.124,16.411,19.872c-0.608-0.309-1.186-0.677-1.802-0.971
      c-4.803-2.291-9.802-4.115-14.964-5.41c-4.924-1.235-10.113-2.189-15.199-2.356c-5.227-0.171-10.26,0.795-15.343,1.86
      c-0.774,0.163-0.581,1.353,0.184,1.357c5.018,0.027,10.014,0.848,14.978,1.528c4.723,0.648,9.358,1.49,13.935,2.853
      c4.609,1.373,9.112,3.14,13.41,5.298c2.193,1.1,4.334,2.302,6.415,3.601c1.859,1.161,3.507,2.558,5.722,2.7
      c0.481,0.754,1.014,1.467,1.48,2.233c7.925,32.168,16.133,64.64,25.679,96.667c-17.208-28.984-38.414-57.139-64.585-81.158
      c-17.515-16.076-37.22-30.322-59.51-41.649c-12.507-6.356-25.783-11.75-39.551-14.528c-27.632-5.575-55.262-0.103-77.62,10.596
      c-20.828,9.966-39.185,28.143-32.391,49.348c6.372,19.888,31.639,33.114,54.893,41.599c28.306,10.328,57.715,17.728,85.464,29.365
      c42.545,17.841,78.815,44.802,108.815,76.26h32.22h14.019h4.31C823.455,1319.629,818.9,1303.517,815.27,1287.119z"/>
    <path style={{ fill:"#197944" }} d="M808.991,1167.04c-2.641-0.858-5.185-1.97-7.562-3.363c0.091,2.311,0.196,4.634,0.298,6.956
      c2.398-0.963,4.838-1.815,7.301-2.53C809.013,1167.749,809.005,1167.394,808.991,1167.04z"/>
    <path style={{ fill:"#3A944B" }} d="M847.123,1196.584c-1.338-0.834-2.602-1.805-3.732-2.922c-2.095-2.072-3.967-4.41-5.714-6.817
      c0.57,2.835,0.893,5.725,0.777,8.576c-0.301,7.327-4.693,15.417-12.854,15.82c-3.717,0.183-7.331-1.369-9.444-4.497
      c-2.271-3.364-2.594-7.465-2.041-11.388c0.271-1.917,0.698-3.826,1.203-5.717c-1.084,0.912-2.202,1.777-3.383,2.536
      c-0.474,0.304-0.992,0.555-1.498,0.823c-2.273,1.203-4.805,2.001-7.364,2.239c-2.195,0.204-4.371-0.016-6.378-0.78
      c0.123,0.512,0.25,1.022,0.374,1.534c3.192,13.217,6.392,26.432,9.66,39.631c1.007,8.503,2.185,16.993,3.568,25.445
      c1.429,8.74,3.067,17.436,4.973,26.052c3.63,16.399,8.186,32.511,13.953,48.092h8.605h1.529
      c-0.639-21.181,0.351-42.34,1.871-63.613C843.012,1246.608,845.023,1221.601,847.123,1196.584z"/>
    <path style={{ fill:"#F6A654" }} d="M743.872,791.203c1.064-2.162,0.78-4.658-0.5-6.662c-2.81-4.398-8.688-4.269-12.846-2.114
      c-1.054,0.546-2.049,1.217-3.009,1.938c0.31-0.904,0.596-1.813,0.815-2.734c0.583-2.462,0.621-5.09-0.625-7.364
      c-0.954-1.742-2.631-2.822-4.516-3.221c-0.137-0.312-0.575-0.39-0.852-0.137c-0.126-0.012-0.244-0.055-0.371-0.06
      c-5.214-0.226-8.486,4.659-9.11,9.301c-0.201,1.496-0.223,3.028-0.116,4.553c-1.032-1.123-2.115-2.202-3.282-3.16
      c-1.116-0.916-2.37-1.658-3.711-2.136c-1.011-0.36-2.066-0.586-3.179-0.534c-2.408,0.113-4.456,1.568-5.591,3.657
      c-2.492,4.585,0.462,9.669,4.358,12.268c1.351,0.901,2.848,1.581,4.384,2.172c0.827,0.318,1.652,0.648,2.5,0.89l-0.526,0.14
      c-0.841,0.239-1.682,0.522-2.524,0.795c-1.722,0.559-3.43,1.178-5.027,1.993c-2.254,1.15-4.279,2.824-5.205,5.246
      c-0.86,2.252-0.345,4.711,1.114,6.587c1.365,1.753,3.216,2.599,5.186,2.842c2.067,0.255,4.267-0.16,6.211-1.058
      c0.555-0.256,1.088-0.546,1.59-0.869c0.754-0.484,1.468-1.037,2.161-1.619c-0.322,1.208-0.595,2.426-0.768,3.652
      c-0.354,2.505-0.147,5.125,1.304,7.273c0.834,1.235,2.053,2.035,3.409,2.477c0.838,0.273,1.716,0.44,2.623,0.396
      c5.212-0.258,8.017-5.425,8.21-10.105c0.075-1.821-0.131-3.667-0.496-5.478c1.116,1.537,2.311,3.031,3.65,4.354
      c1.799,1.78,4.024,3.179,6.613,3.297c2.408,0.11,4.582-1.149,5.906-3.124c2.906-4.335,0.435-9.67-3.204-12.618
      c-2.242-1.816-4.934-3.141-7.664-4.09c2.505-0.477,5.055-1.063,7.424-2.007C740.554,795.008,742.726,793.529,743.872,791.203z"/>
    <path style={{ fill:"#FCC570" }} d="M737.592,789.713c-1.603,0.407-3.197,0.801-4.821,1.117l-0.064-0.232
      c1.516-0.588,3.048-1.097,4.595-1.6c0.741-0.241,1.481-0.489,2.225-0.724l0.823-0.232c0.016-0.69-0.125-1.384-0.491-2.062
      c-0.049-0.09-0.14-0.136-0.194-0.222c-0.04,0.024-0.064,0.046-0.107,0.072c-0.607,0.367-1.215,0.731-1.824,1.091
      c-1.22,0.722-2.446,1.432-3.68,2.131c-2.431,1.377-4.865,2.621-7.451,3.68l-0.165-0.391c2.305-1.509,4.661-2.884,7.045-4.266
      c1.15-0.667,2.293-1.343,3.431-2.03c0.607-0.367,1.212-0.735,1.815-1.107c0.051-0.031,0.093-0.054,0.141-0.085
      c-0.53-0.47-1.132-0.843-1.818-1.088l-0.666,0.441c-0.694,0.465-1.383,0.938-2.068,1.417c-1.386,0.971-2.784,1.914-4.195,2.849
      l-0.178-0.23c1.243-1.169,2.529-2.264,3.892-3.29c0.667-0.502,1.339-0.996,2.016-1.485c-0.987-0.188-1.997-0.27-2.915-0.197
      c-2.634,0.21-5.095,1.097-7.258,2.523c0.522-2.706,0.918-6.61,0.28-9.474c-0.928,2.2-1.798,4.425-2.681,6.642l-0.49-0.135
      c0.171-0.847,0.333-1.703,0.597-2.527c0.246-0.768,0.506-1.532,0.78-2.291c0.394-1.088,0.878-2.141,1.349-3.199
      c-0.523-1.165-1.364-1.941-2.597-2.116c-0.686,2.545-0.987,5.192-1.32,7.796c-0.387,3.029-0.685,6.203-1.617,9.117l-0.236-0.032
      c-0.168-3.185,0.39-6.465,0.802-9.62c0.312-2.398,0.625-4.824,1.219-7.177c-0.262,0.034-0.467-0.024-0.758,0.056
      c-0.729,0.2-1.374,0.55-1.942,1.004c-0.004,1.212-0.007,2.423-0.03,3.636c-0.016,0.847-0.015,1.696-0.048,2.543
      c-0.034,0.882-0.159,1.766-0.244,2.645h-0.562c-0.085-0.879-0.208-1.763-0.244-2.645c-0.034-0.846-0.032-1.696-0.048-2.543
      c-0.015-0.774-0.011-1.547-0.019-2.32c-0.99,1.314-1.657,2.929-1.988,4.438c-0.594,2.709-0.354,5.552,0.188,8.29
      c-1.065-1.026-2.287-1.855-3.622-2.537c0.411,0.352,0.818,0.701,1.204,1.094l-0.405,0.526l-1.063-0.536l-0.935-0.616
      c-0.622-0.416-1.242-0.829-1.85-1.265c-0.243-0.174-0.486-0.349-0.728-0.523c-0.776-0.054-1.436,0.242-1.963,0.835l0.043,0.032
      c0.876,0.643,1.726,1.324,2.579,1.999c1.739,1.378,3.433,2.804,5.113,4.251l-0.357,0.463c-1.831-1.254-3.674-2.491-5.508-3.741
      c-0.854-0.582-1.712-1.159-2.56-1.751c-0.101,0.331-0.219,0.664-0.26,0.987c0.583,0.311,1.183,0.596,1.751,0.934
      c1.326,0.788,2.617,1.676,3.447,3.007l-0.168,0.13c-1.167-1.096-2.613-1.631-4.054-2.251c-0.319-0.137-0.632-0.288-0.95-0.429
      c0.429,3.494,3.964,6.429,7.064,8.245c-3.144,1.19-7.521,3.107-8.633,6.011c0.303-0.219,0.604-0.441,0.909-0.656
      c0.575-0.406,1.146-0.789,1.762-1.13l0.88-0.398l0.984-0.441l0.227,0.294l-0.796,0.746l-0.694,0.68
      c-0.526,0.447-1.073,0.854-1.628,1.264c-0.552,0.408-1.099,0.822-1.641,1.241l-0.23,0.159c0.021,0.219-0.015,0.423,0.043,0.65
      c0.02,0.077,0.078,0.107,0.102,0.179c0.388-0.241,0.767-0.497,1.153-0.74c0.889-0.558,1.777-1.117,2.665-1.677l1.301-0.784
      c0.533-0.252,1.11-0.367,1.651-0.614l0.308,0.399l-1.189,1.213l-1.201,0.845c-0.907,0.598-1.814,1.196-2.722,1.793
      c-0.409,0.269-0.831,0.523-1.239,0.794c0.606,0.555,1.448,0.779,2.327,0.874l0.806-0.967l1.272-1.375l1.28-1.275l0.112,0.065
      c-0.236,0.572-0.482,1.145-0.764,1.695c-0.279,0.546-0.543,1.087-0.893,1.595l-0.215,0.304c0.169-0.011,0.349-0.002,0.512-0.018
      c1.537-0.15,3-0.615,4.351-1.305c-1.062,2.665-1.882,5.37-1.469,8.341c0.122,0.88,0.424,1.979,0.9,3.017
      c0.134-0.443,0.263-0.887,0.4-1.329c0.641-2.066,1.324-4.107,2.146-6.108l0.361,0.1c-0.313,2.14-0.766,4.245-1.268,6.349
      c-0.209,0.877-0.424,1.752-0.649,2.624c0.585,0.762,1.295,1.36,2.149,1.613c0.073-0.526,0.159-1.051,0.227-1.561
      c0.161-1.201,0.319-2.406,0.538-3.597c0.451-2.461,0.822-4.947,1.467-7.359l0.315,0.042c-0.2,2.487-0.576,4.962-0.745,7.457
      c-0.084,1.25-0.205,2.497-0.293,3.746c-0.031,0.438-0.048,0.887-0.068,1.334c0.582-0.095,1.119-0.305,1.593-0.648
      c0.003-0.107,0.001-0.221,0.003-0.324c0.016-0.973,0.124-1.941,0.228-2.908c0.21-1.961,0.533-3.948,1.155-5.822l0.21,0.028
      c0.111,1.961,0.033,3.941-0.021,5.905c-0.014,0.485-0.03,0.969-0.04,1.454c0.83-1.249,1.403-2.748,1.765-3.897
      c0.71-2.248,1.034-4.557,1.036-6.876c0.866,1.181,1.874,2.259,3.06,3.185c1.704,1.331,4.055,2.654,6.162,1.981l-0.351-0.385
      c-0.629-0.69-1.28-1.366-1.876-2.085c-1.232-1.486-2.464-2.973-3.696-4.46l0.227-0.227c1.423,1.334,2.847,2.667,4.271,4.001
      c0.72,0.674,1.389,1.41,2.076,2.117l0.454,0.468c0.078-0.058,0.161-0.088,0.239-0.154c0.258-0.22,0.353-0.511,0.542-0.764
      c-1.445-1.376-2.848-2.802-4.266-4.203c-1.658-1.638-3.273-3.305-4.865-5.006l0.151-0.151c1.833,1.457,3.633,2.937,5.407,4.464
      c1.435,1.234,2.885,2.458,4.304,3.712c0.232-0.689,0.307-1.422,0.269-2.175l-0.163-0.131c-0.66-0.534-1.324-1.062-1.994-1.583
      c-0.688-0.535-1.406-1.037-2.072-1.598c-0.643-0.543-1.289-1.081-1.941-1.612l0.21-0.273c0.766,0.422,1.528,0.85,2.284,1.29
      c0.73,0.425,1.419,0.94,2.114,1.422c0.453,0.315,0.901,0.638,1.35,0.96c-0.182-0.819-0.427-1.617-0.735-2.327
      c-1.049-2.418-2.708-4.327-4.714-5.923c2.674-1.073,5.228-2.578,7.256-4.603c1.213-1.211,2.513-2.879,2.922-4.641l-0.271,0.082
      C739.167,789.332,738.377,789.515,737.592,789.713z"/>
    <path style={{ fill:"#F2F2F2" }} d="M719.522,803.205c2.709,0,4.905-2.195,4.905-4.904c0-2.709-2.196-4.904-4.905-4.904
      c-2.708,0-4.904,2.195-4.904,4.904C714.617,801.009,716.813,803.205,719.522,803.205z"/>
    <path style={{ fill:"#8DCCEC" }} d="M1001.416,1477.249c1.833-16.593-16.616-27.978-30.171-18.234
      c-17.518,12.593-21.99,38.102-27.723,63.737c-21.728,97.158,9.298,203.622,29.709,298.057c17.155,79.37,7.214,153.56-8.186,231.963
      c-10.027,51.048-30.546,108.571-13.987,160.987c14.054,44.485,69.761,59.571,111.488,44.119
      c50.824-18.821,74.282-87.795,80.819-136.374c17.13-127.288-13.412-264.301-75.064-376.122
      C1027.229,1670.885,991.565,1566.392,1001.416,1477.249z"/>
    <path style={{ fill:"#F2F2F2" }} d="M683.187,698.347c-4.24,0-7.678,3.438-7.678,7.678c0,4.241,3.438,7.678,7.678,7.678
      c1.825,0,3.431-0.727,4.748-1.789c0.073-0.182,0.123-0.366,0.196-0.547c0.178-0.444,0.559-0.582,0.906-0.537
      c1.089-1.326,1.828-2.956,1.828-4.805C690.865,701.785,687.428,698.347,683.187,698.347z"/>
    <path style={{ fill:"#3A944B" }} d="M1203.483,882.862c-0.126,0.528-0.317,1.043-0.467,1.567c10.165-14.833,20.267-29.706,30.174-44.706
      c2.605-2.352,4.841-5.553,6.943-7.793c4.456-4.746,8.928-9.476,13.418-14.188c8.98-9.426,18.03-18.786,27.148-28.079
      c8.878-9.048,17.712-18.14,26.62-27.159c8.941-9.053,18.541-17.792,26.105-28.034c0.602-0.816-0.575-1.937-1.386-1.386
      c-10.263,6.973-19.058,16.105-27.971,24.713c-9.614,9.283-19.158,18.629-28.525,28.162c-7.721,7.856-15.365,15.787-22.988,23.74
      c9.799-15.431,19.437-30.97,28.659-46.78c10.86-18.621,21.513-37.64,31.672-56.971c1.181-1.727,2.357-3.445,3.553-5.057
      c6.175-8.323,12.591-16.448,19.051-24.55c12.617-15.825,25.455-31.55,38.264-47.2c1.039-1.27-0.57-2.953-1.824-1.823
      c-15.018,13.528-28.677,27.862-41.46,43.522c13.631-28.758,25.644-58.215,34.703-88.372l-0.328-0.139
      c-16.159,33.299-31.604,66.759-48.213,99.673c2.264-8.651,4.291-17.373,6.148-26.119c3.982-18.752,6.526-37.384,8.019-56.474
      c0.073-0.922-1.464-1.143-1.627-0.221c-3.276,18.497-7.051,37.044-11.147,55.383c-1.982,8.873-4.166,17.698-6.512,26.481
      c-1.956,7.322-4.311,14.698-5.922,22.147c-4.404,5.817-8.74,11.955-11.008,18.55c-0.233,0.678-0.123,1.25,0.16,1.71
      c-4.198,7.567-8.488,15.094-12.935,22.554c-11.796,19.792-24.208,39.212-36.835,58.498c1.549-5.235,3.059-10.473,4.595-15.644
      c4.747-15.974,8.793-32.156,12.835-48.32c7.751-31.004,15.716-62.183,18.737-94.054l-0.543-0.074
      c-9.017,30.569-15.016,61.941-23.177,92.754c-4.024,15.193-8.524,30.246-12.877,45.345c-3.632,12.6-8,25.182-11.292,37.931
      c-10.549,15.798-21.296,31.461-32.079,47.092c0.49,0.551,0.966,1.12,1.333,1.79
      C1204.455,874.893,1204.397,879.006,1203.483,882.862z"/>
    <path style={{ fill:"#3A944B" }} d="M1227.815,897.847c-0.068,0.137-0.173,0.242-0.245,0.375c0.365-0.217,0.728-0.437,1.093-0.655
      c9.914-5.909,19.743-11.998,29.469-18.213c7.108-4.542,13.874-9.68,18.543-16.819c0.867-1.326-1.077-2.776-2.169-1.674
      c-6.587,6.648-15.548,10.184-23.589,14.727c-7.755,4.382-15.475,8.816-23.172,13.295
      C1229.049,891.727,1229.235,894.963,1227.815,897.847z"/>
    <path style={{ fill:"#3A944B" }} d="M1209.21,909.224c1.079-0.647,2.159-1.292,3.237-1.94c-1.705,0.421-3.422,0.804-5.13,1.129
      C1207.961,908.637,1208.571,908.973,1209.21,909.224z"/>
    <path style={{ fill:"#3A944B" }} d="M1156.37,934.279c-7.835,11.316-15.656,22.649-23.415,34.027c0.781-5.683,1.137-11.423,1.72-16.301
      c1.899-15.876,3.771-31.756,5.657-47.633c3.696-31.125,8.298-62.464,8.747-93.823c0.018-1.227-1.893-1.526-2.171-0.294
      c-6.545,28.992-9.387,58.845-12.89,88.343c-1.771,14.916-3.543,29.831-5.314,44.747c-0.944,7.944-1.726,15.933-3.107,23.817
      c-1.03,5.885-3.432,11.805-3.886,17.739c-4.264,6.333-8.435,12.723-12.64,19.094c2.024,5.176,1.926,10.863,0.644,16.27
      c-0.16,0.676-0.412,1.336-0.598,2.008c3.499-5.369,6.975-10.754,10.518-16.094c3.065-0.499,5.557-2.927,8.399-4.69
      c4.727-2.933,9.573-5.662,14.484-8.272c9.454-5.025,19.102-9.685,28.688-14.45c20.47-10.176,41.551-19.876,60.42-32.828
      c0.813-0.558,0.342-2.025-0.71-1.683c-21.973,7.125-42.694,18.041-63.424,28.158c-10.249,5.001-20.577,9.874-30.655,15.218
      c-2.53,1.341-5.047,2.716-7.537,4.137c12.751-18.952,25.705-37.769,38.704-56.556
      C1164.072,936.382,1159.835,936.275,1156.37,934.279z"/>
    <path style={{ fill:"#3A944B" }} d="M1089.225,991.784c3.534-29.833,6.524-61.159,2.498-91.04c-0.083-0.617-1.158-0.615-1.243,0
      c-4.157,29.854-4.817,60.097-8.843,90.012c-0.299,2.221-0.66,4.431-0.972,6.65c2.406-1.956,5.185-3.396,8.34-4.03
      C1089.07,992.845,1089.162,992.316,1089.225,991.784z"/>
    <path style={{ fill:"#3A944B" }} d="M1205.552,732.457c-0.055-0.787-1.098-0.75-1.198,0c-0.253,1.922-0.4,3.855-0.628,5.781
      c1.19,2.337,1.971,4.817,2.398,7.333C1205.955,741.198,1205.861,736.823,1205.552,732.457z"/>
    <path style={{ fill:"#3A944B" }} d="M1201.397,761.846c-1.528,19.031-2.577,38.106-4.667,57.096c-1.586,14.406-3.628,28.807-6.272,43.06
      c-0.283,1.523-0.609,3.038-0.909,4.558c1.238-0.384,2.538-0.641,3.969-0.579c0.199,0.009,0.384,0.076,0.581,0.094
      c0.433-0.397,1.12-0.274,1.334,0.215c0.666,0.141,1.297,0.349,1.919,0.604c0.188-0.945,0.416-1.881,0.595-2.827
      c2.647-14.022,4.468-28.141,5.759-42.35c2.128-23.406,3.277-46.974,2.666-70.482c-0.322,2.87-1.288,5.715-3.092,8.407
      C1202.736,760.456,1202.05,761.136,1201.397,761.846z"/>
    <path style={{ fill:"#3A944B" }} d="M1134.666,1056.434c-5.987,2.385-12.429,3.867-18.761,5.072c2.453,0.852,4.872,1.874,7.255,2.979
      c20.967-10.53,41.537-21.813,61.396-34.391c1.971-1.248,0.255-4.103-1.813-3.101c-11.14,5.397-22.256,10.851-33.372,16.304
      c-0.152,0.381-0.197,0.781-0.381,1.155C1146.095,1050.329,1140.607,1054.066,1134.666,1056.434z"/>
    <path style={{ fill:"#3A944B" }} d="M989.516,1268.054c3.473-4.445,7.074-8.793,10.837-12.994c7.372-8.229,15.322-15.924,23.604-23.231
      c16.614-14.659,34.104-28.326,51.158-42.43c0.69-0.571-0.201-1.689-0.949-1.229c-19.14,11.762-37.913,24.175-55.025,38.843
      c-8.387,7.189-16.445,14.776-23.933,22.902c-1.308,1.42-2.577,2.875-3.849,4.329c4.363-13.752,9.193-27.425,14.656-41.029
      c4.648-11.574,9.63-23.005,14.814-34.345c17.959-11.111,35.549-22.878,53.479-34.052c17.87-11.137,36.326-21.369,53.701-33.269
      c-1.433-0.099-2.833-0.319-4.174-0.703c-8.866,3.808-17.529,8.052-26.027,12.634c-3.454,4.584-8.362,7.836-14.719,8.173
      c-3.81,2.171-7.613,4.354-11.408,6.538c-14.987,8.63-30.08,17.589-44.556,27.237c10.484-21.939,21.891-43.437,33.903-64.588
      c-0.023,0.015-0.042,0.034-0.065,0.049c-4.208,2.702-9.27,4.479-14.326,4.945c-8.085,14.531-15.891,29.219-23.275,44.137
      c0.174-2.496,0.339-4.968,0.54-7.364c1.125-13.48,1.946-26.986,2.464-40.503c0.08-2.076,0.085-4.149,0.147-6.224
      c-2.31-4.279-2.971-9.268-1.183-13.95c0.382-0.999,0.943-1.871,1.463-2.771c0.03-18.562-0.841-37.087-3.325-55.525
      c-0.13-0.961-1.588-0.667-1.628,0.22c-1.181,26.074-1.3,52.166-2.423,78.25c-0.541,12.552-1.341,25.094-2.401,37.613
      c-0.784,9.256-2.654,19.195-2.654,28.764c-4,8.559-7.892,17.177-11.612,25.887c-4.383,10.261-8.667,20.716-12.767,31.32
      c-0.239-8.175-0.81-16.34-1.432-24.492c-1.445-18.926-3.197-37.731-5.364-56.585c-0.204-1.776-2.879-1.884-2.855,0
      c0.236,18.552,0.856,37.004,1.806,55.537c0.461,8.973,1.163,17.943,1.384,26.925c0.141,5.749-0.671,11.811-0.621,17.704
      c-10.484,29.417-19.045,59.811-23.861,90.431h11.593c4.337-20.796,9.138-41.371,14.929-61.719
      C986.882,1271.683,988.14,1269.815,989.516,1268.054z"/>
    <path style={{ fill:"#F6A654" }} d="M1147.728,1027.617c-7.101-11.113-21.955-10.788-32.464-5.341c-2.663,1.38-5.177,3.075-7.605,4.898
      c0.556-1.62,1.004-3.262,1.46-4.902c0.186-0.672,0.438-1.332,0.598-2.008c1.282-5.407,1.38-11.094-0.644-16.27
      c-0.305-0.781-0.522-1.584-0.935-2.338c-2.412-4.401-6.649-7.13-11.413-8.139c-0.346-0.79-1.455-0.987-2.154-0.348
      c-0.318-0.029-0.617-0.137-0.938-0.151c-1.619-0.07-3.161,0.064-4.628,0.358c-3.156,0.634-5.934,2.075-8.34,4.03
      c-5.582,4.536-9.085,11.926-10.053,19.116c-0.508,3.778-0.565,7.649-0.293,11.505c-2.609-2.84-5.346-5.564-8.295-7.985
      c-4.944-4.057-10.868-7.055-17.412-6.749c-6.085,0.285-11.259,3.963-14.128,9.241c-6.297,11.588,1.167,24.435,11.014,31.001
      c5.254,3.504,11.273,5.99,17.395,7.74l-1.33,0.353c-6.474,1.84-13.073,3.979-19.081,7.045c-4.767,2.432-9.023,5.867-11.691,10.485
      c-0.52,0.901-1.081,1.772-1.463,2.771c-1.788,4.682-1.127,9.672,1.183,13.95c0.498,0.922,0.978,1.855,1.633,2.695
      c4.677,6.012,11.579,7.897,18.493,7.259c5.056-0.467,10.118-2.243,14.326-4.945c0.022-0.015,0.042-0.034,0.065-0.049
      c1.881-1.213,3.667-2.588,5.396-4.042c-0.816,3.051-1.506,6.132-1.941,9.227c-0.893,6.333-0.372,12.951,3.294,18.381
      c3.41,5.049,9.243,7.554,15.242,7.259c0.025-0.001,0.045-0.01,0.069-0.012c6.358-0.337,11.265-3.59,14.719-8.173
      c3.677-4.88,5.708-11.263,5.957-17.35c0.19-4.602-0.332-9.265-1.254-13.841c2.82,3.883,5.842,7.658,9.223,11.002
      c3.439,3.402,7.497,6.238,12.1,7.556c1.341,0.384,2.741,0.604,4.174,0.703c0.151,0.01,0.287,0.067,0.438,0.074
      c6.085,0.279,11.578-2.904,14.923-7.894c7.342-10.955,1.1-24.437-8.097-31.888c-3.651-2.958-7.796-5.351-12.113-7.356
      c-2.383-1.106-4.802-2.127-7.255-2.979c6.332-1.204,12.774-2.686,18.761-5.072c5.941-2.368,11.429-6.104,14.324-11.982
      c0.184-0.374,0.229-0.774,0.381-1.155C1151.448,1038.107,1150.741,1032.333,1147.728,1027.617z"/>
    <path style={{ fill:"#FCC570" }} d="M1133.123,1040.688c-4.052,1.026-8.08,2.021-12.183,2.822l-0.162-0.586
      c3.833-1.484,7.704-2.772,11.61-4.043c1.874-0.61,3.744-1.235,5.623-1.829c0.688-0.218,1.386-0.399,2.082-0.588
      c0.039-1.743-0.318-3.496-1.241-5.208c-0.117-0.218-0.284-0.386-0.414-0.592c-0.119,0.071-0.222,0.136-0.348,0.213
      c-1.532,0.927-3.069,1.846-4.61,2.758c-3.082,1.824-6.182,3.619-9.298,5.384c-6.144,3.479-12.294,6.625-18.829,9.3
      c-0.598,0.245-0.898-0.673-0.417-0.988c5.825-3.814,11.779-7.29,17.802-10.781c2.905-1.683,5.795-3.394,8.67-5.129
      c1.533-0.925,3.062-1.859,4.586-2.799c0.161-0.1,0.305-0.193,0.457-0.292c-1.335-1.19-2.914-2.083-4.645-2.704
      c-0.578,0.381-1.156,0.762-1.732,1.147c-1.755,1.175-3.496,2.369-5.225,3.58c-3.501,2.453-7.036,4.838-10.599,7.201l-0.45-0.584
      c3.141-2.954,6.391-5.721,9.835-8.315c1.732-1.304,3.479-2.59,5.239-3.857c-2.53-0.498-5.156-0.58-7.511-0.392
      c-6.656,0.53-12.877,2.772-18.342,6.377c1.323-6.852,2.378-16.801,0.751-24.042c-2.363,5.591-4.572,11.249-6.818,16.885
      c-0.303,0.76-1.405,0.482-1.239-0.341c0.431-2.143,0.841-4.302,1.508-6.385c0.622-1.942,1.279-3.872,1.973-5.789
      c1.002-2.771,2.157-5.486,3.357-8.18c-1.348-2.939-3.485-4.912-6.657-5.302c-1.736,6.435-2.349,13.165-3.19,19.752
      c-0.977,7.654-1.732,15.675-4.086,23.041l-0.598-0.081c-0.424-8.048,0.985-16.338,2.025-24.311
      c0.796-6.102,1.401-12.325,2.929-18.308c-0.576,0.086-1.132,0.14-1.762,0.313c-1.841,0.506-3.47,1.388-4.906,2.532
      c-0.011,3.064-0.016,6.127-0.075,9.192c-0.041,2.141-0.04,4.288-0.123,6.427c-0.086,2.227-0.401,4.464-0.616,6.683
      c-0.088,0.914-1.331,0.912-1.42,0c-0.215-2.22-0.525-4.456-0.616-6.683c-0.087-2.139-0.082-4.286-0.123-6.427
      c-0.038-2.001-0.029-4-0.049-5.999c-2.533,3.333-4.18,7.509-5.022,11.353c-1.499,6.844-0.894,14.031,0.474,20.947
      c-2.692-2.591-5.78-4.686-9.153-6.411c1.038,0.891,2.068,1.772,3.043,2.766c0.698,0.711-0.187,1.747-1.024,1.327
      c-0.892-0.447-1.819-0.858-2.685-1.353c-0.814-0.466-1.581-1.037-2.362-1.558c-1.571-1.049-3.14-2.094-4.675-3.196
      c-0.619-0.444-1.238-0.888-1.857-1.333c-2.009-0.134-3.866,0.336-5.204,1.933c0.122,0.09,0.245,0.178,0.367,0.268
      c2.216,1.626,4.362,3.347,6.517,5.053c4.394,3.48,8.676,7.085,12.922,10.742c0.641,0.552-0.21,1.641-0.901,1.168
      c-4.627-3.168-9.284-6.293-13.917-9.453c-2.195-1.497-4.401-2.976-6.578-4.499c-0.267,0.86-0.468,1.712-0.575,2.553
      c1.483,0.792,3.008,1.516,4.45,2.373c3.351,1.993,6.615,4.235,8.71,7.599l-0.425,0.328c-2.948-2.771-6.603-4.123-10.246-5.69
      c-0.834-0.359-1.656-0.753-2.488-1.121c1.053,8.853,10.092,16.275,17.939,20.874c-8.009,3.031-19.318,7.89-22.012,15.331
      c0.83-0.601,1.656-1.209,2.494-1.801c1.454-1.026,2.895-1.993,4.453-2.854c0.734-0.406,1.426-0.751,2.226-1.007
      c0.86-0.276,1.668-0.727,2.485-1.115l0.573,0.743c-0.683,0.606-1.421,1.188-2.011,1.884c-0.546,0.644-1.107,1.17-1.752,1.718
      c-1.331,1.131-2.71,2.158-4.115,3.196c-1.394,1.03-2.778,2.075-4.149,3.135c-0.232,0.179-0.482,0.332-0.722,0.499
      c0.054,0.508,0.114,1.017,0.249,1.545c0.044,0.169,0.13,0.288,0.181,0.447c0.999-0.62,1.998-1.242,2.992-1.867
      c2.245-1.411,4.49-2.824,6.733-4.238c1.08-0.681,2.135-1.435,3.288-1.981c1.347-0.638,2.804-0.928,4.173-1.552
      c0.618-0.282,1.365,0.493,0.778,1.009c-1.094,0.962-1.948,2.091-3.006,3.065c-0.907,0.835-2.009,1.458-3.035,2.135
      c-2.291,1.512-4.584,3.024-6.878,4.532c-1.031,0.679-2.066,1.361-3.097,2.046c1.519,1.371,3.59,2.006,5.782,2.248
      c0.703-0.839,1.41-1.673,2.101-2.522c1.002-1.234,2.12-2.327,3.214-3.473c1.049-1.099,2.146-2.157,3.234-3.221l0.283,0.164
      c-0.597,1.445-1.218,2.893-1.929,4.284c-0.705,1.38-1.374,2.746-2.257,4.029c-0.189,0.274-0.388,0.542-0.577,0.816
      c0.447-0.027,0.898-0.051,1.328-0.093c3.884-0.378,7.58-1.554,10.996-3.296c-2.683,6.734-4.756,13.571-3.714,21.077
      c0.309,2.226,1.073,5.001,2.274,7.624c0.341-1.118,0.665-2.241,1.012-3.359c1.62-5.219,3.345-10.378,5.423-15.433
      c0.233-0.568,1.001-0.354,0.912,0.252c-0.791,5.409-1.937,10.728-3.205,16.045c-0.529,2.216-1.073,4.427-1.641,6.632
      c1.48,1.924,3.274,3.437,5.431,4.075c0.186-1.33,0.403-2.655,0.576-3.943c0.407-3.036,0.804-6.079,1.357-9.092
      c1.142-6.218,2.078-12.499,3.71-18.598l0.797,0.109c-0.507,6.283-1.456,12.539-1.884,18.844c-0.215,3.158-0.519,6.309-0.74,9.467
      c-0.078,1.107-0.12,2.242-0.173,3.372c1.466-0.239,2.818-0.764,4.011-1.627c0.007-0.276,0.016-0.562,0.021-0.83
      c0.04-2.458,0.314-4.905,0.576-7.348c0.531-4.955,1.349-9.977,2.918-14.712l0.531,0.073c0.28,4.957,0.084,9.959-0.054,14.922
      c-0.034,1.226-0.075,2.449-0.101,3.673c2.099-3.157,3.545-6.943,4.461-9.848c1.793-5.682,2.614-11.517,2.618-17.375
      c2.19,2.984,4.737,5.709,7.733,8.049c4.305,3.362,10.248,6.708,15.571,5.006c-0.295-0.324-0.591-0.648-0.886-0.972
      c-1.589-1.744-3.234-3.452-4.74-5.269c-3.113-3.757-6.226-7.513-9.339-11.269l0.575-0.574c3.597,3.37,7.195,6.74,10.792,10.109
      c1.82,1.704,3.51,3.563,5.247,5.351c0.383,0.394,0.766,0.789,1.149,1.182c0.198-0.147,0.408-0.223,0.603-0.39
      c0.616-0.526,1.103-1.114,1.562-1.712c-3.725-3.539-7.323-7.232-10.974-10.84c-4.19-4.141-8.27-8.351-12.295-12.652l0.383-0.382
      c4.632,3.681,9.18,7.424,13.666,11.282c3.634,3.125,7.33,6.206,10.925,9.385c0.579-1.726,0.771-3.576,0.682-5.463
      c-0.153-0.125-0.309-0.247-0.462-0.371c-1.666-1.35-3.346-2.683-5.038-4c-1.737-1.351-3.553-2.62-5.235-4.04
      c-1.624-1.371-3.257-2.731-4.904-4.074l0.532-0.691c1.934,1.068,3.862,2.147,5.771,3.259c1.846,1.076,3.587,2.376,5.341,3.595
      c1.165,0.809,2.315,1.64,3.469,2.464c-0.459-2.083-1.132-4.112-1.916-5.921c-2.65-6.111-6.842-10.936-11.914-14.966
      c6.758-2.711,13.213-6.517,18.338-11.632c3.065-3.059,6.349-7.273,7.385-11.728c-0.229,0.068-0.456,0.145-0.686,0.208
      C1137.1,1039.724,1135.104,1040.186,1133.123,1040.688z"/>
    <circle style={{ fill:"#F2F2F2"}} cx="1087.458" cy="1062.388" r="12.393"/>
    <path style={{ fill:"#FCC570" }} d="M1217.984,895.515c-2.51,0.635-5.007,1.253-7.548,1.749l-0.101-0.364
      c2.375-0.92,4.773-1.717,7.194-2.505c1.161-0.378,2.32-0.765,3.484-1.133c0.426-0.135,0.859-0.247,1.29-0.364
      c0.024-1.08-0.198-2.166-0.769-3.226c-0.077-0.143-0.22-0.213-0.305-0.347c-0.063,0.038-0.101,0.072-0.167,0.112
      c-0.95,0.574-1.901,1.144-2.856,1.709c-1.91,1.13-3.83,2.242-5.761,3.336c-3.807,2.155-7.617,4.105-11.666,5.762l-0.258-0.612
      c3.609-2.363,7.298-4.516,11.03-6.679c1.8-1.043,3.59-2.102,5.371-3.178c0.95-0.573,1.897-1.152,2.842-1.734
      c0.079-0.049,0.144-0.085,0.22-0.133c-0.829-0.736-1.772-1.319-2.846-1.703l-1.043,0.69c-1.087,0.728-2.166,1.468-3.237,2.218
      c-2.169,1.519-4.359,2.997-6.567,4.461l-0.279-0.362c1.947-1.83,3.959-3.544,6.094-5.151c1.044-0.786,2.097-1.561,3.157-2.324
      c-1.545-0.297-3.128-0.423-4.564-0.309c-4.124,0.328-7.978,1.717-11.364,3.951c0.82-4.245,1.473-10.409,0.466-14.895
      c-1.465,3.464-2.833,6.969-4.225,10.461l-0.767-0.212c0.268-1.327,0.521-2.665,0.934-3.956c0.385-1.203,0.793-2.399,1.222-3.587
      c0.616-1.704,1.375-3.353,2.112-5.01c-0.833-1.855-2.169-3.098-4.157-3.343c-1.075,3.986-1.455,8.156-1.976,12.238
      c-0.605,4.742-1.073,9.711-2.531,14.275l-0.371-0.05c-0.262-4.987,0.611-10.123,1.255-15.062c0.492-3.781,0.867-7.636,1.814-11.344
      c-0.357,0.054-0.701,0.087-1.092,0.194c-1.141,0.313-2.151,0.86-3.04,1.569c-0.006,1.898-0.01,3.796-0.046,5.695
      c-0.026,1.327-0.025,2.656-0.077,3.982c-0.054,1.38-0.249,2.766-0.381,4.141c-0.055,0.566-0.825,0.565-0.88,0
      c-0.133-1.376-0.325-2.761-0.381-4.141c-0.054-1.325-0.051-2.655-0.077-3.982c-0.023-1.239-0.018-2.478-0.03-3.716
      c-1.57,2.065-2.589,4.652-3.111,7.034c-0.929,4.24-0.554,8.693,0.294,12.979c-1.668-1.606-3.581-2.903-5.671-3.972
      c0.643,0.552,1.281,1.098,1.885,1.714l-0.635,0.822c-0.553-0.277-1.127-0.531-1.664-0.838l-1.463-0.965
      c-0.973-0.65-1.946-1.298-2.896-1.98c-0.384-0.275-0.767-0.55-1.152-0.826c-1.244-0.084-2.395,0.207-3.223,1.197
      c0.076,0.055,0.152,0.111,0.228,0.166c1.373,1.008,2.702,2.074,4.038,3.131c2.722,2.156,5.375,4.389,8.006,6.655l-0.559,0.724
      c-2.867-1.963-5.752-3.899-8.622-5.857c-1.338-0.912-2.682-1.815-4.009-2.742c-0.157,0.518-0.343,1.039-0.407,1.545
      c0.914,0.487,1.852,0.934,2.741,1.462c2.076,1.235,4.098,2.624,5.396,4.708l-0.263,0.203c-1.827-1.717-4.091-2.555-6.348-3.526
      c-0.499-0.215-0.989-0.45-1.486-0.669c0.671,5.47,6.207,10.064,11.059,12.908c-4.922,1.863-11.777,4.864-13.517,9.411
      c0.475-0.342,0.946-0.691,1.425-1.028c0.901-0.635,1.793-1.234,2.759-1.768l1.378-0.624c0.533-0.171,1.034-0.451,1.54-0.691
      l0.355,0.46l-1.247,1.167l-1.085,1.064c-0.825,0.701-1.68,1.337-2.55,1.98c-0.864,0.638-1.721,1.285-2.57,1.943l-0.361,0.249
      c0.032,0.342-0.024,0.661,0.068,1.017c0.031,0.119,0.123,0.167,0.16,0.279c0.608-0.377,1.201-0.779,1.806-1.159
      c1.392-0.874,2.782-1.749,4.172-2.625c0.669-0.422,1.323-0.889,2.037-1.228c0.835-0.395,1.738-0.575,2.586-0.962l0.482,0.625
      c-0.678,0.596-1.206,1.296-1.862,1.899c-0.562,0.517-1.244,0.903-1.88,1.323c-1.42,0.937-2.84,1.873-4.261,2.808
      c-0.636,0.418-1.273,0.84-1.908,1.261c0.946,0.852,2.248,1.204,3.612,1.351c0.422-0.503,0.847-1.005,1.261-1.515
      c0.621-0.764,1.313-1.442,1.991-2.152c0.65-0.681,1.33-1.336,2.004-1.996l0.175,0.102c-0.369,0.896-0.754,1.793-1.195,2.654
      c-0.437,0.855-0.852,1.701-1.398,2.497c-0.11,0.16-0.226,0.316-0.337,0.476c0.266-0.016,0.546-0.004,0.802-0.029
      c2.406-0.234,4.696-0.962,6.812-2.042c-1.662,4.172-2.946,8.408-2.301,13.059c0.191,1.38,0.665,3.098,1.408,4.723
      c0.211-0.693,0.412-1.388,0.627-2.08c1.004-3.234,2.072-6.43,3.359-9.562l0.566,0.156c-0.49,3.352-1.2,6.647-1.986,9.941
      c-0.327,1.373-0.664,2.742-1.017,4.109c0.917,1.192,2.03,2.129,3.366,2.525c0.115-0.823,0.249-1.646,0.355-2.444
      c0.252-1.881,0.499-3.766,0.841-5.633c0.707-3.853,1.287-7.744,2.298-11.522l0.494,0.067c-0.314,3.893-0.902,7.769-1.167,11.675
      c-0.133,1.957-0.321,3.909-0.459,5.865c-0.048,0.686-0.075,1.388-0.107,2.089c0.912-0.149,1.753-0.477,2.494-1.016
      c0.004-0.166,0.002-0.345,0.004-0.507c0.025-1.522,0.194-3.039,0.356-4.552c0.329-3.07,0.836-6.182,1.809-9.115l0.328,0.045
      c0.174,3.071,0.052,6.17-0.033,9.245c-0.021,0.76-0.047,1.518-0.063,2.277c1.3-1.957,2.196-4.302,2.764-6.102
      c1.111-3.521,1.62-7.136,1.622-10.765c1.357,1.849,2.935,3.537,4.791,4.987c2.667,2.083,6.349,4.156,9.647,3.101
      c-0.183-0.201-0.366-0.402-0.549-0.602c-0.984-1.081-2.004-2.139-2.937-3.264c-1.928-2.328-3.857-4.655-5.786-6.982l0.355-0.355
      c2.229,2.088,4.458,4.176,6.687,6.263c1.128,1.056,2.175,2.207,3.251,3.316l0.712,0.733c0.123-0.091,0.253-0.139,0.374-0.242
      c0.385-0.328,0.69-0.695,0.975-1.07c-2.308-2.192-4.545-4.472-6.807-6.707c-2.596-2.565-5.124-5.174-7.618-7.839l0.237-0.237
      c2.87,2.281,5.688,4.599,8.467,6.989c2.254,1.938,4.535,3.862,6.764,5.834c0.364-1.075,0.483-2.228,0.427-3.403
      c-0.095-0.078-0.191-0.154-0.286-0.23c-1.032-0.836-2.073-1.663-3.121-2.478c-1.077-0.837-2.202-1.624-3.244-2.503
      c-1.006-0.85-2.017-1.692-3.038-2.524l0.329-0.428c1.198,0.661,2.393,1.33,3.576,2.018c1.144,0.667,2.223,1.472,3.309,2.227
      c0.721,0.502,1.434,1.016,2.149,1.526c-0.285-1.291-0.701-2.547-1.187-3.668c-1.642-3.786-4.239-6.775-7.381-9.273
      c4.186-1.679,8.186-4.037,11.361-7.207c1.898-1.895,3.933-4.507,4.575-7.266c-0.141,0.042-0.282,0.09-0.424,0.129
      C1220.448,894.918,1219.211,895.204,1217.984,895.515z"/>
    <circle style={{ fill:"#F2F2F2;"}} cx="1189.692" cy="908.96" r="7.678"/>
    <path style={{ fill:"#F6A654" }} d="M1210.222,690.532c-0.396-2.446-1.205-4.845-2.583-7c-3.187-4.987-7.962-7.573-13.178-8.524
      c-6.407-1.168-13.493,0.18-19.286,3.183c-0.292,0.151-0.565,0.342-0.853,0.501c-2.343,1.288-4.59,2.774-6.751,4.397
      c0.784-2.283,1.506-4.582,2.057-6.91c1.475-6.222,1.569-12.861-1.579-18.608c-2.411-4.401-6.649-7.13-11.413-8.138
      c-0.346-0.789-1.454-0.987-2.154-0.348c-0.318-0.029-0.617-0.137-0.938-0.151c-8.032-0.349-14.209,4.128-18.19,10.316
      c-2.549,3.962-4.215,8.609-4.831,13.188c-0.509,3.779-0.565,7.65-0.293,11.504c-0.707-0.77-1.452-1.5-2.179-2.25
      c-1.957-2.014-3.966-3.97-6.116-5.735c-4.944-4.057-10.868-7.055-17.412-6.748c-6.086,0.285-11.26,3.963-14.128,9.241
      c-6.297,11.587,1.167,24.434,11.014,31.001c5.254,3.504,11.273,5.99,17.395,7.739l-1.33,0.354
      c-6.474,1.84-13.073,3.978-19.081,7.045c-5.696,2.907-10.815,7.136-13.153,13.256c-2.174,5.69-0.874,11.905,2.815,16.645
      c7.225,9.285,19.729,8.906,29.418,4.182c1.173-0.572,2.326-1.178,3.4-1.868c1.906-1.224,3.711-2.62,5.461-4.092
      c-0.816,3.051-1.505,6.132-1.941,9.228c-0.822,5.829-0.325,11.858,2.599,17.021c0.253,0.446,0.404,0.928,0.696,1.359
      c3.41,5.049,9.242,7.555,15.242,7.259c13.171-0.651,20.26-13.709,20.746-25.535c0.189-4.602-0.332-9.265-1.254-13.841
      c2.82,3.883,5.842,7.658,9.224,11.002c0.49,0.484,1.041,0.902,1.556,1.361c4.262,3.804,9.317,6.702,15.157,6.971
      c5.093,0.233,9.688-2.044,13.039-5.689c0.653-0.711,1.338-1.39,1.884-2.204c1.804-2.692,2.771-5.537,3.092-8.407
      c0.212-1.894,0.071-3.786-0.248-5.665c-0.427-2.516-1.208-4.995-2.398-7.333c-1.529-3.006-3.63-5.747-6.01-8.128
      c-0.821-0.821-1.648-1.638-2.533-2.356c-3.265-2.646-6.928-4.836-10.749-6.712c-2.714-1.332-5.5-2.517-8.324-3.51
      c-0.098-0.034-0.196-0.079-0.294-0.113c0.18-0.034,0.361-0.076,0.542-0.11c6.158-1.186,12.403-2.645,18.219-4.961
      c0.05-0.02,0.097-0.049,0.147-0.07c5.264-2.121,10.055-5.41,13.083-10.236c0.356-0.568,0.793-1.064,1.095-1.677
      C1210.447,697.228,1210.755,693.829,1210.222,690.532z"/>
    <path style={{ fill:"#FCC570" }} d="M1193.034,696.602c-4.052,1.026-8.08,2.022-12.183,2.822l-0.162-0.587
      c3.833-1.484,7.704-2.772,11.611-4.043c1.874-0.609,3.744-1.235,5.622-1.829c0.688-0.217,1.386-0.4,2.082-0.588
      c0.039-1.743-0.318-3.496-1.24-5.208c-0.118-0.219-0.285-0.387-0.414-0.593c-0.119,0.072-0.221,0.137-0.348,0.213
      c-1.532,0.927-3.069,1.846-4.61,2.758c-3.082,1.824-6.182,3.619-9.299,5.383c-6.144,3.48-12.294,6.626-18.829,9.3
      c-0.597,0.245-0.898-0.674-0.417-0.988c5.825-3.815,11.78-7.29,17.803-10.781c2.906-1.684,5.795-3.394,8.67-5.129
      c1.533-0.926,3.062-1.859,4.586-2.799c0.161-0.1,0.304-0.193,0.457-0.292c-1.336-1.19-2.914-2.083-4.645-2.705
      c-0.578,0.381-1.156,0.762-1.732,1.148c-1.754,1.175-3.496,2.369-5.225,3.58c-3.502,2.453-7.036,4.838-10.599,7.2l-0.451-0.584
      c3.141-2.954,6.391-5.72,9.835-8.314c1.733-1.304,3.479-2.59,5.239-3.857c-2.53-0.498-5.156-0.58-7.51-0.392
      c-6.656,0.53-12.877,2.773-18.342,6.378c1.323-6.852,2.378-16.802,0.75-24.043c-2.363,5.592-4.572,11.249-6.818,16.886
      c-0.302,0.76-1.405,0.482-1.238-0.342c0.431-2.142,0.841-4.302,1.508-6.385c0.622-1.942,1.279-3.872,1.973-5.789
      c1.003-2.771,2.158-5.487,3.358-8.18c-1.348-2.939-3.486-4.912-6.657-5.302c-1.736,6.435-2.35,13.166-3.19,19.752
      c-0.977,7.654-1.732,15.676-4.086,23.041l-0.598-0.081c-0.424-8.048,0.985-16.338,2.025-24.311
      c0.795-6.102,1.401-12.326,2.928-18.309c-0.576,0.086-1.131,0.141-1.762,0.313c-1.841,0.505-3.47,1.389-4.906,2.532
      c-0.011,3.064-0.017,6.127-0.075,9.193c-0.041,2.141-0.04,4.287-0.123,6.427c-0.087,2.228-0.401,4.465-0.616,6.684
      c-0.088,0.914-1.332,0.912-1.42,0c-0.215-2.22-0.525-4.456-0.617-6.684c-0.087-2.139-0.081-4.286-0.122-6.427
      c-0.038-2.001-0.029-4-0.048-5.999c-2.534,3.333-4.18,7.509-5.022,11.352c-1.5,6.844-0.895,14.031,0.474,20.948
      c-2.692-2.591-5.781-4.685-9.155-6.41c1.038,0.891,2.069,1.772,3.045,2.766c0.697,0.71-0.187,1.746-1.024,1.327
      c-0.892-0.447-1.819-0.858-2.685-1.353c-0.814-0.465-1.581-1.037-2.361-1.558c-1.571-1.048-3.14-2.094-4.675-3.196
      c-0.62-0.444-1.239-0.888-1.858-1.333c-2.009-0.135-3.865,0.335-5.203,1.933c0.122,0.09,0.245,0.178,0.367,0.268
      c2.216,1.627,4.362,3.348,6.517,5.054c4.394,3.48,8.676,7.084,12.922,10.742c0.642,0.552-0.209,1.641-0.901,1.168
      c-4.628-3.168-9.284-6.294-13.917-9.453c-2.195-1.497-4.402-2.976-6.578-4.499c-0.268,0.861-0.468,1.713-0.575,2.553
      c1.483,0.792,3.008,1.516,4.45,2.373c3.352,1.993,6.615,4.235,8.71,7.599l-0.425,0.328c-2.949-2.771-6.603-4.123-10.245-5.69
      c-0.835-0.359-1.656-0.753-2.488-1.122c1.054,8.854,10.092,16.275,17.939,20.874c-8.009,3.031-19.317,7.889-22.011,15.331
      c0.83-0.601,1.656-1.209,2.494-1.8c1.453-1.026,2.895-1.993,4.453-2.854c0.734-0.406,1.426-0.751,2.226-1.007
      c0.86-0.276,1.668-0.728,2.485-1.115l0.573,0.743c-0.682,0.605-1.42,1.188-2.011,1.884c-0.546,0.644-1.108,1.171-1.752,1.718
      c-1.331,1.131-2.71,2.158-4.115,3.196c-1.394,1.03-2.778,2.074-4.149,3.135c-0.232,0.179-0.482,0.332-0.722,0.499
      c0.055,0.508,0.114,1.017,0.25,1.545c0.043,0.169,0.129,0.288,0.18,0.447c0.998-0.621,1.999-1.242,2.992-1.867
      c2.245-1.41,4.49-2.823,6.733-4.237c1.08-0.68,2.135-1.435,3.288-1.981c1.347-0.638,2.805-0.928,4.174-1.552
      c0.618-0.282,1.365,0.493,0.778,1.009c-1.095,0.962-1.948,2.091-3.006,3.065c-0.907,0.834-2.009,1.457-3.035,2.135
      c-2.292,1.512-4.584,3.023-6.878,4.533c-1.031,0.679-2.065,1.362-3.096,2.046c1.519,1.37,3.59,2.006,5.782,2.248
      c0.703-0.839,1.41-1.673,2.1-2.522c1.003-1.234,2.12-2.327,3.214-3.473c1.049-1.099,2.146-2.157,3.235-3.221l0.282,0.164
      c-0.597,1.445-1.218,2.893-1.928,4.283c-0.705,1.38-1.375,2.747-2.257,4.029c-0.189,0.274-0.388,0.541-0.577,0.816
      c0.447-0.028,0.898-0.051,1.327-0.093c3.884-0.378,7.58-1.554,10.996-3.296c-2.683,6.734-4.756,13.57-3.714,21.077
      c0.309,2.226,1.073,5.001,2.274,7.624c0.341-1.119,0.665-2.241,1.011-3.359c1.62-5.219,3.345-10.378,5.423-15.434
      c0.233-0.567,1.001-0.354,0.913,0.252c-0.792,5.409-1.937,10.727-3.206,16.045c-0.528,2.215-1.073,4.426-1.641,6.632
      c1.479,1.923,3.274,3.436,5.43,4.075c0.186-1.33,0.404-2.654,0.576-3.943c0.406-3.035,0.804-6.079,1.357-9.092
      c1.141-6.218,2.078-12.499,3.709-18.597l0.797,0.108c-0.507,6.283-1.456,12.539-1.884,18.844c-0.215,3.158-0.518,6.309-0.74,9.467
      c-0.078,1.107-0.121,2.241-0.174,3.372c1.466-0.239,2.819-0.764,4.011-1.626c0.008-0.277,0.017-0.562,0.021-0.83
      c0.04-2.458,0.315-4.906,0.576-7.348c0.531-4.955,1.348-9.977,2.918-14.712l0.532,0.072c0.279,4.956,0.084,9.96-0.054,14.923
      c-0.034,1.225-0.076,2.449-0.101,3.674c2.098-3.157,3.544-6.943,4.461-9.848c1.793-5.683,2.615-11.517,2.618-17.374
      c2.19,2.983,4.737,5.709,7.733,8.048c4.305,3.363,10.248,6.708,15.57,5.006c-0.295-0.324-0.591-0.648-0.886-0.972
      c-1.589-1.745-3.234-3.453-4.74-5.27c-3.112-3.756-6.225-7.513-9.339-11.269l0.574-0.573c3.597,3.369,7.195,6.739,10.792,10.109
      c1.821,1.705,3.51,3.563,5.248,5.351c0.383,0.394,0.766,0.789,1.149,1.183c0.198-0.147,0.408-0.223,0.602-0.39
      c0.616-0.526,1.103-1.113,1.563-1.712c-3.725-3.539-7.323-7.232-10.975-10.84c-4.19-4.14-8.27-8.351-12.295-12.652l0.383-0.383
      c4.632,3.681,9.181,7.424,13.666,11.281c3.634,3.125,7.329,6.206,10.925,9.385c0.579-1.726,0.771-3.576,0.681-5.462
      c-0.153-0.126-0.309-0.247-0.462-0.372c-1.666-1.35-3.345-2.683-5.038-3.999c-1.737-1.351-3.554-2.62-5.235-4.04
      c-1.624-1.371-3.257-2.732-4.905-4.074l0.533-0.69c1.934,1.068,3.861,2.147,5.77,3.259c1.846,1.076,3.587,2.376,5.341,3.595
      c1.165,0.809,2.314,1.64,3.469,2.464c-0.459-2.083-1.132-4.112-1.916-5.921c-2.65-6.111-6.842-10.936-11.914-14.966
      c6.758-2.711,13.214-6.517,18.338-11.632c3.065-3.059,6.348-7.273,7.384-11.728c-0.229,0.067-0.455,0.144-0.686,0.207
      C1197.011,695.638,1195.015,696.1,1193.034,696.602z"/>
    <path style={{ fill:"#F2F2F2" }} d="M1147.369,730.695c6.844,0,12.393-5.548,12.393-12.393c0-6.845-5.549-12.393-12.393-12.393
      c-6.844,0-12.393,5.548-12.393,12.393C1134.976,725.147,1140.525,730.695,1147.369,730.695z"/>
    <path style={{ fill:"#F6A654" }} d="M1170.944,463.264c8.091-3.224,15.565-8.313,19.508-16.318c3.666-7.443,2.686-16.033-1.719-22.928
      c-1.331-2.083-2.878-3.845-4.567-5.361c-1.724-1.548-3.615-2.799-5.622-3.803c-3.435-1.716-7.203-2.679-11.1-2.988
      c-4.878-0.387-9.927,0.218-14.719,1.612c-2.861,0.833-5.631,1.931-8.206,3.266c-3.627,1.88-7.05,4.188-10.357,6.67
      c1.067-3.109,2.052-6.24,2.803-9.41c2.009-8.475,2.136-17.517-2.151-25.343c-2.307-4.21-5.843-7.33-9.98-9.312
      c-1.751-0.839-3.606-1.465-5.534-1.872c-0.272-0.54-0.838-0.872-1.466-0.95c-0.573-0.072-1.169,0.065-1.61,0.49
      c-0.39-0.035-0.772-0.102-1.165-0.119c-17.944-0.779-29.203,16.034-31.353,32.011c-0.693,5.146-0.77,10.419-0.399,15.668
      c-3.553-3.867-7.28-7.578-11.297-10.874c-0.803-0.659-1.627-1.293-2.467-1.905c-6.205-4.526-13.397-7.654-21.247-7.286
      c-2.092,0.098-4.103,0.493-6.005,1.14c-5.638,1.918-10.316,6.071-13.237,11.445c-8.538,15.711,1.502,33.116,14.824,42.096
      c0.059,0.04,0.117,0.086,0.176,0.126c0.865,0.576,1.787,1.07,2.681,1.607c6.501,3.906,13.679,6.838,21.01,8.933
      c-0.602,0.166-1.212,0.311-1.811,0.482c-7.379,2.097-14.85,4.528-21.897,7.698c-1.373,0.617-2.757,1.216-4.091,1.897
      c-3.741,1.908-7.286,4.248-10.324,7.081c-2.749,6.348-5.836,12.568-8.982,18.771c-0.001,5.313,1.858,10.544,5.226,14.872
      c4.664,5.994,10.956,9.013,17.685,9.874c1.35,0.173,2.714,0.269,4.091,0.272c1.371,0.002,2.749-0.092,4.128-0.246
      c6.646-0.741,13.264-3.198,18.793-6.75c2.596-1.667,5.054-3.567,7.438-5.573c-1.111,4.156-2.05,8.352-2.645,12.567
      c-1.216,8.625-0.506,17.639,4.487,25.034c2.401,3.556,5.694,6.165,9.435,7.82c3.494,1.545,7.378,2.26,11.324,2.066
      c2.414-0.119,4.665-0.566,6.777-1.252c13.584-4.412,20.905-19.585,21.478-33.525c0.079-1.924,0.04-3.856-0.051-5.791
      c-0.206-4.365-0.787-8.741-1.657-13.061c2.019,2.779,4.128,5.502,6.33,8.136c1.987,2.378,4.047,4.687,6.232,6.848
      c3.388,3.351,7.228,6.276,11.458,8.335c1.928,0.938,3.941,1.682,6.033,2.2c1.708,0.422,3.456,0.729,5.271,0.813
      c8.287,0.38,15.767-3.955,20.323-10.75c9.879-14.74,1.693-32.824-10.583-43.043c-0.15-0.125-0.294-0.263-0.445-0.386
      c-1.527-1.238-3.157-2.359-4.795-3.467c-5.928-4.011-12.479-7.187-19.188-9.687c-0.801-0.298-1.591-0.644-2.395-0.922
      c1.1-0.209,2.204-0.447,3.307-0.67C1156.246,467.974,1163.83,466.098,1170.944,463.264z"/>
    <path style={{ fill:"#FCC570" }} d="M1168.841,441.819c-5.518,1.397-11.005,2.754-16.593,3.844l-0.22-0.799
      c5.219-2.022,10.491-3.776,15.813-5.507c2.552-0.83,5.099-1.681,7.658-2.491c0.936-0.296,1.887-0.544,2.835-0.8
      c0.053-2.373-0.434-4.762-1.69-7.093c-0.16-0.297-0.387-0.526-0.564-0.806c-0.161,0.097-0.301,0.186-0.474,0.29
      c-2.087,1.262-4.18,2.514-6.278,3.757c-4.198,2.484-8.42,4.928-12.664,7.332c-8.368,4.738-16.744,9.023-25.643,12.665
      c-0.814,0.333-1.223-0.917-0.568-1.346c7.934-5.195,16.043-9.928,24.246-14.683c3.956-2.293,7.893-4.622,11.807-6.986
      c2.088-1.261,4.17-2.531,6.246-3.811c0.219-0.135,0.414-0.264,0.622-0.397c-1.819-1.621-3.969-2.837-6.326-3.683
      c-0.787,0.519-1.575,1.037-2.359,1.563c-2.389,1.6-4.761,3.226-7.117,4.875c-4.769,3.341-9.583,6.589-14.435,9.806l-0.614-0.796
      c4.278-4.022,8.704-7.791,13.395-11.324c2.359-1.776,4.737-3.528,7.135-5.253c-3.446-0.678-7.022-0.789-10.229-0.533
      c-9.065,0.722-17.537,3.776-24.98,8.685c1.814-9.395,3.258-23.065,0.977-32.942c-3.245,7.664-6.161,15.467-9.24,23.195
      c-0.412,1.035-1.913,0.656-1.687-0.465c0.588-2.918,1.146-5.859,2.054-8.696c0.846-2.644,1.742-5.274,2.686-7.885
      c1.365-3.774,2.938-7.472,4.573-11.141c-1.836-4.002-4.747-6.689-9.067-7.22c-2.364,8.763-3.199,17.93-4.344,26.901
      c-1.331,10.424-2.359,21.348-5.565,31.38l-0.814-0.11c-0.577-10.961,1.342-22.252,2.757-33.109
      c1.083-8.311,1.908-16.786,3.988-24.935c-0.784,0.118-1.541,0.191-2.399,0.427c-2.507,0.688-4.727,1.891-6.682,3.449
      c-0.015,4.173-0.022,8.344-0.102,12.519c-0.055,2.916-0.054,5.839-0.167,8.753c-0.117,3.034-0.546,6.08-0.839,9.103
      c-0.12,1.244-1.814,1.242-1.934,0c-0.292-3.023-0.716-6.069-0.839-9.103c-0.119-2.914-0.111-5.838-0.167-8.753
      c-0.052-2.725-0.04-5.448-0.067-8.17c-3.451,4.539-5.692,10.226-6.84,15.461c-2.042,9.322-1.218,19.109,0.646,28.53
      c-3.8-3.659-8.078-6.722-12.879-9.106c1.574,1.323,3.098,2.653,4.559,4.143c0.95,0.968-0.255,2.379-1.395,1.808
      c-1.215-0.609-2.477-1.168-3.657-1.842c-1.109-0.633-2.153-1.412-3.216-2.122c-2.14-1.428-4.277-2.852-6.368-4.352
      c-0.843-0.605-1.687-1.21-2.53-1.815c-2.735-0.183-5.264,0.456-7.086,2.632c0.166,0.122,0.334,0.243,0.5,0.365
      c3.018,2.215,5.941,4.559,8.876,6.883c5.984,4.74,11.816,9.649,17.6,14.63c0.873,0.753-0.286,2.236-1.228,1.591
      c-6.302-4.315-12.644-8.571-18.954-12.874c-2.989-2.039-5.994-4.053-8.959-6.128c-0.364,1.17-0.636,2.327-0.781,3.47
      c2.021,1.079,4.094,2.07,6.06,3.239c4.564,2.714,9.009,5.768,11.862,10.349l-0.579,0.446c-4.015-3.774-8.993-5.615-13.953-7.75
      c-1.137-0.489-2.255-1.025-3.389-1.527c1.435,12.058,13.744,22.166,24.432,28.429c-10.908,4.129-26.309,10.745-29.979,20.88
      c1.131-0.819,2.256-1.647,3.397-2.452c1.98-1.398,3.943-2.715,6.065-3.887c0.999-0.552,1.943-1.023,3.031-1.372
      c1.172-0.375,2.272-0.991,3.384-1.518c0.624-0.296,1.362,0.497,0.781,1.012c-0.93,0.825-1.935,1.617-2.739,2.566
      c-0.743,0.876-1.508,1.594-2.385,2.34c-1.813,1.541-3.692,2.939-5.604,4.353c-1.899,1.403-3.783,2.825-5.651,4.27
      c-0.315,0.244-0.656,0.451-0.983,0.68c0.074,0.691,0.155,1.386,0.34,2.105c0.059,0.229,0.176,0.391,0.246,0.609
      c1.36-0.845,2.722-1.691,4.075-2.542c3.058-1.922,6.115-3.846,9.169-5.772c1.47-0.927,2.907-1.954,4.478-2.698
      c1.835-0.868,3.82-1.264,5.684-2.114c0.842-0.384,1.859,0.672,1.06,1.374c-1.49,1.311-2.653,2.848-4.094,4.175
      c-1.235,1.136-2.736,1.985-4.133,2.907c-3.121,2.06-6.244,4.118-9.367,6.173c-1.404,0.924-2.813,1.855-4.216,2.787
      c2.069,1.867,4.889,2.732,7.874,3.062c0.956-1.143,1.921-2.28,2.861-3.436c1.366-1.68,2.887-3.169,4.378-4.73
      c1.429-1.497,2.923-2.938,4.406-4.388l0.385,0.224c-0.813,1.968-1.659,3.94-2.626,5.833c-0.961,1.88-1.873,3.741-3.074,5.488
      c-0.257,0.373-0.528,0.738-0.786,1.111c0.608-0.037,1.223-0.07,1.808-0.127c5.29-0.516,10.323-2.116,14.975-4.489
      c-3.654,9.171-6.477,18.481-5.058,28.705c0.421,3.033,1.461,6.811,3.097,10.384c0.463-1.523,0.905-3.053,1.377-4.575
      c2.206-7.108,4.556-14.134,7.385-21.019c0.317-0.773,1.364-0.482,1.243,0.343c-1.077,7.367-2.638,14.61-4.365,21.852
      c-0.72,3.018-1.46,6.029-2.235,9.033c2.016,2.619,4.458,4.68,7.396,5.551c0.253-1.811,0.549-3.615,0.784-5.37
      c0.554-4.135,1.096-8.28,1.848-12.383c1.555-8.469,2.83-17.022,5.052-25.328c0.158-0.592,1.136-0.483,1.085,0.147
      c-0.69,8.557-1.983,17.078-2.566,25.665c-0.292,4.301-0.705,8.592-1.008,12.893c-0.106,1.51-0.167,3.05-0.239,4.593
      c1.999-0.325,3.841-1.041,5.466-2.215c0.011-0.377,0.022-0.764,0.028-1.13c0.055-3.348,0.429-6.682,0.785-10.009
      c0.723-6.748,1.836-13.588,3.974-20.037l0.724,0.098c0.381,6.75,0.114,13.564-0.074,20.323c-0.047,1.669-0.103,3.336-0.137,5.004
      c2.858-4.301,4.827-9.457,6.075-13.412c2.442-7.739,3.561-15.686,3.566-23.664c2.982,4.064,6.451,7.775,10.531,10.962
      c5.864,4.58,13.957,9.135,21.206,6.818c-0.402-0.441-0.804-0.883-1.206-1.324c-2.164-2.375-4.406-4.701-6.456-7.176
      c-4.239-5.116-8.479-10.232-12.719-15.348c-0.448-0.54,0.254-1.276,0.782-0.781c4.899,4.589,9.8,9.179,14.699,13.768
      c2.479,2.322,4.78,4.852,7.147,7.288c0.522,0.537,1.043,1.074,1.565,1.611c0.269-0.2,0.556-0.305,0.821-0.531
      c0.84-0.716,1.502-1.516,2.128-2.332c-5.074-4.819-9.973-9.849-14.946-14.763c-5.707-5.638-11.263-11.374-16.745-17.231l0.521-0.52
      c6.308,5.014,12.503,10.11,18.612,15.364c4.95,4.256,9.983,8.453,14.88,12.782c0.789-2.351,1.05-4.871,0.928-7.44
      c-0.208-0.172-0.42-0.337-0.629-0.506c-2.269-1.838-4.556-3.654-6.861-5.447c-2.366-1.84-4.841-3.569-7.13-5.502
      c-2.211-1.868-4.435-3.719-6.679-5.548c-0.546-0.445,0.156-1.255,0.726-0.94c2.633,1.454,5.259,2.924,7.859,4.438
      c2.515,1.465,4.886,3.236,7.275,4.896c1.586,1.103,3.153,2.233,4.724,3.356c-0.625-2.838-1.542-5.6-2.61-8.064
      c-3.609-8.322-9.318-14.894-16.226-20.383c9.204-3.691,17.996-8.875,24.975-15.842c4.174-4.166,8.646-9.906,10.057-15.973
      c-0.312,0.092-0.621,0.197-0.933,0.283C1174.258,440.506,1171.539,441.136,1168.841,441.819z"/>
    <circle style={{ fill:"#F2F2F2;"}} cx="1106.649" cy="471.374" r="16.878"/>
    <path style={{ fill:"#3A944B" }} d="M688.383,1107.132c-2.122,0.804-4.11,1.963-5.832,3.738c-1.367,1.409,0.452,4.033,2.176,2.821
      c2.056-1.446,4.308-2,6.655-2.255c-0.671-0.746-1.3-1.545-1.876-2.397C689.088,1108.418,688.742,1107.772,688.383,1107.132z"/>
    <path style={{ fill:"#3A944B" }} d="M682.348,1075.523c-0.705,0.499-1.397,1.02-2.122,1.486c-1.911,1.228-3.961,2.31-6.088,3.256
      c0.669,0.142,1.348,0.236,2.015,0.388c3.042,0.694,6.035,1.584,9.018,2.5c0.331-2.179,0.747-4.352,1.233-6.518
      C685.06,1076.236,683.705,1075.875,682.348,1075.523z"/>
    <path style={{ fill:"#3A944B" }} d="M657.284,1023.717c-0.706-3.325-1.208-6.689-1.664-10.059c-0.629-0.389-1.29-0.731-1.903-1.14
      c-1.973-1.315-3.86-2.835-5.643-4.488c0.657,6.432,1.424,12.868,2.821,19.179c0.319,1.438,0.671,3.097,1.087,4.825
      c2.169-1.027,4.375-1.983,6.623-2.865C658.112,1027.365,657.672,1025.546,657.284,1023.717z"/>
    <path style={{ fill:"#3A944B" }} d="M649.865,949.583c-0.099-1.142-1.61-1.106-1.75,0c-0.509,4.002-0.936,7.897-1.281,11.789
      c1.242-0.819,2.578-1.481,3.963-2.042C650.477,956.084,650.148,952.843,649.865,949.583z"/>
    <path style={{ fill:"#F6A654" }} d="M780.604,1016.463c5.875-2.341,11.385-5.708,15.493-10.418c1.549-1.776,2.935-3.708,4.015-5.901
      c2.602-5.283,2.824-11.135,1.181-16.558c-0.672-2.217-1.622-4.368-2.9-6.369c-0.757-1.184-1.598-2.24-2.476-3.237
      c-0.879-0.998-1.818-1.897-2.802-2.717c-0.644-0.536-1.304-1.041-1.988-1.504c-2.568-1.739-5.395-2.967-8.375-3.745
      c-9.287-2.425-19.988-0.519-28.572,3.929c-2.618,1.357-5.104,2.982-7.543,4.69c-0.939,0.658-1.894,1.29-2.813,1.98
      c0.695-2.026,1.326-4.068,1.91-6.118c0.311-1.095,0.631-2.188,0.893-3.292c2.009-8.475,2.137-17.517-2.151-25.342
      c-1.603-2.927-3.808-5.317-6.382-7.185c-2.194-1.593-4.654-2.807-7.289-3.575c-0.603-0.176-1.224-0.294-1.842-0.425
      c-0.521-1.031-2.151-1.351-3.075-0.46c-0.389-0.034-0.773-0.101-1.165-0.118c-0.291-0.013-0.565,0.018-0.852,0.014
      c-1.605-0.019-3.153,0.103-4.646,0.354c-3.612,0.607-6.895,1.947-9.815,3.86c-8.986,5.885-14.59,17.013-16.039,27.783
      c-0.363,2.695-0.54,5.425-0.589,8.167c-0.045,2.495,0.013,5,0.19,7.501c-3.553-3.867-7.281-7.578-11.298-10.875
      c-4.445-3.648-9.482-6.634-14.951-8.145c-2.814-0.777-5.735-1.188-8.763-1.047c-2.527,0.119-4.918,0.711-7.16,1.62
      c-1.385,0.561-2.721,1.223-3.963,2.042c-3.347,2.206-6.138,5.281-8.119,8.925c-7.315,13.459-0.981,28.149,9.358,37.734
      c1.783,1.653,3.67,3.173,5.643,4.488c0.614,0.409,1.274,0.751,1.903,1.14c6.699,4.148,14.164,7.221,21.787,9.4
      c-0.601,0.166-1.212,0.311-1.81,0.482c-5.687,1.617-11.424,3.446-16.991,5.63c-2.248,0.882-4.454,1.838-6.623,2.865
      c-0.744,0.353-1.51,0.668-2.242,1.04c-0.042,0.022-0.088,0.038-0.131,0.061c-2.694,1.375-5.279,2.983-7.657,4.824
      c-4.472,3.461-8.178,7.788-10.257,13.23c-2.961,7.75-1.19,16.213,3.834,22.669c9.476,12.177,25.64,12.169,38.609,6.406
      c2.127-0.945,4.177-2.028,6.088-3.256c0.725-0.466,1.417-0.987,2.122-1.486c0.504-0.357,1.022-0.69,1.516-1.062
      c1.291-0.969,2.557-1.98,3.799-3.025c-0.453,1.696-0.853,3.401-1.237,5.109c-0.006,0.029-0.014,0.059-0.021,0.088
      c-0.486,2.166-0.902,4.338-1.233,6.518c-0.044,0.285-0.113,0.567-0.153,0.852c-1.115,7.903-0.569,16.118,3.364,23.129
      c0.359,0.641,0.705,1.286,1.123,1.905c0.576,0.853,1.205,1.651,1.876,2.397c4.743,5.266,11.725,7.84,18.883,7.488
      c5.661-0.279,10.493-2.248,14.481-5.309c2.017-1.548,3.799-3.395,5.379-5.429c1.007-1.297,1.931-2.665,2.759-4.109
      c1.189-2.073,2.186-4.276,3.002-6.555c1.439-4.017,2.299-8.251,2.561-12.412c0.02-0.32,0.06-0.643,0.073-0.962
      c0.258-6.267-0.453-12.618-1.707-18.851c2.214,3.049,4.562,6.006,7,8.874c1.791,2.105,3.612,4.182,5.561,6.11
      c2.383,2.358,4.988,4.512,7.794,6.304c2.593,1.657,5.361,2.994,8.295,3.878c2.139,0.645,4.361,1.058,6.673,1.165
      c0.151,0.007,0.296-0.015,0.447-0.01c8.107,0.205,15.404-4.068,19.877-10.74c10-14.92,1.498-33.282-11.028-43.429
      c-7.045-5.707-15.392-9.947-23.939-13.136c-0.816-0.304-1.62-0.655-2.439-0.939c0.711-0.136,1.426-0.292,2.139-0.434
      C765.123,1021.37,773.123,1019.444,780.604,1016.463z"/>
    <path style={{ fill:"#FCC570" }} d="M778.502,995.018c-5.518,1.397-11.005,2.753-16.592,3.844l-0.22-0.799
      c5.219-2.022,10.491-3.775,15.813-5.506c2.552-0.831,5.099-1.682,7.658-2.491c0.936-0.296,1.887-0.543,2.836-0.8
      c0.054-2.374-0.434-4.762-1.69-7.093c-0.16-0.297-0.387-0.526-0.564-0.806c-0.161,0.097-0.301,0.186-0.473,0.29
      c-2.087,1.262-4.18,2.514-6.279,3.756c-4.198,2.485-8.42,4.929-12.664,7.332c-8.368,4.739-16.744,9.023-25.644,12.666
      c-0.814,0.333-1.223-0.918-0.568-1.347c7.933-5.195,16.043-9.928,24.245-14.682c3.956-2.293,7.893-4.622,11.807-6.986
      c2.088-1.261,4.17-2.531,6.246-3.812c0.219-0.135,0.415-0.263,0.622-0.397c-1.819-1.621-3.969-2.837-6.326-3.682
      c-0.787,0.519-1.575,1.037-2.359,1.562c-2.389,1.6-4.761,3.226-7.117,4.876c-4.769,3.34-9.582,6.589-14.435,9.806l-0.613-0.796
      c4.278-4.023,8.703-7.791,13.394-11.324c2.359-1.776,4.738-3.527,7.135-5.253c-3.446-0.678-7.022-0.789-10.228-0.533
      c-9.066,0.722-17.538,3.776-24.98,8.685c1.814-9.394,3.258-23.065,0.976-32.942c-3.245,7.664-6.161,15.467-9.24,23.195
      c-0.413,1.035-1.914,0.656-1.687-0.466c0.587-2.918,1.146-5.859,2.054-8.696c0.846-2.645,1.742-5.274,2.687-7.885
      c1.365-3.774,2.938-7.471,4.572-11.141c-1.836-4.002-4.747-6.689-9.066-7.22c-2.364,8.763-3.2,17.93-4.345,26.901
      c-1.331,10.424-2.359,21.348-5.565,31.38l-0.814-0.11c-0.577-10.961,1.341-22.252,2.757-33.11
      c1.083-8.311,1.908-16.787,3.988-24.935c-0.784,0.118-1.542,0.192-2.399,0.427c-2.507,0.688-4.726,1.891-6.682,3.449
      c-0.015,4.173-0.022,8.344-0.101,12.519c-0.056,2.916-0.054,5.839-0.167,8.753c-0.118,3.034-0.546,6.081-0.839,9.103
      c-0.12,1.244-1.814,1.242-1.934,0c-0.292-3.023-0.715-6.069-0.839-9.103c-0.119-2.913-0.111-5.838-0.167-8.753
      c-0.052-2.725-0.039-5.448-0.066-8.17c-3.451,4.539-5.693,10.227-6.84,15.461c-2.042,9.321-1.218,19.109,0.647,28.53
      c-3.801-3.659-8.078-6.722-12.88-9.106c1.575,1.322,3.098,2.653,4.559,4.143c0.95,0.968-0.255,2.379-1.395,1.808
      c-1.216-0.609-2.477-1.168-3.658-1.843c-1.109-0.633-2.153-1.412-3.216-2.121c-2.14-1.429-4.276-2.852-6.368-4.352
      c-0.843-0.605-1.687-1.211-2.53-1.815c-2.735-0.183-5.264,0.456-7.085,2.632c0.166,0.122,0.333,0.243,0.499,0.365
      c3.018,2.215,5.941,4.559,8.876,6.883c5.985,4.739,11.816,9.648,17.6,14.63c0.873,0.752-0.286,2.236-1.227,1.591
      c-6.303-4.315-12.644-8.572-18.955-12.875c-2.989-2.039-5.994-4.053-8.958-6.127c-0.364,1.169-0.636,2.327-0.782,3.469
      c2.021,1.079,4.093,2.071,6.059,3.24c4.565,2.714,9.008,5.767,11.862,10.349l-0.579,0.447c-4.015-3.774-8.993-5.615-13.953-7.75
      c-1.138-0.489-2.255-1.026-3.389-1.527c1.435,12.058,13.745,22.165,24.432,28.429c-10.908,4.129-26.309,10.745-29.979,20.88
      c1.131-0.819,2.257-1.647,3.396-2.452c1.98-1.397,3.943-2.715,6.065-3.887c1-0.552,1.943-1.023,3.031-1.372
      c1.172-0.375,2.272-0.991,3.384-1.518c0.623-0.296,1.361,0.497,0.781,1.012c-0.93,0.825-1.935,1.617-2.739,2.566
      c-0.744,0.877-1.509,1.594-2.386,2.34c-1.812,1.541-3.692,2.939-5.604,4.352c-1.899,1.403-3.783,2.826-5.651,4.27
      c-0.316,0.245-0.657,0.452-0.984,0.679c0.075,0.692,0.155,1.386,0.34,2.105c0.059,0.229,0.176,0.392,0.246,0.609
      c1.36-0.845,2.721-1.692,4.074-2.543c3.058-1.921,6.115-3.845,9.17-5.771c1.47-0.927,2.907-1.955,4.477-2.698
      c1.835-0.869,3.82-1.264,5.685-2.114c0.842-0.384,1.859,0.672,1.06,1.374c-1.49,1.31-2.653,2.848-4.094,4.175
      c-1.235,1.136-2.735,1.985-4.133,2.908c-3.121,2.06-6.243,4.118-9.367,6.173c-1.405,0.924-2.813,1.855-4.217,2.787
      c2.069,1.867,4.889,2.733,7.874,3.062c0.957-1.142,1.921-2.279,2.861-3.435c1.366-1.68,2.887-3.169,4.377-4.73
      c1.429-1.496,2.923-2.938,4.406-4.388l0.384,0.224c-0.813,1.969-1.658,3.94-2.626,5.833c-0.961,1.88-1.873,3.741-3.074,5.488
      c-0.256,0.374-0.528,0.738-0.786,1.112c0.609-0.038,1.223-0.07,1.808-0.127c5.29-0.515,10.324-2.116,14.976-4.489
      c-3.655,9.171-6.477,18.482-5.059,28.705c0.421,3.032,1.462,6.811,3.098,10.384c0.463-1.524,0.905-3.053,1.377-4.575
      c2.205-7.108,4.556-14.134,7.385-21.019c0.318-0.773,1.364-0.482,1.243,0.343c-1.077,7.367-2.638,14.61-4.365,21.852
      c-0.72,3.019-1.46,6.029-2.235,9.033c2.016,2.619,4.459,4.68,7.396,5.55c0.253-1.811,0.549-3.615,0.784-5.37
      c0.554-4.134,1.095-8.279,1.848-12.383c1.554-8.469,2.829-17.023,5.052-25.329c0.158-0.591,1.136-0.483,1.085,0.147
      c-0.69,8.557-1.982,17.078-2.565,25.665c-0.292,4.301-0.706,8.593-1.008,12.894c-0.106,1.51-0.166,3.051-0.239,4.593
      c1.998-0.325,3.842-1.041,5.466-2.216c0.011-0.377,0.022-0.764,0.028-1.13c0.054-3.348,0.428-6.681,0.784-10.008
      c0.723-6.748,1.837-13.588,3.975-20.037l0.723,0.098c0.381,6.751,0.114,13.564-0.074,20.323c-0.046,1.67-0.103,3.336-0.137,5.004
      c2.858-4.3,4.827-9.457,6.075-13.412c2.442-7.739,3.561-15.686,3.566-23.663c2.982,4.064,6.451,7.775,10.532,10.962
      c5.864,4.579,13.957,9.135,21.206,6.817c-0.403-0.441-0.804-0.882-1.206-1.324c-2.164-2.375-4.405-4.702-6.456-7.176
      c-4.239-5.116-8.479-10.232-12.719-15.348c-0.448-0.541,0.254-1.276,0.782-0.782c4.9,4.59,9.799,9.179,14.699,13.769
      c2.479,2.322,4.78,4.852,7.146,7.287c0.522,0.537,1.043,1.074,1.565,1.611c0.27-0.2,0.556-0.305,0.822-0.53
      c0.84-0.717,1.502-1.516,2.128-2.332c-5.074-4.819-9.973-9.849-14.946-14.763c-5.707-5.638-11.263-11.374-16.746-17.231
      l0.521-0.521c6.309,5.014,12.503,10.111,18.612,15.365c4.949,4.256,9.982,8.453,14.88,12.782c0.789-2.352,1.05-4.871,0.928-7.44
      c-0.208-0.172-0.42-0.336-0.629-0.506c-2.269-1.839-4.556-3.655-6.862-5.447c-2.366-1.841-4.84-3.569-7.13-5.502
      c-2.212-1.868-4.436-3.72-6.679-5.548c-0.547-0.445,0.155-1.255,0.725-0.941c2.634,1.454,5.26,2.924,7.859,4.438
      c2.515,1.465,4.886,3.236,7.275,4.896c1.586,1.102,3.153,2.233,4.724,3.356c-0.625-2.838-1.542-5.601-2.61-8.064
      c-3.609-8.323-9.318-14.894-16.225-20.383c9.204-3.692,17.995-8.875,24.974-15.842c4.174-4.167,8.646-9.907,10.057-15.973
      c-0.312,0.092-0.62,0.197-0.933,0.283C783.919,993.705,781.2,994.336,778.502,995.018z"/>
    <path style={{ fill:"#F2F2F2" }} d="M716.31,1041.451c9.322,0,16.879-7.557,16.879-16.878c0-9.322-7.557-16.879-16.879-16.879
      c-9.321,0-16.878,7.557-16.878,16.879C699.432,1033.894,706.988,1041.451,716.31,1041.451z"/>
    <path style={{ fill:"#3A944B" }} d="M936.447,611.696c4.464,13.731,9.235,27.323,14.03,40.924c0.589-5.137,1.121-10.287,1.586-15.452
      c-3.879-9.025-8.033-17.926-12.586-26.749C938.621,608.761,935.865,609.905,936.447,611.696z"/>
    <path style={{ fill:"#F6A654" }} d="M991.205,528.233c-1.467-4.595-4.833-7.536-8.889-9.106c-4.105-1.59-8.917-1.775-13.195-0.825
      c-2.155,0.479-4.263,1.21-6.334,2.048c0.988-1.476,1.937-2.976,2.768-4.527c2.226-4.147,3.546-8.852,2.392-13.534
      c-0.884-3.586-3.383-6.328-6.581-7.945c-0.097-0.626-0.848-0.977-1.466-0.654c-0.22-0.081-0.413-0.215-0.638-0.285
      c-4.206-1.314-8.165-0.479-11.579,1.507c-3.967,2.307-7.16,6.197-9.016,10.422c-0.066,0.15-0.157,0.292-0.22,0.442
      c-1.076,2.592-1.847,5.335-2.381,8.129c-1.32-2.513-2.752-4.968-4.393-7.246c-2.75-3.82-6.398-7.071-11.111-8.09
      c-4.383-0.947-8.758,0.693-11.795,3.906c-6.667,7.052-3.785,17.601,1.979,24.132c1.211,1.372,2.61,2.585,4.018,3.782
      c1.715,1.459,3.525,2.787,5.427,4.001c0.5,0.32,0.959,0.704,1.468,1.007h-1.013c-0.258,0.004-0.521,0.03-0.779,0.036
      c-2.405,0.052-4.827,0.164-7.246,0.385c-2.318,0.212-4.628,0.502-6.879,0.987c-4.601,0.992-9.041,3.034-11.86,6.946
      c-2.622,3.637-2.87,8.303-1.142,12.372c1.888,4.443,5.515,7.061,9.703,8.248c2.552,0.723,5.302,0.865,8.005,0.607
      c1.781-0.169,3.544-0.478,5.2-1.011c1.587-0.511,3.134-1.162,4.657-1.879c-1.156,2.017-2.229,4.078-3.124,6.197
      c-1.832,4.336-2.711,9.143-1.128,13.697c1.472,4.235,5.148,7.119,9.471,8.042c2.421,0.516,4.707,0.371,6.821-0.251
      c0.854-0.251,1.667-0.607,2.459-1.007c4.94-2.495,8.644-7.646,10.299-12.987c1.004-3.238,1.513-6.653,1.723-10.083
      c1.272,3.294,2.709,6.551,4.483,9.568c1.774,3.019,4.077,5.763,7.031,7.572c1.017,0.622,2.106,1.14,3.283,1.512
      c1.428,0.45,2.87,0.519,4.298,0.427c2.845-0.182,5.595-1.281,7.808-3.224c7.292-6.406,5.398-17.175,0.263-24.212
      c-3.163-4.335-7.37-8.002-11.824-11.009c4.731,0.339,9.594,0.501,14.303-0.064c4.199-0.505,8.288-1.951,11.385-4.858
      c0.35-0.328,0.745-0.591,1.067-0.96C991.87,537.067,992.549,532.445,991.205,528.233z"/>
    <path style={{ fill:"#FCC570" }} d="M982.512,533.108c0.53-0.025,1.061-0.022,1.592-0.025c0.357-1.232,0.434-2.547,0.101-3.939
      c-0.044-0.182-0.132-0.336-0.187-0.511c-0.104,0.03-0.172,0.065-0.283,0.097c-1.265,0.371-2.532,0.734-3.801,1.091
      c-2.537,0.716-5.081,1.407-7.631,2.073c-5.027,1.315-9.996,2.391-15.15,3.059l-0.11-0.782c4.864-1.614,9.756-2.96,14.699-4.307
      c2.385-0.649,4.764-1.319,7.136-2.011c1.265-0.369,2.529-0.744,3.791-1.125c0.133-0.04,0.253-0.08,0.38-0.121
      c-0.726-1.099-1.679-2.032-2.793-2.801c-0.483,0.163-0.967,0.324-1.449,0.489c-1.47,0.505-2.934,1.024-4.393,1.56
      c-2.954,1.084-5.919,2.112-8.9,3.12l-0.21-0.5c2.792-1.508,5.626-2.862,8.566-4.057c1.479-0.601,2.964-1.185,4.456-1.754
      c-1.706-0.832-3.559-1.386-5.269-1.697c-4.835-0.881-9.683-0.46-14.252,1.072c2.236-4.625,4.865-11.502,5.075-16.96
      c-2.737,3.531-5.376,7.137-8.038,10.723c-0.359,0.484-1.09,0.078-0.817-0.477c0.712-1.443,1.411-2.901,2.278-4.257
      c0.809-1.264,1.641-2.512,2.497-3.745c1.227-1.769,2.601-3.431,3.952-5.108c-0.392-2.383-1.545-4.219-3.753-5.106
      c-2.449,4.249-4.157,8.921-6,13.448c-2.141,5.26-4.193,10.822-7.259,15.618l-0.41-0.17c1.218-5.805,3.787-11.436,6.032-16.911
      c1.718-4.19,3.325-8.503,5.541-12.47c-0.426-0.047-0.831-0.113-1.312-0.11c-1.406,0.012-2.731,0.332-3.969,0.875
      c-0.586,2.178-1.168,4.355-1.789,6.525c-0.433,1.515-0.838,3.042-1.301,4.548c-0.483,1.569-1.129,3.1-1.701,4.638
      c-0.235,0.634-1.12,0.397-1.01-0.268c0.266-1.62,0.468-3.269,0.824-4.871c0.342-1.538,0.751-3.065,1.126-4.595
      c0.351-1.431,0.735-2.851,1.099-4.277c-2.432,1.892-4.391,4.552-5.717,7.127c-2.359,4.585-3.286,9.812-3.619,14.991
      c-1.426-2.352-3.227-4.425-5.301-6.289c0.57,0.83,1.137,1.651,1.643,2.543c0.362,0.637-0.463,1.206-0.979,0.75
      c-0.55-0.486-1.132-0.954-1.655-1.469l-1.385-1.554c-0.919-1.043-1.838-2.083-2.722-3.156c-0.357-0.433-0.713-0.866-1.07-1.299
      c-1.403-0.475-2.812-0.491-4.066,0.392c0.07,0.087,0.141,0.173,0.21,0.26c1.269,1.575,2.471,3.205,3.681,4.826
      c2.469,3.306,4.833,6.678,7.163,10.082l-0.861,0.661c-2.693-3.128-5.416-6.231-8.115-9.353c-1.257-1.455-2.525-2.9-3.767-4.37
      c-0.339,0.546-0.711,1.088-0.938,1.65c0.901,0.838,1.842,1.636,2.702,2.514c2.007,2.05,3.905,4.262,4.76,7.05l-0.364,0.153
      c-1.574-2.528-3.919-4.18-6.214-5.983c-0.507-0.398-0.998-0.819-1.502-1.222c-0.897,6.485,4.058,13.447,8.763,18.191
      c-6.22,0.638-15.003,1.993-18.388,6.685c0.649-0.249,1.297-0.505,1.949-0.747c1.228-0.456,2.436-0.87,3.706-1.189
      c0.598-0.15,1.156-0.265,1.773-0.296c0.664-0.034,1.324-0.203,1.977-0.324l0.268,0.637c-0.601,0.302-1.235,0.576-1.786,0.96
      c-0.51,0.355-1.009,0.623-1.571,0.892c-1.161,0.553-2.336,1.022-3.53,1.496c-1.186,0.469-2.368,0.951-3.544,1.446
      c-0.16,0.067-0.327,0.115-0.489,0.176c-0.067,0.403-0.229,0.752-0.233,1.189c-0.001,0.128,0.038,0.229,0.044,0.352
      c0.827-0.253,1.656-0.506,2.481-0.763c1.864-0.58,3.727-1.16,5.589-1.743c0.896-0.28,1.789-0.618,2.713-0.789
      c1.079-0.199,2.17-0.13,3.262-0.316l0.363,0.865c-0.96,0.477-1.781,1.12-2.717,1.612c-0.803,0.422-1.704,0.658-2.562,0.945
      c-1.915,0.643-3.832,1.285-5.749,1.926c-0.862,0.288-1.726,0.579-2.588,0.87c0.822,1.262,2.174,2.105,3.688,2.691
      c0.658-0.464,1.32-0.923,1.971-1.397c0.946-0.688,1.948-1.255,2.943-1.864c0.954-0.583,1.934-1.129,2.909-1.681l0.17,0.17
      c-0.697,0.916-1.412,1.828-2.181,2.683c-0.763,0.849-1.496,1.694-2.366,2.44c-0.186,0.159-0.379,0.312-0.565,0.471
      c0.323,0.065,0.648,0.133,0.962,0.185c2.835,0.465,5.686,0.327,8.444-0.268c-3.18,4.283-5.946,8.755-6.623,14.291
      c-0.2,1.642-0.181,3.76,0.178,5.852c0.453-0.731,0.896-1.469,1.354-2.198c2.138-3.407,4.34-6.751,6.772-9.954l0.602,0.352
      c-1.584,3.698-3.404,7.265-5.31,10.808c-0.795,1.476-1.599,2.946-2.421,4.408c0.69,1.648,1.681,3.063,3.095,3.925
      c0.383-0.909,0.787-1.814,1.153-2.697c0.863-2.083,1.721-4.172,2.683-6.211c1.986-4.208,3.839-8.498,6.151-12.528l0.546,0.227
      c-1.548,4.374-3.404,8.645-4.899,13.049c-0.748,2.206-1.56,4.39-2.315,6.594c-0.264,0.773-0.509,1.572-0.76,2.366
      c1.088,0.107,2.15-0.011,3.161-0.4c0.057-0.195,0.117-0.396,0.172-0.586c0.493-1.741,1.15-3.43,1.798-5.119
      c1.314-3.424,2.844-6.842,4.855-9.914l0.364,0.152c-0.737,3.578-1.822,7.1-2.857,10.604c-0.256,0.866-0.516,1.729-0.766,2.595
      c2.089-1.849,3.833-4.27,5.033-6.163c2.349-3.704,4.035-7.699,5.144-11.865c0.994,2.535,2.292,4.955,3.981,7.185
      c2.428,3.205,6.023,6.707,10.13,6.502c-0.149-0.286-0.298-0.572-0.446-0.859c-0.801-1.541-1.649-3.066-2.377-4.644
      c-1.505-3.26-3.01-6.52-4.515-9.78l0.517-0.3c1.922,3.076,3.845,6.154,5.767,9.229c0.973,1.557,1.824,3.197,2.722,4.798
      c0.197,0.353,0.395,0.706,0.594,1.058c0.169-0.067,0.332-0.082,0.503-0.163c0.538-0.258,0.995-0.583,1.434-0.923
      c-1.981-3.22-3.842-6.527-5.759-9.783c-2.199-3.737-4.305-7.503-6.356-11.322l0.344-0.2c2.6,3.494,5.128,7.015,7.591,10.606
      c1.994,2.91,4.041,5.799,5.999,8.74c0.738-1.119,1.224-2.398,1.516-3.757c-0.084-0.118-0.173-0.234-0.258-0.351
      c-0.93-1.275-1.874-2.541-2.828-3.797c-0.981-1.289-2.033-2.535-2.961-3.862c-0.896-1.282-1.801-2.558-2.719-3.824l0.509-0.39
      c1.174,1.125,2.341,2.256,3.489,3.407c1.11,1.115,2.104,2.368,3.121,3.566c0.676,0.796,1.337,1.603,2.002,2.408
      c0.067-1.569-0.028-3.138-0.245-4.574c-0.731-4.847-2.802-9.071-5.648-12.896c5.318-0.652,10.63-2.139,15.241-4.811
      c2.758-1.597,5.889-3.975,7.468-6.948c-0.176,0.005-0.351,0.016-0.527,0.018c-1.504,0.013-3.011-0.035-4.515-0.053
      c-3.076-0.036-6.129-0.088-9.199-0.293l-0.004-0.448c3.006-0.332,6.003-0.517,9.023-0.683
      C979.615,533.267,981.063,533.176,982.512,533.108z"/>
    <path style={{ fill:"#F2F2F2" }} d="M932.951,539.243c-1.292,4.868,1.606,9.863,6.475,11.156c4.869,1.292,9.864-1.607,11.156-6.475
      c1.293-4.868-1.606-9.863-6.475-11.156C939.238,531.475,934.243,534.374,932.951,539.243z"/>
    <path style={{ fill:"#7FBF78" }} d="M951.882,1278.719c10.764-43.965,17.735-89.101,23.009-134.426
      c2.257-19.391,4.221-38.814,6.033-58.193c1.365-14.606,2.62-29.28,3.793-43.982c5.38-67.401,8.248-135.598,4.658-202.922
      c-0.161-3.015-0.266-6.038-0.454-9.049c-0.265-4.26-0.634-8.504-0.953-12.756c-0.74-9.841-1.641-19.655-2.693-29.444
      c-0.491-4.569-0.944-9.146-1.507-13.702c-1.036-8.386-2.237-16.741-3.53-25.077c-1.473-9.502-3.119-18.969-4.948-28.397
      c-4.422-22.793-9.964-45.339-16.706-67.598c-1.988-6.565-3.961-13.135-6.17-19.646c-0.103,1.216-0.24,2.425-0.35,3.641
      c-0.465,5.165-0.997,10.315-1.586,15.452c-6.017,52.482-18.218,103.61-32.22,154.354c-2.092,7.583-4.228,15.158-6.384,22.727
      c-1.697,5.954-3.402,11.905-5.122,17.854c-11.129,38.503-22.584,76.941-32.431,115.744c-4.395,17.318-8.462,34.71-12.037,52.212
      c-5.048,24.708-9.121,49.635-11.7,74.897c-1.772,17.352-2.769,34.792-3.161,52.259c6.31-2.52,14.267-2.153,18.269,4.11
      c2.003,3.137,2.449,7.044,0.781,10.43c-1.794,3.642-5.193,5.957-8.875,7.424c-3.306,1.317-6.837,2.159-10.345,2.861
      c0.004,0.278,0.006,0.555,0.01,0.833c3.819,1.443,7.56,3.298,10.711,5.851c5.698,4.616,9.565,12.969,5.016,19.756
      c-2.072,3.092-5.475,5.064-9.245,4.891c-1.956-0.09-3.77-0.663-5.449-1.526c0.857,16.124,2.168,32.229,4.014,48.267
      c2.942,25.553,4.496,61.232,14.002,89.646h24.995c-0.139-1.276-0.313-2.548-0.439-3.826c-2.452-2.734-4.443-6.083-6.539-9.002
      c-2.578-3.59-5.194-7.157-7.737-10.772c-2.528-3.594-5.016-7.275-7.312-11.02c-2.378-3.88-4.496-7.894-6.881-11.766
      c-0.49-0.796,0.677-1.713,1.302-1.004c2.995,3.395,6.205,6.577,9.211,9.968c2.899,3.27,5.674,6.708,8.368,10.148
      c2.724,3.48,5.369,7.024,8.051,10.536l0.513,0.64c-0.171-2.506-0.38-5.011-0.51-7.517c-4.157-4.46-5.852-12.004-7.948-17.277
      c-3.098-7.797-6.232-15.581-9.263-23.405c-3.131-8.086-6.465-16.129-9.326-24.315c-2.773-7.937-4.888-15.909-7.158-23.985
      c-0.337-1.199,1.429-1.964,2.02-0.852c4.058,7.651,8.146,15.121,11.711,23.034c3.326,7.38,6.25,14.966,9.344,22.446
      c3.325,8.038,6.557,16.114,9.812,24.181l0.171,0.392c-0.01-0.734-0.031-1.47-0.038-2.203
      c-0.404-42.171,4.671-83.679,11.873-124.914c-4.227-7.547-5.066-17.427-7.111-25.662c-2.856-11.499-5.842-22.966-8.956-34.398
      c-6.227-22.865-12.938-45.595-17.937-68.77c-0.24-1.113,1.432-1.964,1.936-0.816c9.425,21.479,16.376,43.858,22.709,66.42
      c3.316,11.814,6.496,23.667,9.538,35.554c0.833,3.257,1.949,6.717,2.972,10.243c4.109-21.85,8.686-43.639,13.244-65.422
      c-0.411-2.023-0.77-4.078-1.17-6.215c-1.186-6.34-2.702-12.616-4.23-18.88c-2.854-11.695-5.824-23.362-8.891-35.003
      c-6.371-24.185-12.399-48.462-18.581-72.671c-0.431-1.688,2.003-2.309,2.576-0.71c8.615,24.057,16.462,48.157,23.11,72.863
      c3.247,12.064,6.407,24.156,9.405,36.285c0.473,1.913,1.031,3.936,1.597,5.996c2.068-9.999,4.106-19.998,6.057-30.007
      c2.688-13.787,5.069-27.617,7.296-41.469l-0.423-0.606c-4.007-8.835-4.821-19.57-6.889-29.026
      c-2.081-9.511-4.344-18.977-6.589-28.449c-4.662-19.676-10.262-39.113-14.766-58.824c-0.419-1.832,2.086-2.433,2.753-0.758
      c7.488,18.803,12.929,38.356,18.128,57.896c2.501,9.402,4.726,18.883,6.876,28.371c1.043,4.602,2.454,9.469,3.574,14.377
      c2.577-17.566,4.809-35.181,6.63-52.852c-1.853-8.532-2.619-17.375-3.689-25.983c-1.525-12.276-2.987-24.562-4.338-36.859
      c-2.712-24.687-4.512-49.094-5.189-73.875l0.633-0.086c3.658,23.665,6.812,47.314,9.713,71.124
      c1.498,12.295,3.03,24.586,4.661,36.863c0.174,1.312,0.38,2.637,0.571,3.954c1.707-21.241,2.748-42.518,3.991-63.79
      c1.277-21.846,3.793-44.941,1.738-66.756c-0.055-0.585,0.943-0.598,0.919,0c-1.001,25.036,2.236,50.536,2.27,75.655l-0.013,0.987
      c0.967-4.81,1.934-9.59,2.841-14.289c5.35-27.723,11.976-54.82,20.977-81.562c0.229-0.678,1.204-0.403,1.066,0.294
      c-5.361,27.119-11.169,54.195-16.313,81.37c-2.481,13.107-4.734,26.257-6.762,39.442c-1.163,7.563-2.186,15.186-3.491,22.748
      c-0.452,7.378-0.942,14.751-1.482,22.105c-0.631,8.601-1.446,17.166-2.283,25.728c2.586-7.93,5.248-15.835,8.071-23.683
      c7.858-21.844,15.857-43.987,27.851-63.924c0.293-0.486,1.096-0.166,0.926,0.39c-6.874,22.42-16.354,43.943-23.903,66.16
      c-3.849,11.329-7.453,22.741-10.807,34.226c-2.043,6.994-3.711,14.447-5.987,21.567c-1.917,15.335-4.085,30.624-6.387,45.891
      c2.735-5.762,5.572-11.476,8.568-17.107c10.76-20.224,23.224-39.789,37.312-57.837c0.59-0.756,1.57,0.213,1.229,0.948
      c-9.481,20.469-21.8,39.333-32.316,59.274c-5.22,9.899-10.048,20.006-14.454,30.293c-1.653,3.861-3.123,7.964-4.638,12.063
      c-2.646,16.472-5.402,32.933-8.155,49.401c2.808-5.639,5.726-11.224,8.782-16.733c12.67-22.847,27.758-44.386,46.054-63.037
      c0.722-0.737,2.039,0.241,1.446,1.116c-14.27,21.071-28.356,42.276-40.729,64.535c-6.2,11.153-11.899,22.584-17.075,34.246
      c-1.077,2.427-2.068,4.955-3.053,7.495c-2.442,14.831-4.85,29.674-7.105,44.561c-0.848,5.596-1.661,11.203-2.441,16.818
      c2.801-5.508,5.723-10.957,8.764-16.338c15.655-27.697,31.614-56.852,51.987-81.35c0.457-0.549,1.506,0.041,1.232,0.717
      c-11.615,28.559-29.514,54.314-44.833,80.98c-7.484,13.029-14.579,26.332-20.228,40.273c-1.888,16.304-3.287,32.663-4.109,49.042
      c4.101-9.155,8.385-18.229,13.019-27.127c12.129-23.298,25.956-45.053,43.216-64.799c0.842-0.964,2.363,0.285,1.735,1.339
      c-12.979,21.78-26.268,43.631-37.962,66.164c-5.864,11.299-11.314,22.818-16.313,34.526c-1.567,3.669-2.973,7.569-4.377,11.503
      c-0.072,5.74-0.132,11.48-0.011,17.22c0.06,2.811,0.222,5.604,0.339,8.406c0.662-1.399,1.252-2.829,1.943-4.214
      c3.93-7.886,8.228-15.595,12.684-23.195c4.605-7.854,9.139-15.737,13.606-23.67c4.594-8.158,10.132-16.27,13.527-25.006
      c0.443-1.139,2.271-0.681,1.865,0.514c-2.909,8.555-5.259,17.065-9.106,25.301c-3.731,7.986-8.234,15.635-12.538,23.322
      c-4.443,7.933-8.986,15.818-13.118,23.92c-2.119,4.156-4.142,8.363-5.992,12.647c-0.724,1.676-1.327,3.521-1.976,5.349
      c0.359,4.61,0.804,9.206,1.3,13.793h28.518c0.204-0.603,0.409-1.206,0.61-1.805
      C942.207,1315.438,947.363,1297.177,951.882,1278.719z"/>
    <path style={{ fill:"#DBEBF7" }} d="M813.282,1355.649c0,6.123,5.01,11.133,11.132,11.133h187.099c6.123,0,11.133-5.01,11.133-11.133
      c0-6.123-5.01-11.133-11.133-11.133H824.415C818.292,1344.516,813.282,1349.526,813.282,1355.649z"/>
    <path style={{ fill:"#F6A654" }} d="M857.598,1164.631c3.681-1.466,7.081-3.782,8.875-7.424c1.668-3.386,1.222-7.293-0.781-10.43
      c-4.002-6.263-11.96-6.63-18.269-4.11c-0.626,0.25-1.257,0.496-1.844,0.801c-1.65,0.855-3.207,1.906-4.711,3.035
      c0.486-1.414,0.933-2.839,1.275-4.281c0.914-3.855,0.972-7.969-0.978-11.529c-1.494-2.727-4.12-4.417-7.071-5.042
      c-0.214-0.489-0.901-0.612-1.334-0.216c-0.197-0.018-0.383-0.085-0.581-0.094c-8.163-0.355-13.285,7.294-14.263,14.562
      c-0.315,2.342-0.351,4.74-0.182,7.128c-1.617-1.759-3.312-3.447-5.139-4.947c-0.823-0.675-1.697-1.289-2.604-1.842
      c-1.936-1.182-4.063-1.959-6.317-2.2c-0.618-0.067-1.229-0.168-1.867-0.139c-0.423,0.02-0.807,0.157-1.214,0.228
      c-3.226,0.563-5.961,2.594-7.539,5.498c-3.902,7.178,0.723,15.139,6.824,19.207c0.487,0.325,1.046,0.543,1.554,0.841
      c2.377,1.393,4.921,2.505,7.562,3.363c0.559,0.182,1.097,0.43,1.661,0.592l-0.824,0.219c-0.267,0.076-0.534,0.175-0.801,0.253
      c-2.463,0.715-4.903,1.567-7.301,2.53c-1.254,0.504-2.527,0.973-3.721,1.582c-2.146,1.096-4.105,2.542-5.679,4.323
      c-0.623,0.704-1.164,1.47-1.63,2.3c-0.294,0.521-0.621,1.017-0.84,1.591c-1.347,3.526-0.541,7.376,1.745,10.313
      c1.362,1.751,3.042,2.908,4.87,3.645c0.073,0.029,0.15,0.044,0.223,0.071c2.007,0.764,4.183,0.984,6.378,0.78
      c2.559-0.238,5.092-1.036,7.364-2.239c0.505-0.268,1.024-0.519,1.498-0.823c1.181-0.759,2.3-1.623,3.383-2.536
      c-0.505,1.891-0.932,3.8-1.203,5.717c-0.553,3.923-0.23,8.024,2.041,11.388c2.112,3.128,5.726,4.68,9.444,4.497
      c8.161-0.403,12.553-8.493,12.854-15.82c0.117-2.851-0.206-5.74-0.777-8.576c1.747,2.406,3.619,4.745,5.714,6.817
      c1.13,1.117,2.394,2.088,3.732,2.922c0.39,0.243,0.768,0.504,1.175,0.713c1.678,0.864,3.493,1.436,5.449,1.526
      c3.77,0.173,7.173-1.799,9.245-4.891c4.549-6.787,0.682-15.14-5.016-19.756c-3.151-2.553-6.892-4.408-10.711-5.851
      c-0.436-0.165-0.85-0.4-1.288-0.552c0.426-0.081,0.852-0.196,1.278-0.281C850.761,1166.79,854.292,1165.949,857.598,1164.631z"/>
    <path style={{ fill:"#FCC570" }} d="M856.642,1154.876c-2.511,0.635-5.007,1.252-7.548,1.749l-0.1-0.364
      c2.374-0.92,4.772-1.718,7.193-2.505c1.161-0.378,2.32-0.765,3.484-1.133c0.426-0.135,0.859-0.247,1.29-0.364
      c0.025-1.08-0.197-2.166-0.768-3.227c-0.077-0.142-0.22-0.213-0.305-0.347c-0.064,0.038-0.101,0.073-0.167,0.113
      c-0.95,0.574-1.902,1.143-2.857,1.709c-1.91,1.13-3.83,2.242-5.761,3.336c-3.806,2.155-7.617,4.104-11.665,5.762l-0.259-0.612
      c3.609-2.363,7.298-4.517,11.03-6.679c1.8-1.043,3.59-2.102,5.372-3.178c0.95-0.573,1.897-1.152,2.841-1.734
      c0.08-0.049,0.144-0.085,0.22-0.133c-0.829-0.736-1.772-1.319-2.846-1.703l-1.043,0.69c-1.087,0.728-2.166,1.468-3.237,2.218
      c-2.169,1.519-4.359,2.997-6.567,4.461l-0.279-0.362c1.946-1.831,3.96-3.544,6.094-5.152c1.043-0.786,2.096-1.559,3.155-2.323
      c-1.545-0.296-3.127-0.423-4.563-0.309c-4.124,0.328-7.978,1.718-11.364,3.951c0.82-4.245,1.473-10.409,0.464-14.896
      c-1.464,3.465-2.832,6.969-4.223,10.462l-0.768-0.212c0.268-1.327,0.521-2.665,0.935-3.956c0.385-1.203,0.792-2.399,1.222-3.587
      c0.616-1.704,1.376-3.353,2.113-5.01c-0.834-1.855-2.169-3.098-4.157-3.344c-1.076,3.987-1.456,8.157-1.977,12.238
      c-0.605,4.742-1.073,9.712-2.531,14.276l-0.37-0.05c-0.263-4.987,0.61-10.123,1.254-15.062c0.493-3.78,0.869-7.636,1.815-11.343
      c-0.357,0.054-0.701,0.087-1.091,0.194c-1.141,0.313-2.151,0.86-3.04,1.568c-0.006,1.898-0.01,3.797-0.047,5.696
      c-0.025,1.327-0.024,2.656-0.075,3.982c-0.054,1.38-0.249,2.766-0.382,4.141c-0.055,0.566-0.825,0.565-0.88,0
      c-0.133-1.376-0.325-2.761-0.382-4.141c-0.054-1.326-0.051-2.656-0.076-3.982c-0.024-1.239-0.018-2.478-0.031-3.717
      c-1.57,2.065-2.59,4.652-3.111,7.034c-0.929,4.24-0.553,8.693,0.294,12.979c-1.669-1.606-3.582-2.904-5.672-3.972
      c0.644,0.552,1.282,1.098,1.887,1.714l-0.634,0.822c-0.553-0.277-1.127-0.531-1.664-0.838l-1.463-0.965
      c-0.974-0.649-1.945-1.297-2.897-1.98c-0.384-0.275-0.767-0.551-1.151-0.826c-1.244-0.084-2.395,0.207-3.223,1.197
      c0.076,0.055,0.151,0.111,0.227,0.166c1.373,1.008,2.703,2.074,4.038,3.131c2.723,2.156,5.375,4.389,8.007,6.655l-0.559,0.724
      c-2.867-1.963-5.752-3.899-8.622-5.856c-1.338-0.912-2.682-1.815-4.009-2.742c-0.158,0.517-0.343,1.038-0.407,1.544
      c0.914,0.487,1.852,0.933,2.741,1.462c2.076,1.234,4.098,2.624,5.396,4.708l-0.263,0.203c-1.827-1.716-4.091-2.554-6.348-3.525
      c-0.499-0.214-0.989-0.45-1.486-0.669c0.672,5.47,6.207,10.064,11.06,12.908c-4.922,1.863-11.776,4.863-13.517,9.411
      c0.475-0.342,0.947-0.691,1.424-1.028c0.901-0.635,1.794-1.235,2.759-1.768l1.379-0.624c0.533-0.171,1.033-0.45,1.539-0.691
      l0.355,0.461l-1.247,1.167l-1.085,1.064c-0.825,0.701-1.679,1.337-2.549,1.98c-0.864,0.638-1.722,1.285-2.571,1.943l-0.36,0.249
      c0.032,0.342-0.024,0.661,0.067,1.018c0.031,0.119,0.123,0.167,0.16,0.279c0.608-0.377,1.201-0.779,1.806-1.159
      c1.392-0.874,2.782-1.749,4.172-2.625c0.669-0.422,1.323-0.889,2.037-1.228c0.835-0.395,1.738-0.575,2.586-0.962l0.482,0.625
      c-0.678,0.596-1.207,1.296-1.862,1.9c-0.562,0.517-1.245,0.903-1.88,1.323c-1.419,0.937-2.84,1.873-4.261,2.808
      c-0.636,0.418-1.273,0.839-1.908,1.261c0.945,0.852,2.248,1.203,3.613,1.351c0.422-0.503,0.846-1.004,1.261-1.515
      c0.622-0.764,1.314-1.442,1.992-2.152c0.65-0.681,1.33-1.336,2.004-1.996l0.175,0.102c-0.37,0.896-0.755,1.792-1.195,2.654
      c-0.437,0.855-0.852,1.702-1.399,2.496c-0.11,0.16-0.227,0.317-0.337,0.477c0.265-0.016,0.546-0.004,0.802-0.029
      c2.406-0.235,4.697-0.963,6.813-2.042c-1.663,4.172-2.946,8.408-2.301,13.059c0.191,1.379,0.665,3.098,1.409,4.723
      c0.21-0.693,0.412-1.389,0.627-2.081c1.003-3.233,2.072-6.429,3.359-9.561l0.566,0.156c-0.49,3.352-1.2,6.646-1.986,9.941
      c-0.327,1.373-0.664,2.742-1.016,4.109c0.916,1.192,2.029,2.129,3.365,2.525c0.115-0.823,0.249-1.646,0.356-2.443
      c0.252-1.881,0.498-3.766,0.84-5.633c0.707-3.853,1.288-7.744,2.299-11.522l0.493,0.067c-0.314,3.893-0.902,7.769-1.167,11.675
      c-0.133,1.957-0.321,3.909-0.459,5.865c-0.048,0.686-0.075,1.389-0.108,2.089c0.912-0.149,1.753-0.477,2.494-1.016
      c0.005-0.166,0.002-0.345,0.004-0.507c0.025-1.522,0.195-3.039,0.357-4.553c0.329-3.069,0.836-6.181,1.808-9.115l0.329,0.045
      c0.173,3.071,0.052,6.17-0.034,9.245c-0.021,0.76-0.047,1.518-0.062,2.276c1.3-1.957,2.196-4.302,2.763-6.101
      c1.112-3.521,1.62-7.136,1.622-10.765c1.357,1.849,2.935,3.537,4.792,4.987c2.667,2.083,6.349,4.156,9.646,3.101
      c-0.183-0.2-0.365-0.401-0.548-0.602c-0.985-1.081-2.004-2.139-2.937-3.265c-1.928-2.328-3.857-4.655-5.786-6.982l0.355-0.355
      c2.229,2.088,4.458,4.176,6.688,6.263c1.127,1.056,2.174,2.207,3.25,3.315l0.712,0.733c0.123-0.091,0.253-0.138,0.374-0.241
      c0.385-0.328,0.69-0.695,0.976-1.07c-2.308-2.192-4.545-4.472-6.808-6.707c-2.596-2.565-5.123-5.174-7.617-7.839l0.236-0.237
      c2.87,2.281,5.688,4.599,8.467,6.989c2.253,1.938,4.533,3.862,6.763,5.833c0.364-1.074,0.483-2.227,0.427-3.403
      c-0.094-0.078-0.192-0.153-0.286-0.23c-1.032-0.837-2.073-1.663-3.121-2.478c-1.076-0.837-2.202-1.624-3.243-2.503
      c-1.006-0.85-2.018-1.692-3.039-2.524l0.33-0.428c1.198,0.662,2.392,1.331,3.575,2.019c1.144,0.667,2.223,1.472,3.31,2.227
      c0.721,0.501,1.435,1.016,2.149,1.527c-0.285-1.291-0.702-2.548-1.188-3.669c-1.641-3.786-4.239-6.775-7.381-9.272
      c4.187-1.68,8.186-4.037,11.361-7.207c1.899-1.895,3.933-4.507,4.575-7.266c-0.142,0.042-0.282,0.09-0.425,0.129
      C859.106,1154.278,857.87,1154.565,856.642,1154.876z"/>
    
      <ellipse transform="matrix(0.3809 -0.9246 0.9246 0.3809 -567.4153 1489.2178)" style={{ fill:"#F2F2F2;"}} cx="828.35" cy="1168.32" rx="7.678" ry="7.678"/>
    <path style={{ fill:"#297BAC" }} d="M754.086,2338.943c0,33.194,71.457,36.02,132.942,36.02c61.485,0,132.942,1.412,132.942-36.02
      H863.132H754.086z"/>
    <path style={{ fill:"#459AC8" }} d="M832.573,2290.417c-40.393-74.25-63.511-157.208-73.912-240.789
      c-12.26-98.513,2.367-193.357,32.362-287.556c17.42-54.706,38.386-108.64,51.295-164.672c12.908-56.031,15.79-113.87,10.574-171.07
      c-0.032-0.358-0.088-0.711-0.121-1.069h-90.438c-2.707,0-5.271-0.536-7.731-1.311c0,18.595,0,44.201,0,79.384
      c0,183.028-161.708,279.122-161.708,573.256c0,53.712,14.407,104.046,39.564,147.368c3.354,5.776,6.9,11.428,10.627,16.946
      c7.456,11.037,15.641,21.54,24.487,31.442c24.325,27.229,53.644,49.905,86.515,66.596l0,0h109.046
      C851.947,2323.471,841.72,2307.23,832.573,2290.417z"/>
    <path style={{ fill:"#81C9EE" }} d="M788.015,1404.737c-22.917-13.436-18.891-51.986-18.201-69.526h-7.481
      c-5.379,0-10.391,1.651-14.555,4.47c-2.776,1.88-5.175,4.279-7.055,7.055c-0.94,1.389-1.75,2.87-2.412,4.429
      c-1.324,3.117-2.057,6.54-2.057,10.126v37.891c0,3.586,0.733,7.009,2.057,10.126c1.324,3.118,3.239,5.93,5.603,8.293
      c1.182,1.182,2.476,2.251,3.863,3.191c2.069,1.4,4.396,2.395,6.824,3.16c2.46,0.775,5.024,1.311,7.731,1.311h90.438h64.635h2.156
      h96.783c1.063,0,2.081-0.168,3.111-0.293c0.642-0.079,1.301-0.094,1.927-0.219c0.639-0.127,1.235-0.363,1.856-0.537
      c0.947-0.265,1.899-0.506,2.799-0.874c0.817-0.333,1.578-0.767,2.352-1.18c0.612-0.327,1.24-0.619,1.822-0.992
      c0.905-0.58,1.747-1.245,2.571-1.93c0.354-0.294,0.722-0.564,1.061-0.876c0.915-0.846,1.762-1.764,2.55-2.732
      c0.165-0.203,0.339-0.396,0.498-0.604c0.845-1.105,1.609-2.276,2.273-3.509c0.052-0.097,0.106-0.19,0.157-0.288
      c0.693-1.328,1.285-2.718,1.746-4.167c0.006-0.019,0.012-0.04,0.019-0.06c0.471-1.495,0.816-3.045,1.014-4.639
      C960.642,1427.678,810.932,1418.173,788.015,1404.737z"/>
    <path style={{ fill:"none" }} d="M646.533,685.971c0.019-0.226,0.057-0.451,0.09-0.678C646.592,685.52,646.55,685.745,646.533,685.971z"
      />
    <path style={{ fill:"none" }} d="M652.816,709.929c3.722-1.9,7.811-3.225,11.822-4.365l0.824-0.219
      c-3.793-1.084-7.522-2.624-10.777-4.794c-3.608-2.406-6.649-6.184-7.766-10.345c-0.984,9.214-1.704,18.454-2.132,27.71
      C646.277,714.254,649.363,711.691,652.816,709.929z"/>
    <path style={{ fill:"none" }} d="M646.547,688.012c-0.003-0.031-0.007-0.062-0.01-0.093C646.54,687.95,646.543,687.981,646.547,688.012z
      "/>
    <path style={{ fill:"none" }} d="M644.198,720.185c0.078-0.509,0.188-1.016,0.348-1.517
      C644.388,719.171,644.268,719.676,644.198,720.185z"/>
    <path style={{ fill:'none' }} d="M670.966,744.458c-2.271-3.364-2.594-7.464-2.041-11.388c0.271-1.918,0.697-3.826,1.203-5.717
      c-1.084,0.912-2.203,1.777-3.383,2.535c-1.597,1.026-3.396,1.844-5.269,2.4c-3.935,1.169-8.172,1.062-11.637-0.934
      c-1.256-0.723-2.438-1.627-3.427-2.898c-0.838-1.077-1.397-2.299-1.804-3.56c0.001,5.894,0.226,11.935-0.296,17.761
      c2.53,6.086,5.06,12.172,7.59,18.257c6.164,14.821,12.291,29.665,18.391,44.519c0.093-2.348,0.137-4.699,0.273-7.045
      c0.547-9.496,1.536-18.944,2.836-28.366c1-7.247,2.292-14.358,3.762-21.412C674.685,748.022,672.448,746.653,670.966,744.458z"/>
    <path style={{ fill:"none" }} d="M646.939,683.672c0.129-0.437,0.329-0.87,0.516-1.304C647.271,682.802,647.065,683.235,646.939,683.672
      z"/>
    <path style={{ fill:"none" }} d="M693.263,733.134c-0.266,6.487-3.753,13.547-10.207,15.367c-1.275,7.442-2.477,14.893-3.426,22.364
      c-1.205,9.491-2.07,19.037-2.676,28.585c-0.314,4.955-0.536,9.916-0.663,14.879c-0.049,1.933,0.105,3.763-0.121,5.467
      c6.914,16.979,13.759,33.986,20.396,51.073c0.019-1.353,0.034-2.706,0.06-4.057c0.174-8.969,0.581-17.963,1.414-26.896
      c0.761-8.168,1.836-16.358,3.197-24.453c2.067,0.255,4.267-0.16,6.211-1.058c-1.135,8.818-2.183,17.61-2.959,26.47
      c-0.756,8.634-1.327,17.273-1.579,25.938c-0.13,4.49-0.1,8.982-0.223,13.472c-0.051,1.843-0.03,3.654-0.447,5.316
      c3.979,10.445,7.851,20.93,11.659,31.439c0.102-1.438,0.216-2.86,0.308-4.167c0.473-6.764,1.47-13.489,2.648-20.163
      c1.764-9.997,3.3-20.443,5.988-30.408c-2.343-11.239-4.706-22.474-7.032-33.716c-0.225-1.087-0.443-2.177-0.668-3.265
      c0.838,0.273,1.716,0.44,2.623,0.396c5.212-0.258,8.017-5.425,8.21-10.105c0.075-1.821-0.131-3.667-0.496-5.478
      c1.116,1.537,2.311,3.031,3.65,4.354c1.799,1.78,4.024,3.179,6.613,3.297c2.408,0.11,4.582-1.149,5.906-3.124
      c2.906-4.335,0.435-9.67-3.204-12.618c-2.242-1.816-4.934-3.141-7.664-4.09c2.505-0.477,5.055-1.063,7.424-2.007
      c2.351-0.936,4.523-2.416,5.669-4.741c1.064-2.162,0.78-4.658-0.5-6.662c-2.81-4.398-8.688-4.269-12.846-2.114
      c-1.054,0.546-2.049,1.217-3.009,1.938c0.31-0.904,0.596-1.813,0.815-2.734c0.583-2.462,0.621-5.09-0.625-7.364
      c-0.954-1.742-2.631-2.822-4.516-3.221c-0.137-0.312-0.575-0.39-0.852-0.137c-0.126-0.012-0.244-0.055-0.371-0.06
      c-5.214-0.226-8.486,4.659-9.11,9.301c-0.201,1.496-0.223,3.028-0.116,4.553c-1.032-1.123-2.115-2.202-3.282-3.16
      c-1.116-0.916-2.37-1.658-3.711-2.136c-3.505-17.089-7.006-34.179-10.492-51.271c-0.963-1.159-1.883-2.358-2.768-3.577
      C693.057,727.394,693.38,730.284,693.263,733.134z"/>
    <path style={{ fill:"none" }} d="M702.678,706.298c1.777,0.698,3.532,1.485,5.215,2.388c-2.275-1.26-4.644-2.36-7.076-3.206
      c-0.011,0.002-0.021,0.005-0.032,0.007C701.429,705.711,702.039,706.047,702.678,706.298z"/>
    <path style={{ fill:"none" }} d="M717.801,731.647c-1.55,2.312-3.846,3.996-6.481,4.626c2.647-0.625,4.953-2.314,6.508-4.635
      c4.549-6.787,0.682-15.14-5.017-19.756c-0.988-0.801-2.131-1.407-3.217-2.09c1.088,0.667,2.203,1.299,3.189,2.098
      C718.482,716.506,722.35,724.86,717.801,731.647z"/>
    <path style={{ fill:"#F2F2F2" }} d="M675.482,706.034c0,4.24,3.437,7.678,7.678,7.678c4.241,0,7.678-3.438,7.678-7.678
      s-3.438-7.678-7.678-7.678C678.919,698.356,675.482,701.794,675.482,706.034z"/>
    <path style={{ fill:"#1F5A34" }} d="M904.519,644.252c-4.621,10.924-8.775,22.046-12.284,33.378
      c-0.257-10.886-0.655-21.764-1.209-32.636c1.172-7.088,2.237-14.201,3.657-21.277c2.612-13.015,5.885-25.891,9.578-38.639
      c1.95-6.731,4.045-13.422,6.186-20.1c-2.703,0.258-5.453,0.116-8.005-0.607c-1.978,6.199-3.863,12.422-5.643,18.651
      c-2.677,9.362-5.466,19.202-7.867,29.201c-2.06-24.473-5.211-48.779-8.684-73.049c0.918-3.566,1.033-7.201,1.437-10.949
      c0.589-5.449,1.462-10.861,2.537-16.234c2.076-10.371,4.946-20.584,8.183-30.649c6.403-19.907,14.668-39.093,20.82-59.052
      c0.278-0.902-1.031-1.429-1.504-0.635c-11.131,18.7-19.829,38.077-26.82,58.757c-3.504,10.368-6.355,20.953-8.371,31.713
      l-0.12,0.615c-1.731-11.813-3.452-23.631-5.062-35.472c-2.313-17.012-4.213-34.064-5.934-51.132
      c1.247-14.318,2.658-28.487,5.638-42.712c1.82-8.682,3.976-17.289,6.053-25.911c2.171-9.011,3.4-18.127,5.347-27.178l-0.617-0.17
      c-3.371,9.042-7.317,17.67-10.122,26.923c-2.669,8.807-4.925,17.741-6.928,26.723c-0.809,3.629-1.601,7.326-2.354,11.052
      c-2.689-29.813-5.11-59.651-8.233-89.423c-0.095-0.903-1.367-0.93-1.426,0c-2.903,46.051,0.431,91.456,5.713,136.715
      c-2.62-6.544-5.369-13.037-8.324-19.434c-8.697-18.831-19.277-36.674-30.4-54.149l-0.632,0.37
      c8.205,18.388,16.917,36.53,25.168,54.897c4.265,9.492,8.218,19.122,11.669,28.941c2.334,6.641,3.797,14.11,6.432,20.809
      c2.6,19.701,5.377,39.399,8.002,59.129c-1.306-2.213-2.606-4.393-3.823-6.534c-5.541-9.75-11.417-19.315-17.621-28.657
      c-5.823-8.767-12.053-17.336-18.595-25.581c-1.496-1.886-3.044-3.704-4.603-5.506c1.596,5.687,3.221,11.367,4.732,17.078
      c4.458,6.395,8.936,12.772,13.185,19.319c5.756,8.87,11.226,17.926,16.396,27.15c4.391,7.834,8.011,16.515,13.029,24.01
      c1.9,15.249,3.688,30.519,5.085,45.847c0.522,5.732,0.982,11.467,1.405,17.202c-1.356-2.353-2.705-4.64-3.91-6.757
      c-6.182-10.862-13.333-21.138-20.68-31.237c-1.472-2.024-3.04-3.965-4.529-5.974c1.018,5.565,1.947,11.144,2.884,16.723
      c4.968,7.416,9.804,14.919,14.267,22.654c2.923,5.066,5.673,10.231,8.181,15.516c1.771,3.732,3.183,7.731,5.177,11.36
      c1.453,27.886,1.798,55.8,1.281,83.708c-0.725-1.923-1.34-3.886-2.11-5.791c-4.229-10.455-9.138-20.554-14.567-30.426
      c0.546,6.372,1.014,12.748,1.468,19.124c2.031,4.402,4.048,8.813,5.868,13.295c2.219,5.466,4.243,11.012,6.057,16.625
      c0.896,2.772,1.664,5.619,2.738,8.309c-0.631,18.649-1.621,37.291-2.915,55.914c-0.632-1.533-1.262-3.068-1.901-4.599
      c-2.148-5.16-4.299-10.325-6.489-15.473c0.113,5.409,0.307,10.814,0.368,16.225c0.222,0.563,0.447,1.126,0.668,1.69
      c1.544,3.953,3.078,7.911,4.603,11.872c0.586,1.523,1.113,3.058,1.694,4.561c-2.114,27.292-4.81,54.542-7.922,81.712
      c-0.269,2.344-0.582,4.688-0.864,7.032c-1.535,37.45-3.877,74.923-6.679,112.405c3.575-17.502,7.642-34.894,12.037-52.212
      c1.636-13.56,3.148-27.129,4.668-40.662c1.008-2.81,1.444-5.95,2.148-8.745c1.334-5.291,2.783-10.548,4.412-15.756
      c3.573-11.423,7.838-22.675,12.823-33.556c2.627-5.734,5.436-11.411,8.38-17.025c1.72-5.949,3.425-11.901,5.122-17.854
      c-7.309,10.303-13.937,21.068-19.526,32.538c-3.434,7.048-6.434,14.285-9.224,21.605c0.453-4.549,0.831-9.105,1.26-13.656
      c3.658-9.94,6.046-20.314,9.611-30.311c3.988-11.184,8.766-22.093,14-32.747c3.701-7.534,7.574-15.004,11.5-22.453
      c0.245-4.243,0.456-8.49,0.706-12.732c-7.276,11.109-14.128,22.481-20.172,34.513c-4.756,9.471-8.976,19.192-12.656,29.128
      c1.198-15.295,2.19-30.604,3.008-45.923c5.866-20.295,11.299-40.592,19.147-60.387c4.611-11.629,10.154-22.926,15.633-34.243
      c0.467-6.357,0.951-12.71,1.451-19.072c-9.862,15.688-17.268,33.413-23.908,50.08c-3.806,9.552-7.522,19.349-10.853,29.302
      c0.476-14.787,0.728-29.582,0.757-44.384c2.299-9.658,3.732-19.678,6.552-29.124c3.913-13.112,8.743-25.945,14.17-38.502
      c6.387-14.777,13.464-29.197,20.313-43.726c0.385-3.616,0.762-7.234,1.164-10.844c-0.792,0.4-1.605,0.755-2.459,1.007
      C921.735,607.186,912.514,625.348,904.519,644.252z"/>
    <path style={{ fill:"#1F5A34" }} d="M919.866,535.433c0.108-0.348,0.216-0.695,0.324-1.043c-1.902-1.214-3.712-2.542-5.427-4.001
      c-0.733,1.802-1.436,3.616-2.143,5.429C915.039,535.597,917.461,535.485,919.866,535.433z"/>
    <path style={{ fill:"#1F5A34" }} d="M1219.002,435.808c-4.666,4.49-10.072,8.318-14.948,12.603c-4.888,4.295-9.595,8.796-14.496,13.081
      c-7.453,6.516-15.031,12.888-22.583,19.288c1.638,1.108,3.267,2.229,4.795,3.467c0.151,0.123,0.295,0.261,0.445,0.386
      c7.225-6.262,14.444-12.532,21.518-18.967c4.566-4.153,9.249-8.284,13.528-12.736c4.808-5.004,8.549-10.61,12.913-15.95
      C1220.837,436.169,1219.787,435.053,1219.002,435.808z"/>
    <path style={{ fill:"#1F5A34" }} d="M1147.956,470.665c0.257-0.381,0.49-0.78,0.744-1.163c-1.103,0.223-2.208,0.461-3.307,0.67
      c0.804,0.279,1.594,0.624,2.395,0.922C1147.842,470.95,1147.902,470.809,1147.956,470.665z"/>
    <path style={{ fill:"#1F5A34" }} d="M1159.043,372.072c0.553,4.665,0.58,10.205,1.321,15.449c-2.45,8.681-5.001,17.332-7.639,25.957
      c4.792-1.394,9.841-1.999,14.719-1.612c2.381-8.375,4.622-16.804,6.641-25.319c2.914-5.446,5.467-11.112,8.263-16.668
      c5.029-9.99,10.447-19.785,16.237-29.354c11.552-19.092,25.54-36.521,37.272-55.455c0.46-0.743-0.549-1.42-1.157-0.893
      c-16.696,14.455-29.609,33.594-41.323,52.16c-4.677,7.411-9.057,15.003-13.273,22.685c4.129-19.642,8.047-39.343,11.631-59.116
      c1.341-3.872,2.463-7.851,3.837-11.39c3.186-8.205,6.68-16.282,10.428-24.245c3.625-7.702,7.23-15.398,11.2-22.932
      c2.114-4.013,4.195-8.045,6.349-12.037c2.182-4.043,3.671-8.334,5.742-12.385l-0.506-0.39c-2.578,3.191-5.459,5.891-7.817,9.297
      c-2.58,3.727-5.053,7.546-7.369,11.441c-4.62,7.769-9.062,15.718-12.922,23.894c-1.258,2.664-2.436,5.366-3.629,8.061
      c3.347-19.926,6.543-39.871,9.456-59.821c0.097-0.667-0.857-0.976-1.038-0.287c-6.462,24.585-12.443,49.281-18.411,73.96
      c-0.095-3.689-0.225-7.374-0.373-11.039c-0.685-16.984-2.814-34.343-7.224-50.765c-0.173-0.642-1.201-0.526-1.176,0.159
      c0.601,16.874,1.826,33.727,2.507,50.606c0.487,12.074,0.073,24.155,0.151,36.224c-4.87,19.96-9.881,39.87-15.197,59.688
      c-1.036-8.464-2.21-16.901-3.675-25.306c-3.348-19.208-6.434-40.058-14.83-57.824l-0.515,0.14
      c0.636,19.153,5.649,38.384,8.38,57.322C1156.531,352.189,1157.864,362.128,1159.043,372.072z"/>
    <path style={{ fill:"#1F5A34" }} d="M1230.896,358.126c-5.077,4.355-10.284,8.131-14.932,13c-4.548,4.764-8.996,9.602-13.332,14.561
      c-8.303,9.496-16.379,19.183-24.089,29.167c2.007,1.003,3.897,2.255,5.622,3.803c7.889-10.251,15.896-20.414,24.197-30.335
      c4-4.782,7.981-9.58,12.016-14.332c4.134-4.87,7.375-10.25,11.24-15.305L1230.896,358.126z"/>
    <path style={{ fill:"#1F5A34" }} d="M1098.722,595.24c7.774-9.021,15.832-17.812,24.233-26.254
      c10.94-10.993,22.636-21.135,34.249-31.373c-2.093-0.518-4.105-1.261-6.033-2.2c-11.698,8.757-22.593,18.686-32.994,28.794
      c-7.451,7.241-14.592,14.785-21.471,22.568c3.602-7.417,7.147-14.857,10.676-22.304c-2.112,0.686-4.363,1.133-6.777,1.252
      c-3.946,0.194-7.83-0.521-11.324-2.066c0.158,1.508,0.274,3.025,0.503,4.518c-9.718,19.776-19.668,39.446-29.522,59.157
      c-0.045-1.42-0.092-2.837-0.096-4.156c-0.04-12.654-0.422-25.3-1.357-37.92c-1.367-18.453-3.464-36.669-7.036-54.697
      c-1.379,0.154-2.756,0.248-4.128,0.246c1.74,18.595,3.493,37.209,4.325,55.854c0.543,12.165,0.939,24.34,0.953,36.518
      c0.007,6.228-0.883,13.458-0.723,20.371c-4.825,9.751-9.596,19.526-14.282,29.339c-0.588-4.569-1.325-9.103-1.825-13.414
      c-0.079-0.684-0.177-1.365-0.258-2.049c-2.554,25.94-5.723,51.977-9.375,78.035c2.861-6.856,5.782-13.688,8.78-20.487
      c6.059-4.096,12.058-8.278,18.017-12.517c2.791-4.87,5.636-9.707,8.518-14.523c-7.008,4.954-14.016,9.91-21.079,14.781
      c7.652-16.872,15.641-33.594,23.762-50.224c0.758-1.552,1.522-3.102,2.281-4.653c1.371-1.002,2.677-2.109,4.02-3.214
      c3.453-2.844,7.038-5.518,10.702-8.083c6.797-4.758,13.844-9.183,20.914-13.522c1.367-0.839,2.742-1.658,4.113-2.488
      c2.966-4.051,5.962-8.078,8.998-12.073c-5.671,3.12-11.312,6.3-16.946,9.498c-7.225,4.1-14.31,8.394-21.13,13.143
      c-1.153,0.803-2.405,1.639-3.682,2.498c3.025-6.145,6.051-12.29,9.077-18.435C1088.235,608.639,1093.209,601.638,1098.722,595.24z"
      />
    <path style={{ fill:"#1F5A34" }} d="M1119.301,377.476c1.928,0.408,3.783,1.033,5.534,1.872c-1.816-10.746-4.374-21.309-8.23-31.328
      c-0.174-0.453-0.924-0.434-0.905,0.123c0.319,9.485,1.157,18.937,2.135,28.383C1118.463,376.605,1119.028,376.936,1119.301,377.476
      z"/>
    <path style={{ fill:"#1F5A34" }} d="M1133.48,520.232c-2.202-2.634-4.311-5.357-6.33-8.136c0.87,4.32,1.451,8.696,1.657,13.061
      C1130.354,523.505,1131.897,521.849,1133.48,520.232z"/>
    <path style={{ fill:"#197944" }} d="M1268.746,896.894c-25.884,52.682-54.215,104.111-85.567,153.828
      c-0.49,0.777-0.954,1.57-1.446,2.346c-10.62,16.773-21.586,33.312-32.719,49.738c4.759-3.266,9.647-6.385,14.644-9.377
      c13.687-8.195,28.245-15.348,43.797-21.071c13.167-4.846,26.983-8.645,40.982-9.79c7.055-0.576,14.028-0.457,20.848,0.248
      c0.589-0.539,1.199-1.054,1.788-1.595c35.983-33.101,68.888-69.545,98.154-108.711c33.009-44.177,61.928-93.249,71.117-147.625
      C1379.897,828.825,1322.083,859.716,1268.746,896.894z"/>
    <path style={{ fill:"#197944" }} d="M439.35,913.731c-11.471-1.565-24.8-4.278-35.973-0.227c-0.553,0.2-0.514,1.112,0.147,1.085
      c11.691-0.478,23.663,2.005,35.165,3.883c10.236,1.671,20.468,4.061,30.045,8.117c-4.901,5.592-9.564,11.448-14.194,17.415
      c-3.27,4.213-6.457,8.487-9.568,12.815c-3.197,0.834-6.391,1.679-9.578,2.551c-6.916,1.892-13.84,3.81-20.68,5.961
      c-6.84,2.151-13.682,4.4-20.423,6.847c-5.418,1.966-9.679,4.444-13.026,9.225c-0.575,0.822,0.629,1.566,1.302,1.004
      c4.483-3.74,11.72-4.881,17.196-6.557c6.63-2.029,13.306-3.899,19.948-5.886c6.415-1.918,12.853-3.761,19.312-5.528l0.821-0.219
      c-7.095,10.315-13.792,20.901-19.938,31.819c-2.25,3.997-4.441,8.083-6.584,12.219c-1.478,0.792-2.967,1.563-4.423,2.394
      c-4.824,2.753-9.537,5.699-14.057,8.927c-9.043,6.46-17.437,13.462-24.402,22.147c-0.707,0.883,0.247,2.558,1.34,1.736
      c8.543-6.431,16.934-13.181,25.868-19.084c3.626-2.395,7.344-4.651,11.095-6.85c-13.974,28.91-24.61,60.509-26.944,92.007
      c-0.113,1.523,1.987,1.55,2.468,0.334c11.603-29.331,22.275-58.504,35.828-86.748l0.05,1.186
      c0.264,6.577,0.905,13.132,1.597,19.677c1.411,13.356,2.117,26.804,3.654,40.112c0.055,0.48,0.77,0.668,0.905,0.123
      c3.117-12.593,1.279-25.953,0.294-38.776c-0.504-6.551-0.978-13.109-1.1-19.68c-0.086-4.647,0.561-9.603,0.429-14.369
      c1.816-3.517,3.643-7.03,5.577-10.511c5.357-9.644,11.139-19.049,17.24-28.241c-0.061,1.838-0.103,3.673-0.143,5.492
      c-0.189,8.437,0.093,16.881,0.671,25.299c1.109,16.143,3.816,32.253,6.994,48.101c0.324,1.614,3.01,1.27,2.894-0.392
      c-1.115-15.915-2.686-31.784-3.69-47.709c-0.492-7.797-0.732-15.615-0.573-23.427c0.123-6.023,0.815-12.031,1.163-18.038
      c2.068-2.915,4.137-5.829,6.28-8.69c4.437-5.923,9.145-11.592,13.88-17.232c0.548,3.788,1.299,7.56,1.953,11.311
      c1.123,6.441,2.293,12.869,3.588,19.278c2.509,12.42,4.532,25.465,8.973,37.372c0.69,1.848,3.874,1.778,3.708-0.502
      c-0.905-12.449-4.061-24.87-6.268-37.136c-1.115-6.198-2.243-12.394-3.355-18.593c-1.071-5.969-1.796-12.118-3.368-17.982
      c0.83-0.987,1.633-1.996,2.46-2.986c-2.315-3.021-4.598-6.065-6.831-9.141c-1.551,1.558-3.084,3.135-4.579,4.751
      C461.929,917.758,450.788,915.292,439.35,913.731z"/>
    <path style={{ fill:"#197944" }} d="M772.582,1279.684l-0.704-1.214c-1.795-3.346-3.556-6.711-5.283-10.094
      c-3.82-7.485-7.438-15.074-11.1-22.636c-7.174-14.814-13.502-30.021-20.195-45.052c-0.282-0.632-1.261-0.177-1.094,0.461
      c4.19,15.95,10.071,31.279,16.499,46.452c3.098,7.312,6.523,14.456,10.102,21.542c-8.062-7.023-16.278-13.86-24.804-20.26
      c-3.542-2.659-7.178-5.194-10.795-7.753c-0.935-1.1-1.864-2.201-2.661-3.354c-1.928-2.789-3.688-5.692-5.372-8.634
      c-4.05-7.073-7.769-14.337-11.638-21.51c-8.096-15.007-16.294-30.018-25.294-44.493l-0.239,0.14
      c6.969,16.231,14.853,32.11,22.844,47.869c3.654,7.205,7.164,14.51,11.111,21.562l0.598,1.086
      c-14.824-9.913-30.142-19.107-45.878-27.482c-1.031-1.351-2.264-2.551-3.483-3.839c-2.237-2.366-4.401-4.796-6.518-7.268
      c-4.456-5.204-8.81-10.448-12.787-16.034c-7.597-10.673-14.201-22.285-20.473-33.774l-0.505,0.213
      c1.865,6.412,3.911,12.566,6.963,18.527c3.13,6.114,6.595,12.056,10.371,17.792c3.589,5.452,7.436,10.783,11.611,15.804
      c0.494,0.594,1.047,1.138,1.555,1.722c-10.191-5.071-20.51-9.89-31.059-14.171l-0.572-0.217c-2.547-1.85-5.684-3.148-8.232-4.809
      c-3.672-2.393-7.081-5.137-10.25-8.163c-6.319-6.032-11.798-12.928-16.419-20.347l-0.421,0.177c1.412,4.324,3.162,8.314,5.71,12.09
      c2.529,3.748,5.39,7.417,8.658,10.552c1.893,1.815,3.92,3.493,6.006,5.094c-6.165-2.063-12.37-4.041-18.484-6.195
      c10.096,3.84,20,8.814,29.462,13.32c1.248,0.594,2.471,1.241,3.715,1.842c-6.264-1.058-12.628-1.529-18.975-1.32
      c-15.524,0.513-30.582,4.473-45.136,9.647c-0.885,0.315-0.54,1.65,0.391,1.421c14.44-3.551,29.086-7.088,44.003-7.617
      c7.006-0.248,14.056,0.176,20.938,1.552c3.377,0.675,6.717,1.563,9.968,2.699c1.828,0.64,3.608,1.416,5.453,1.913
      c6.086,3.162,12.127,6.412,18.088,9.8c5.087,2.891,10.084,5.93,15.067,8.99c-8.517-0.303-17.361,1.184-25.232,3.094
      c-11.95,2.9-24.091,7.06-34.766,13.216c-0.696,0.401-0.22,1.428,0.532,1.262c11.579-2.555,22.519-7.293,34.132-9.801
      c5.931-1.28,11.946-2.108,18.016-2.28c6.108-0.173,11.958,0.744,17.997,1.428l0.189-0.017
      c15.972,10.359,31.436,21.489,46.243,33.479c0.922,0.747,1.813,1.525,2.731,2.276c-1.673-0.45-3.343-0.868-4.954-1.263
      c-5.173-1.268-10.417-2.202-15.701-2.865c-10.976-1.376-21.614-1.193-32.439,1.074c-0.877,0.183-0.66,1.535,0.208,1.537
      c10.482,0.034,21.228,0.469,31.595,2.092c5.037,0.788,10.028,1.866,14.939,3.232c5.047,1.403,10.036,3.729,15.213,4.446l0.864-0.15
      c10.389,8.789,20.472,17.896,30.245,27.344c-2.895-0.926-5.82-1.749-8.739-2.411c-8.159-1.851-16.504-2.726-24.787-1.367
      c-0.601,0.099-0.393,0.948,0.134,0.995c7.836,0.697,15.715,1.465,23.323,3.556c6.924,1.904,13.297,4.871,19.451,8.498
      c3.444,3.51,6.863,7.046,10.202,10.673c6.358,6.907,12.318,14.135,18.171,21.447h14.019c-8.002-9.907-16.624-19.344-25.158-28.479
      C791.051,1297.416,781.956,1288.4,772.582,1279.684z"/>
    <path style={{ fill:"#197944" }} d="M996.613,1335.21h10.765c14.02-21.391,28.275-42.569,44.513-62.443
      c16.671-20.405,34.813-39.552,53.95-57.654c1.946-0.776,3.916-1.492,5.93-2.101c7.211-2.181,14.715-3.863,22.212-4.684
      c0.932-0.102,1.363-1.636,0.245-1.809c-6.46-0.998-12.891-0.986-19.269,0.141c1.682-1.536,3.314-3.127,5.011-4.647
      c7.6-6.806,15.44-13.334,23.393-19.725c4.563-0.791,9.171-2.492,13.442-3.44c7.744-1.718,15.546-3.177,23.388-4.367
      c8.217-1.246,16.492-2.184,24.764-2.99c8.523-0.831,17.112-2.094,25.657-2.513c0.536-0.027,0.531-0.792,0-0.829
      c-8.609-0.597-17.003-1.494-25.657-1.292c-8.547,0.2-17.054,0.87-25.546,1.848c-7.724,0.888-15.419,2.031-23.071,3.41
      c14.122-10.704,28.698-20.81,43.731-30.193c1.513-0.944,3.075-1.801,4.597-2.729l0.077-0.014
      c5.153-0.823,10.323-1.528,15.497-2.201c10.134-1.317,20.295-2.362,30.496-3.013c10.194-0.651,20.388-0.879,30.601-0.905
      c10.175-0.026,20.417-0.804,30.562-0.549l0.012-0.091c-10.299-1.505-20.121-3.397-30.574-3.814
      c-10.577-0.423-21.202-0.306-31.777,0.11c-10.419,0.41-20.85,1.134-31.208,2.352c22.635-13.005,45.939-24.825,68.749-37.507
      c0.556-0.31,0.122-1.11-0.447-0.971c-33.832,8.293-66.339,23.367-96.869,41.905c3.401-4.673,6.691-9.414,9.788-14.318
      c9.165-14.514,19.318-28.763,30.344-41.92c0.651-0.777-0.328-1.75-1.107-1.107c-13.063,10.795-22.546,24.55-32.395,38.191
      c-5.002,6.929-10.16,13.847-15.46,20.552c-2.494,3.154-5.258,6.134-7.905,9.197c-15.512,10.275-30.42,21.347-44.683,32.732
      c3.106-4.969,6.208-9.942,9.18-14.992c7.579-12.881,14.236-26.456,19.379-40.484c0.206-0.563-0.625-0.846-0.926-0.39
      c-8.321,12.603-16.111,25.582-23.851,38.552c-3.811,6.388-7.731,12.71-11.757,18.965c-2.078,3.227-4.214,6.417-6.253,9.668
      l-0.464,0.707c-0.717,0.601-1.464,1.192-2.177,1.795c-6.604,5.578-13.164,11.364-19.651,17.327
      c2.299-4.771,4.517-9.57,6.732-14.382c2.598-5.644,4.871-11.427,7.564-17.024c0.483-1.004-0.849-2.279-1.663-1.283
      c-3.664,4.482-7.171,9.015-10.04,14.048c-2.98,5.229-5.691,10.557-8.338,15.961c-2.562,5.227-5.163,10.438-7.997,15.524l-0.279,0.5
      c-16.38,16.057-31.975,33.341-46.293,51.513c-6.688,10.304-13.3,20.657-19.73,31.124
      C1006.737,1313.192,1001.779,1323.978,996.613,1335.21z"/>
    <path style={{ fill:"#1F5A34" }} d="M1409.569,878.279c-7.113,1.046-13.513,3.832-20.189,6.388c-6.863,2.627-13.675,5.381-20.498,8.11
      c-4.13,1.651-8.257,3.312-12.387,4.964c0.563-0.552,1.139-1.09,1.7-1.644c6.16-6.064,12.182-12.273,18.31-18.372
      c7.292-7.259,12.624-15.62,19.367-23.414c0.747-0.864-0.239-2.438-1.305-1.692c-7.289,5.108-15.574,9.06-22.344,14.71
      c-6.659,5.558-13.277,11.17-19.84,16.841c-4.025,3.478-7.922,7.111-11.863,10.69c0.866-1.723,1.768-3.426,2.596-5.167
      c6.198-13.027,12.373-26.473,16.464-40.315c0.162-0.547-0.608-1.05-1.001-0.582c-9.14,10.899-14.263,24.598-20.499,37.254
      c-3.102,6.295-6.388,12.523-10.168,18.441c-1.178,1.844-2.469,3.602-3.736,5.379c-4.4,4.136-8.804,8.271-13.198,12.403
      c-8.579,8.066-17.01,16.275-25.478,24.448c2.229-4.723,4.379-9.483,6.411-14.294c7.028-16.638,13.869-34.667,15.501-52.651
      c0.101-1.112-1.678-1.606-2.145-0.581c-7.569,16.624-12.852,34.42-20.287,51.242c-3.622,8.197-7.547,16.261-11.766,24.168
      c-1.533,2.874-3.18,5.738-4.796,8.622c-7.694,7.559-15.269,15.243-22.878,22.891c3.373-8.086,6.695-16.193,9.91-24.343
      c7.041-17.847,14.074-35.938,17.346-54.893c0.133-0.771-0.921-1.354-1.347-0.568c-8.929,16.49-15.172,34.275-21.992,51.718
      c-3.443,8.805-6.977,17.573-10.603,26.303c-2.043,4.918-4.223,9.778-6.225,14.701l-0.449,0.45
      c-16.525,16.894-32.818,34.014-49,51.237c-0.49,0.777-0.954,1.57-1.446,2.346c-10.62,16.773-21.586,33.312-32.719,49.738
      c4.759-3.266,9.647-6.385,14.644-9.377c0.55-0.599,1.089-1.209,1.639-1.808c12.782-13.886,25.706-27.64,38.717-41.311
      c5.999-0.823,12.231-3.075,17.9-4.389c7.994-1.853,16.004-3.637,24.028-5.353c7.723-1.651,15.456-3.259,23.184-4.886
      c8.108-1.707,16.03-3.047,23.726-6.205c1.03-0.423,0.934-1.919-0.269-1.99c-8.253-0.486-16.032,0.924-24.164,2.209
      c-7.826,1.236-15.62,2.606-23.405,4.076c-7.777,1.469-15.54,3-23.292,4.595c-2.367,0.487-4.909,0.901-7.484,1.327
      c7.529-7.847,15.032-15.719,22.63-23.499c4.623-1.716,9.166-3.79,13.558-5.373c10.075-3.63,20.209-7.089,30.384-10.428
      c9.822-3.222,19.691-6.295,29.606-9.217c9.684-2.854,19.483-5.145,28.418-9.96c0.531-0.286,0.278-1.115-0.302-1.116
      c-10.551-0.023-20.614,3.034-30.73,5.759c-9.975,2.689-19.91,5.526-29.799,8.515c-9.643,2.915-19.228,6.021-28.772,9.245
      c12.89-13.08,25.819-26.125,38.836-39.084c3.54-1.616,7.09-3.208,10.669-4.735c8.786-3.748,17.696-7.209,26.695-10.409
      c8.674-3.085,17.437-5.92,26.276-8.496c8.729-2.544,17.505-4.218,25.3-8.942l-0.233-0.858c-9.184-0.931-17.754,1.739-26.621,4.163
      c-9.488,2.594-18.893,5.484-28.202,8.661c-7.022,2.397-13.968,5.007-20.87,7.73c5.557-5.495,11.081-11.026,16.66-16.496
      c8.635-8.467,17.384-16.819,26.11-25.194c2.579-1.049,5.161-2.089,7.73-3.163c6.577-2.748,13.096-5.643,19.641-8.47
      c6.512-2.813,13.039-5.594,19.509-8.503c6.728-3.026,13.501-5.67,19.442-10.115
      C1410.898,879.166,1410.463,878.147,1409.569,878.279z"/>
    <path style={{ fill:"#197944" }} d="M1194.461,675.007c5.392-8.176,10.792-16.349,16.164-24.536
      c7.452-4.097,13.906-10.836,20.285-16.061c8.918-7.303,18.098-14.252,27.35-21.124c17.991-13.363,36.75-25.757,55.3-38.323
      c1.338-0.907,0.192-2.816-1.255-2.147c-20.726,9.592-39.921,21.479-58.539,34.673c-8.863,6.281-17.438,13.007-25.86,19.865
      c-1.456,1.185-3.006,2.395-4.578,3.623c4.717-7.256,9.452-14.501,14.118-21.787c12.03-18.788,23.738-37.858,34.875-57.257
      c1.734-2.073,3.454-4.157,5.248-6.179c5.332-6.009,10.956-11.745,16.816-17.24c11.828-11.091,24.459-21.633,37.415-31.384
      c0.839-0.631,0.139-1.921-0.836-1.431c-14.911,7.484-28.255,16.703-40.635,27.91c-1.651,1.495-3.223,3.077-4.829,4.622
      c13.773-25.497,26.434-51.571,37.349-78.371c0.235-0.576-0.682-0.924-0.985-0.415c-18.413,31.102-37.407,61.812-56.698,92.326
      c1.398-5.409,2.697-10.844,3.941-16.284c4.754-20.797,8.303-41.411,9.87-62.676c0.058-0.777-1.181-0.938-1.357-0.184
      c-4.589,19.689-8.976,39.504-14.031,59.083c-3.66,14.173-6.818,29.497-13.033,43.064c-21.598,33.779-43.54,67.338-65.531,100.879
      c1.199-4.914,2.297-9.839,3.358-14.642c2.928-13.265,5.289-26.657,7.475-40.062c4.524-27.728,8.523-55.69,14.883-83.072
      c0.338-1.455-1.729-2.002-2.22-0.612c-9.26,26.239-13.778,53.314-18.474,80.678c-2.299,13.391-4.59,26.78-7.511,40.053
      c-2.276,10.34-5.531,20.462-8.212,30.694c0.288-0.159,0.561-0.35,0.853-0.501C1180.968,675.188,1188.054,673.839,1194.461,675.007z
      "/>
    <path style={{ fill:"#197944" }} d="M1194.577,712.348c-5.816,2.317-12.061,3.776-18.219,4.961c-0.084,0.073-0.163,0.15-0.248,0.223
      c2.824,0.993,5.61,2.177,8.324,3.51c3.4-2.951,6.801-5.905,10.289-8.764C1194.674,712.299,1194.627,712.328,1194.577,712.348z"/>
    <path style={{ fill:"#197944" }} d="M1208.902,700.365c-0.302,0.613-0.739,1.11-1.095,1.677c1.08-0.812,2.092-1.691,3.183-2.491
      c10.161-7.454,20.647-14.366,31.224-21.131c5.206-5.809,10.427-11.605,15.709-17.35c-16.743,8.336-32.653,18.511-47.701,29.461
      C1210.755,693.829,1210.447,697.228,1208.902,700.365z"/>
    <path style={{ fill:"#197944" }} d="M974.891,1144.293c1.485-5.72,3.021-11.427,4.625-17.116c1.051-7.316,2.188-14.612,3.613-21.839
      c4.917-24.953,11.418-49.582,19.183-73.795c12.571-39.199,28.479-77.212,46.495-114.199l0.123-0.115
      c6.167-5.43,12.748-10.356,19.532-14.985c4.38-2.989,8.784-5.925,13.19-8.855c2.232-3.741,4.458-7.487,6.732-11.201
      c-8.4,4.548-16.626,9.405-24.513,14.869c-2.658,1.841-5.262,3.764-7.85,5.708c3.092-6.118,6.235-12.21,9.431-18.272
      c19.021-36.072,39.883-71.041,61.539-105.532c-2.924-5.163-3.421-11.193-2.599-17.021c0.436-3.095,1.126-6.177,1.941-9.228
      c-1.75,1.472-3.555,2.868-5.461,4.092c-1.074,0.69-2.227,1.297-3.4,1.868c-1.424,5.91-2.946,11.802-4.316,17.713
      c-21.043,33.562-41.284,67.671-59.82,102.641c0.23-5.662,0.457-11.324,0.685-16.986l1.704-42.233
      c1.157-28.687,2.202-57.237,1.003-85.923c-0.059-1.397-1.953-1.323-2.118,0c-3.559,28.562-4.892,57.166-6.112,85.923l-1.793,42.233
      c-0.288,6.796-0.586,13.592-0.865,20.388c-0.157,3.827-0.918,8.127-0.569,12.099c-11.865,23.196-22.822,46.834-32.864,70.887
      c-0.046-4.39-0.124-8.723,0.049-12.797c0.57-13.489,1.26-26.976,1.98-40.458c0.72-13.474,1.771-26.929,2.464-40.404
      c0.688-13.37,0.379-27.023,1.589-40.329c0.065-0.715-1.022-0.693-1.105,0c-1.618,13.479-4.512,26.81-6.096,40.329
      c-1.573,13.42-2.503,26.928-3.467,40.404c-0.964,13.475-1.667,26.958-2.193,40.458c-0.387,9.925-2.125,21.484-1.007,31.81
      c-3.635,9.327-7.143,18.711-10.435,28.191c-3.388,9.757-6.498,19.609-9.471,29.502c-1.173,14.702-2.428,29.376-3.793,43.982
      C979.112,1105.479,977.148,1124.902,974.891,1144.293z"/>
    <path style={{ fill:"#197944" }} d="M1130.524,672.437c0.616-4.579,2.282-9.227,4.831-13.188c-0.393-15.494-1.863-30.942-4.852-46.208
      c-0.141-0.724-1.266-0.542-1.266,0.172c-0.013,22.831,0.058,45.684-1.185,68.479c0.728,0.75,1.472,1.48,2.179,2.25
      C1129.959,680.086,1130.016,676.216,1130.524,672.437z"/>
    <path style={{ fill:"#197944" }} d="M801.805,1137.904c0.638-0.03,1.248,0.072,1.867,0.139c2.254,0.241,4.382,1.018,6.317,2.2
      c0.207-1.453,0.414-2.898,0.74-4.264c0.936-3.923,2.15-7.768,3.499-11.567c2.924-8.231,6.65-16.123,10.469-23.969
      c7.879-16.185,15.604-32.441,21.382-49.499l-0.842-0.354c-10.569,15.76-19.252,32.715-27.614,49.743
      c-3.624,7.379-7.128,14.872-9.864,22.635c-0.278-14.956-0.471-29.916-0.739-44.869c2.488-10.323,4.671-20.471,8.309-30.663
      c4.476-12.538,9.228-24.979,14.211-37.323c9.755-24.167,20.254-48.036,30.14-72.133c0.303-0.738-0.875-1.185-1.263-0.532
      c-13.555,22.813-24.593,46.503-34.632,71.078c-5.037,12.329-9.842,24.755-14.373,37.279c-0.939,2.595-1.946,5.285-2.933,8.022
      c-0.665-24.99-1.816-49.944-4.149-74.818c0.822-4.035,1.491-8.122,2.424-12.047c1.791-7.541,3.793-15.031,5.975-22.468
      c4.37-14.899,9.461-29.582,15.007-44.082c5.637-14.735,11.454-29.389,17.622-43.911c5.912-13.921,12.142-28.214,16.351-42.746
      l-0.169-0.071c-8.657,13.242-15.705,28.057-22.239,42.443c-6.363,14.009-12.62,28.106-18.147,42.47
      c-5.576,14.492-10.692,29.166-15.096,44.058c-1.444,4.883-2.779,9.798-4.059,14.728c-1.28-10.241-2.792-20.466-4.614-30.671
      c-3.341-18.718-7.454-37.267-11.805-55.765c2.04-6.005,2.421-12.892,3.572-18.997c1.547-8.209,3.438-16.351,5.622-24.414
      c4.383-16.18,9.943-32.026,16.234-47.557c12.925-31.904,28.333-62.878,42.252-94.322c0.259-0.583-0.523-1.079-0.875-0.511
      c-18.213,29.488-34.754,59.476-47.89,91.668c-6.499,15.927-12.232,32.181-16.736,48.788c-2.302,8.485-4.28,17.063-5.867,25.711
      c-0.139,0.758-0.292,1.536-0.445,2.32c-3.595-14.865-7.241-29.719-10.732-44.606c-2.924-12.466-5.596-24.983-8.159-37.521
      c1.187-39.709,9.39-78.162,23.063-115.428c13.683-37.296,32.481-72.22,48.488-108.479c0.423-0.958-0.843-1.755-1.431-0.836
      c-21.56,33.681-39.754,69.975-53.825,107.45c-10.65,28.366-18.891,58.288-21.865,88.623c-3.003-16.323-5.801-32.685-8.321-49.097
      c-3.582-23.328-6.735-46.712-9.713-70.12c1.718-7.247,1.232-15.282,1.99-22.629c0.994-9.627,2.491-19.166,4.555-28.622
      c3.792-17.385,9.218-34.376,15.498-51.011c6.664-17.654,14.223-34.948,21.674-52.279c7.005-16.292,15.097-32.946,18.496-50.439
      c0.172-0.884-1.027-1.498-1.515-0.638c-9.349,16.469-15.982,34.715-23.618,52.03c-7.44,16.868-14.915,33.734-21.539,50.943
      c-6.55,17.019-12.328,34.394-16.301,52.208c-1.325,5.942-2.379,11.95-3.272,17.98c-5.076-41.888-9.832-83.82-15.419-125.642
      c2.015-4.968,1.891-10.279,2.446-15.629c0.79-7.603,1.779-15.176,3.185-22.69c2.449-13.092,5.997-25.926,10.06-38.603
      c8.464-26.405,19.945-51.808,26.645-78.754l-0.841-0.355c-12.235,25.515-22.7,52.033-31.647,78.884
      c-4.478,13.438-8.4,27.116-11.2,41.008c-0.645,3.201-1.465,6.827-2.206,10.596c-4.654-32.408-9.948-64.728-16.439-96.821
      c0.199-1.09,0.37-2.211,0.549-3.397c0.78-5.176,1.561-10.353,2.34-15.53c1.45-9.626,2.735-19.276,4.074-28.917
      c2.695-19.418,5.952-38.868,6.445-58.48c0.018-0.731-1.075-0.87-1.266-0.171c-5.313,19.416-7.821,39.505-10.913,59.382
      c-1.493,9.605-3.015,19.206-4.396,28.827c-0.087,0.601-0.173,1.201-0.259,1.802c-4.137-18.781-8.927-37.433-14.195-55.923
      c-5.82-20.427-11.533-41.201-20.893-60.312c-0.558-1.141-2.219-0.314-1.969,0.829c8.299,37.796,20.855,74.562,28.834,112.554
      c1.976,9.411,3.874,18.833,5.697,28.267c-4.027-7.954-8.556-15.593-12.776-22.681c-12.308-20.679-25.989-40.745-40.967-59.565
      l-0.506,0.39c10.772,21.118,23.861,40.8,35.777,61.274c5.499,9.449,10.665,19.113,15.061,29.13
      c3.524,8.032,6.248,16.371,9.452,24.515c3.078,17.705,5.919,35.452,8.469,53.259c2.89,20.187,5.516,40.408,8.019,60.644
      c-1.605-2.938-3.222-5.819-4.703-8.605c-5.536-10.413-11.449-20.627-17.726-30.611c-12.279-19.532-25.786-38.251-41.599-55.081
      c-0.63-0.67-1.863,0.23-1.302,1.004c13.409,18.473,26.725,37.075,38.448,56.68c5.698,9.53,11.065,19.258,16.083,29.163
      c4.49,8.863,8.038,18.994,13.247,27.611c5.01,41.695,9.721,83.429,15.183,125.067c-0.569-1.24-1.1-2.496-1.676-3.732
      c-5.623-12.064-11.559-24.001-17.914-35.697c-6.164-11.342-12.809-22.442-19.679-33.369c-6.58-10.464-13.564-21.675-22.332-30.471
      l-0.506,0.391c5.156,11.706,12.59,22.67,19.037,33.704c6.317,10.811,12.262,21.817,18.063,32.911
      c5.801,11.094,11.379,22.293,16.611,33.668c2.699,5.87,5.319,11.777,7.851,17.721c1.249,2.933,2.357,5.905,3.748,8.706
      c0.215,1.538,0.403,3.08,0.621,4.618c3.396,23.996,7.216,47.937,11.541,71.786c-3.425-4.77-6.975-9.451-10.673-14.012
      c-8.013-9.882-16.68-19.01-26.061-27.491c-1.159,0.393-2.305,0.813-3.494,1.125c8.177,9.329,16.198,18.84,23.796,28.627
      c4.547,5.857,8.835,11.904,13.096,17.969c2.029,2.889,4.061,5.794,5.749,8.899c0.242,0.443,0.427,0.927,0.629,1.4
      c1.729,8.936,3.527,17.859,5.445,26.758c6.511,30.213,14.247,60.144,21.263,90.242c-2.314-3.686-4.701-7.327-7.239-10.862
      c-7.657-10.662-16.422-20.373-26.698-28.565c-1.11-0.885-2.478,0.453-1.563,1.563c8.244,10.007,16.353,20.186,23.627,30.929
      c3.547,5.238,6.853,10.638,9.914,16.174c1.531,2.768,3.059,5.538,4.503,8.354c0.799,1.558,1.489,3.046,2.38,4.39
      c0.375,1.733,0.796,3.457,1.163,5.192c4.642,21.965,7.869,43.987,10.204,66.057c0.985,0.82,1.924,1.719,2.802,2.717
      c0.878,0.997,1.719,2.053,2.476,3.237c1.278,2,2.228,4.152,2.9,6.369c1.643,5.423,1.42,11.275-1.181,16.558
      c-1.08,2.192-2.466,4.124-4.015,5.901c2.962,43.857,3.279,87.898,4.493,132.087C800.998,1138.06,801.382,1137.923,801.805,1137.904
      z"/>
    <path style={{ fill:"#197944" }} d="M761.956,924.965l-0.651,0.502c2.92,5.625,5.719,11.253,8.828,16.778
      c3,5.333,6.038,10.658,8.899,16.068c1.332,2.52,2.477,5.134,3.721,7.7c2.98,0.778,5.807,2.007,8.375,3.745
      c-2.167-4.661-4.521-9.223-7.104-13.679C777.568,944.943,770.074,934.909,761.956,924.965z"/>
    <path style={{ fill:"#197944" }} d="M803.073,1195.237c0.884,13.407,2.058,26.906,3.656,40.385c1.007,8.503,2.185,16.993,3.568,25.445
      c1.429,8.74,3.067,17.436,4.973,26.052c3.63,16.399,8.186,32.511,13.953,48.092h8.605c-15.796-45.814-23.9-93.285-27.391-142.213
      C808.164,1194.201,805.632,1194.999,803.073,1195.237z"/>
  </g>
</svg>

  );
};

const FigmaBook = ({
  title = "",
  width = 200,
  height = 250,
  color = "#fff"
}) => {
return (
<svg 
 width={width}
      height={height}
  viewBox="0 0 197 52" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg">
<path d="M189.98 51.9995H7.79856C4.00712 51.9995 0.887573 48.9279 0.887573 45.0885V7.51008C0.887573 3.71864 3.95913 0.599121 7.79856 0.599121H189.98C193.771 0.599121 196.891 3.67065 196.891 7.51008V45.0885C196.891 48.8799 193.819 51.9995 189.98 51.9995Z" fill="#7A6D18"/>
<path d="M190.511 46.1446V6.07056L165.651 6.07056V46.1446H190.511Z" fill="#F29104"/>
<path d="M160.419 46.1446V6.07056L135.559 6.07056V46.1446H160.419Z" fill="#F29104"/>
<path opacity="0.2" d="M3.5751 12.8614C3.5751 10.7977 5.25488 9.11792 7.31857 9.11792H191.035C193.099 9.11792 194.779 10.7977 194.779 12.8614C194.779 14.9251 193.099 16.6048 191.035 16.6048H7.31857C5.25488 16.6048 3.5751 14.9251 3.5751 12.8614Z" fill="white" fill-opacity="0.73"/>
</svg>

  );
};

const FigmaBook1 = ({
  title = "",
  width = 200,
  height = 250,
  color = "#fff"
}) => {
return (
<svg 
 width={width}
      height={height}
  viewBox="0 0 197 52" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg">
    <path d="M21.5357 27.5001C21.7277 42.4739 3.8743 50.0088 3.8743 50.0088H175.305C188.215 50.0088 198.677 39.5463 198.677 26.6362C198.677 13.7261 188.215 3.26367 175.305 3.26367H3.8743C3.8743 3.26367 21.3437 12.3823 21.5357 27.4521V27.5001Z" fill="#F4DDBD"/>
<path d="M3.87426 0H175.305C189.991 0 201.941 11.9502 201.941 26.6361C201.941 41.3219 189.991 53.2721 175.305 53.2721H3.87426C2.05053 53.2721 0.610718 51.7843 0.610718 50.0086C0.610718 48.2329 2.09852 46.7451 3.87426 46.7451H175.305C186.391 46.7451 195.366 37.7224 195.366 26.684C195.366 15.6457 186.343 6.62301 175.305 6.62301H3.87426C2.05053 6.62301 0.610718 5.13524 0.610718 3.3595C0.610718 1.58377 2.09852 0.0959916 3.87426 0.0959916V0Z" fill="#7A6D18"/>
<path d="M22.2556 34.123H187.303C187.447 34.123 187.543 34.219 187.543 34.363C187.543 34.507 187.447 34.603 187.303 34.603H22.2556C22.1116 34.603 22.0156 34.507 22.0156 34.363C22.0156 34.219 22.1116 34.123 22.2556 34.123Z" fill="#CABAA0"/>
<path d="M23.5514 23.3726H135.231C135.375 23.3726 135.471 23.4685 135.471 23.6125C135.471 23.7565 135.375 23.8525 135.231 23.8525H23.5514C23.4074 23.8525 23.3114 23.7565 23.3114 23.6125C23.3114 23.4685 23.4074 23.3726 23.5514 23.3726Z" fill="#CABAA0"/>
<path d="M90.5494 17.1814H191.431C191.575 17.1814 191.67 17.2774 191.67 17.4214C191.67 17.5653 191.575 17.6613 191.431 17.6613H90.5494C90.4055 17.6613 90.3095 17.5653 90.3095 17.4214C90.3095 17.2774 90.4055 17.1814 90.5494 17.1814Z" fill="#CABAA0"/>
<path d="M57.1464 28.7H152.412C152.556 28.7 152.652 28.7959 152.652 28.9399C152.652 29.0839 152.556 29.1799 152.412 29.1799H57.1464C57.0024 29.1799 56.9064 29.0839 56.9064 28.9399C56.9064 28.7959 57.0024 28.7 57.1464 28.7Z" fill="#CABAA0"/>
<path d="M18.4162 12.6704H104.755C104.899 12.6704 104.995 12.7664 104.995 12.9104C104.995 13.0544 104.899 13.1503 104.755 13.1503H18.4162C18.2722 13.1503 18.1762 13.0544 18.1762 12.9104C18.1762 12.7664 18.2722 12.6704 18.4162 12.6704Z" fill="#CABAA0"/>
<path d="M50.3794 41.1301H167.914C168.058 41.1301 168.154 41.2261 168.154 41.3701C168.154 41.5141 168.058 41.6101 167.914 41.6101H50.3794C50.2354 41.6101 50.1394 41.5141 50.1394 41.3701C50.1394 41.2261 50.2354 41.1301 50.3794 41.1301Z" fill="#CABAA0"/>
</svg>
  );
};

const FigmaBook2 = ({
  title = "",
  width = 200,
  height = 250,
  color = "#fff"
}) => {
return (
<svg 
 width={width}
      height={height}
  viewBox="0 0 197 52" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg">
<path d="M180.405 26.172C180.213 11.1982 198.067 3.66333 198.067 3.66333H26.6361C13.726 3.66333 3.26361 14.1258 3.26361 27.0359C3.26361 39.946 13.726 50.4084 26.6361 50.4084H198.067C198.067 50.4084 180.597 41.2898 180.405 26.22V26.172Z" fill="#F4DDBD"/>
<path d="M198.067 53.6718H26.6361C11.9502 53.6718 0 41.7215 0 27.0357C0 12.3499 11.9502 0.399658 26.6361 0.399658H198.067C199.89 0.399658 201.33 1.88743 201.33 3.66317C201.33 5.43891 199.842 6.92671 198.067 6.92671H26.6361C15.5497 6.92671 6.575 15.9494 6.575 26.9877C6.575 38.0261 15.5977 47.0488 26.6361 47.0488H198.067C199.89 47.0488 201.33 48.5365 201.33 50.3123C201.33 52.088 199.842 53.5758 198.067 53.5758V53.6718Z" fill="#7A6D18"/>
<path d="M179.685 19.5493H14.6379C14.4939 19.5493 14.3979 19.4533 14.3979 19.3093C14.3979 19.1653 14.4939 19.0693 14.6379 19.0693H179.685C179.829 19.0693 179.925 19.1653 179.925 19.3093C179.925 19.4533 179.829 19.5493 179.685 19.5493Z" fill="#CABAA0"/>
<path d="M178.39 30.299H66.7101C66.5662 30.299 66.4702 30.203 66.4702 30.0591C66.4702 29.9151 66.5662 29.8191 66.7101 29.8191H178.39C178.534 29.8191 178.63 29.9151 178.63 30.0591C178.63 30.203 178.534 30.299 178.39 30.299Z" fill="#CABAA0"/>
<path d="M111.392 36.4904H10.5105C10.3665 36.4904 10.2705 36.3944 10.2705 36.2505C10.2705 36.1065 10.3665 36.0105 10.5105 36.0105H111.392C111.535 36.0105 111.631 36.1065 111.631 36.2505C111.631 36.3944 111.535 36.4904 111.392 36.4904Z" fill="#CABAA0"/>
<path d="M144.795 25.02H49.5287C49.3847 25.02 49.2887 24.924 49.2887 24.78C49.2887 24.636 49.3847 24.54 49.5287 24.54H144.795C144.939 24.54 145.035 24.636 145.035 24.78C145.035 24.924 144.939 25.02 144.795 25.02Z" fill="#CABAA0"/>
<path d="M183.525 41.0498H97.1857C97.0417 41.0498 96.9457 40.9538 96.9457 40.8098C96.9457 40.6658 97.0417 40.5698 97.1857 40.5698H183.525C183.669 40.5698 183.765 40.6658 183.765 40.8098C183.765 40.9538 183.669 41.0498 183.525 41.0498Z" fill="#CABAA0"/>
<path d="M151.562 12.5422H34.027C33.883 12.5422 33.787 12.4462 33.787 12.3022C33.787 12.1582 33.883 12.0623 34.027 12.0623H151.562C151.706 12.0623 151.802 12.1582 151.802 12.3022C151.802 12.4462 151.706 12.5422 151.562 12.5422Z" fill="#CABAA0"/>
<path d="M45.8333 31.0191L39.7862 25.8359L33.787 31.0191V18.9729H45.8333V31.0191Z" fill="#BE1823"/>
</svg>
  );
};

const FigmaBook3 = ({
  title = "",
  width = 400,
  height = 250,
  color = "#fff"
}) => {
return (
<svg 
 width={width}
      height={height}
  viewBox="0 0 135 1" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg">
<path d="M34.7279 0H5.2721C2.3604 0 0 1.4062 0 3.14083V96.8592C0 98.5938 2.3604 100 5.2721 100H34.7279C37.6396 100 40 98.5938 40 96.8592V3.14083C40 1.4062 37.6396 0 34.7279 0Z" fill="#D79917"/>
<path d="M35 1.75586H6V4.097H35V1.75586Z" fill="#841625"/>
<path d="M35 6.43823H6V8.77937H35V6.43823Z" fill="#841625"/>
<path d="M20.8504 62.6342C26.2041 62.6342 30.5442 55.7483 30.5442 47.2542C30.5442 38.7601 26.2041 31.8743 20.8504 31.8743C15.4966 31.8743 11.1565 38.7601 11.1565 47.2542C11.1565 55.7483 15.4966 62.6342 20.8504 62.6342Z" stroke="#D79917" stroke-width="1.36054" stroke-miterlimit="10"/>
<path opacity="0.2" d="M10 98.3278C8.34118 98.3278 7 97.544 7 96.5746V1.75328C7 0.783818 8.34118 0 10 0C11.6588 0 13 0.783818 13 1.75328V96.5746C13 97.544 11.6588 98.3278 10 98.3278Z" fill="white"/>
</svg>

  );
};

const FigmaBook4 = ({
  title = "",
  width = 400,
  height = 250,
  color = "#fff"
}) => {
return (
<svg 
 width={width}
      height={height}
  viewBox="0 0 135 1" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg">
<path d="M74.7884 87.4537L48.8201 101.526C46.9172 102.562 44.5666 101.842 43.5368 99.9277L0.666628 19.8601C-0.363152 17.9462 0.353238 15.582 2.25609 14.5463L28.2245 0.473689C30.1273 -0.562055 32.4779 0.15843 33.5076 2.07231L76.3778 82.1399C77.4076 84.0537 76.6913 86.418 74.7884 87.4537Z" fill="#7F4F25"/>
<path d="M26.351 4.77358L8.14602 14.6327C6.51268 15.5173 5.92076 17.602 6.82394 19.2891L9.59523 24.4658C10.4984 26.1529 12.5546 26.8034 14.188 25.9189L32.393 16.0597C34.0264 15.1752 34.6183 13.0904 33.7151 11.4033L30.9438 6.2267C30.0406 4.5396 27.9844 3.88902 26.351 4.77358Z" fill="#F8B133"/>
<path d="M69.9979 82.0048L46.5144 94.7264C45.5966 95.2218 44.4324 94.8841 43.9175 93.9384C43.425 93.0152 43.7608 91.8444 44.7011 91.3265L68.1846 78.6049C69.1024 78.1095 70.2665 78.4473 70.7814 79.393C71.2739 80.3161 70.9381 81.4869 69.9979 82.0048Z" fill="#F8B133"/>
</svg>

  );
};

const FigmaBook5 = ({
  title = "",
  width = 400,
  height = 250,
  color = "#fff"
}) => {
return (
<svg 
 width={width}
      height={height}
  viewBox="0 0 135 1" 
  fill="none" 
  xmlns="http://www.w3.org/2000/svg">
<path d="M39.9616 0H0V99.7753H39.9616V0Z" fill="#2A3180"/>
<path d="M33.622 96.8555H5.59578C4.36783 96.8555 3.3927 96.2742 3.3927 95.5891C3.3927 94.8833 4.40395 94.3228 5.59578 94.3228H33.622C34.8499 94.3228 35.8251 94.904 35.8251 95.5891C35.8251 96.295 34.8138 96.8555 33.622 96.8555Z" fill="#F7C26D"/>
<path d="M33.622 5.65632H5.59578C4.36783 5.65632 3.3927 5.07501 3.3927 4.38991C3.3927 3.68406 4.40395 3.12354 5.59578 3.12354H33.622C34.8499 3.12354 35.8251 3.70482 35.8251 4.38991C35.8251 5.09577 34.8138 5.65632 33.622 5.65632Z" fill="#F7C26D"/>
<path opacity="0.2" d="M8.19977 0H7.43776C6.56864 0 5.86407 0.99029 5.86407 2.21187V97.7881C5.86407 99.0097 6.56864 100 7.43776 100H8.19977C9.06889 100 9.77345 99.0097 9.77345 97.7881V2.21187C9.77345 0.99029 9.06889 0 8.19977 0Z" fill="white" fill-opacity="0.62"/>
</svg>
  );
};

const getBookColor = (cat) => {
  switch (cat) {
    case "science":     return { color: "#963A26", stroke: "#307D54" };
    case "history":     return { color: "#963A26", stroke: "#c22ba7" };
    case "bio":         return { color: "#963A26", stroke: "#246ec4" };
    case "math":        return { color: "#963A26", stroke: "#d3a110" };
    case "literature":  return { color: "#963A26", stroke: "#b67fc2" };
    default:            return { color: "#963A26", stroke: "#bfa46b" };
  }
};

const BOOK_WIDTH = 95; // عرض هر کتاب در بانک
const VISIBLE_COUNT = 3.5; // تعداد کتاب‌های قابل مشاهده

// درگبل: کتاب
function DraggableBook({ id, children }) {
const { attributes, listeners, setNodeRef, isDragging } = useDraggable({ id });


    // console.log("DraggableBook rendered:", id);
  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
          // onPointerDown={() => setActiveDragItem(item)} // این خط رو اضافه کن
      style={{
        minWidth: BOOK_WIDTH,
        maxWidth: BOOK_WIDTH,
        height: 130,
        cursor: isDragging ? "grabbing" : "grab",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: isDragging ? 0.4 : 1,
        gap: 8,
        touchAction: "none",
        userSelect: "none",
        zIndex: isDragging ? 50 : "auto"
      }}
      tabIndex={-1}
      draggable={false}
    >
      {children}
    </div>
  );
}




function BookBankCarousel({ bookBank, onDragStart }) {
  const [index, setIndex] = useState(0);

  // محاسبه حداکثر ایندکسی که کروسل می‌تواند داشته باشد
  const maxIndex = Math.max(0, bookBank.length - Math.ceil(VISIBLE_COUNT));

  const handleLeft = () => setIndex(i => Math.max(i - 1, 0));
  const handleRight = () => setIndex(i => Math.min(i + 1, maxIndex));

return (
  <div style={{
    display: "flex",
    alignItems: "center",
    userSelect: "none",
    justifyContent: 'space-between',
    width: '100%',
    margin: "0 auto",
    position: "relative",
    direction: "ltr"
  }}>
    {/* دکمه چپ */}
    <button
      onClick={handleLeft}
      disabled={index === 0}
      style={{
        width: 32, height: 70, border: "none", background: "none", cursor: "pointer", fontSize: 24, color: "#888"
      }}
    >
      ‹
    </button>
    {/* کانتینر اصلی که کتاب‌ها را مخفی می‌کند */}
    <div
      style={{
        flex: 1,
        overflow: "hidden",
        width: BOOK_WIDTH * VISIBLE_COUNT,
        height: 130,
        margin: '0 10px'
      }}
    >
      {/* کانتینر داخلی که با transform حرکت می‌کند */}
      <div
        style={{
          display: "flex",
          transition: "transform 0.25s ease-out",
          transform: `translateX(-${index * (BOOK_WIDTH + 8)}px)`,
          gap: 8,
          
          paddingTop: 4
        }}
      >
{bookBank.slice(index, index + VISIBLE_COUNT).map((item) => {
  // کلمه‌ها را جدا می‌کنیم
  const parts = item.title.split(" ");
  // اگر دقیقاً دو کلمه باشد، با \n به دو خط تبدیل می‌کنیم
  const twoLineTitle = parts.length === 2
    ? `${parts[0]}\n${parts[1]}`
    : item.title;

  return (
    <DraggableBook id={item.id} key={item.id} onDragStart={onDragStart}>
      <BookIconCartoon
        title={twoLineTitle}
        width={90}
        height={120}
      />
    </DraggableBook>
  );
})}


      </div>
    </div>
    {/* دکمه راست */}
    <button
      onClick={handleRight}
      disabled={index === maxIndex}
      style={{
        width: 32, height: 70, border: "none", background: "none", cursor: "pointer", fontSize: 24, color: "#888"
      }}
    >
      ›
    </button>
  </div>
);

}



// --- هوک سفارشی برای تشخیص عرض صفحه ---
const useMediaQuery = (query) => {
  const [matches, setMatches] = React.useState(false);

  React.useEffect(() => {
    // در اولین رندر، وضعیت را بررسی می‌کنیم
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    
    // یک listener برای تغییرات اندازه صفحه اضافه می‌کنیم
    const listener = () => setMatches(media.matches);
    media.addEventListener('change', listener);
    
    // در زمان unmount شدن کامپوننت، listener را حذف می‌کنیم تا از memory leak جلوگیری شود
    return () => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
};


export default function BookshelfFullSVGWithTimer() {
	const sensors = useSensors(
 useSensor(PointerSensor, { activationConstraint: { distance: 10 } }),
  useSensor(TouchSensor,  { activationConstraint: { delay: 180, tolerance: 6 } })
);
  const isMobile = useMediaQuery('(max-width: 768px)'); 
  const [shelves, setShelves] = useState(initialShelves);
 // بیرون از رندر تکراری نباشه (یا داخل useState initializer)
const [bank, setBank] = useState(() => {
  // 1) اسلات‌های خالی رو از initialShelves دربیار
  const holes = initialShelves.flat().filter(c => !c.book && !c.fixed);

  // 2) بانک رو بساز (به جای pickBookFor از همون منطق خودت برای book/title/... استفاده کن)
  const arr = holes.map(h => ({
    id: 'bank-' + h.id,
    slotId: h.id,
    book: /* اینجا چیزی که قبلاً می‌ذاشتی */ h.expectedBookComponent ?? <DefaultBook />,
    // title: h.title ?? '',
  }));

  // 3) شافل فیشر-یتس
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }

  return arr;
});

  const [carouselIndex, setCarouselIndex] = useState(0);
  const visibleCount = 3;

const slideLeft = () => setCarouselIndex(i => Math.max(0, i - 1));
const slideRight = () => setCarouselIndex(i => Math.min(bank.length - visibleCount, i + 1));

const [activeDragItem, setActiveDragItem] = useState(null);


  const [dragItem, setDragItem] = useState(null);
  const [highlighted, setHighlighted] = useState({row: null, col: null});
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(30);
  const [started, setStarted] = useState(false);
  const [chances, setChances] = useState(0);
  const [lastPlay, setLastPlay] = useState(null);
  const [loading, setLoading] = useState(true);
  const [finished, setFinished] = useState(false);

  const [rank, setRank] = useState(1);
  const [totalPlayers, setTotalPlayers] = useState(1);
  const [referralCode, setReferralCode] = useState(null);
  const [inputReferral, setInputReferral] = useState("");
  const [referralMsg, setReferralMsg] = useState("");
  const [notLoggedIn, setNotLoggedIn] = useState(false);
  const [books, setBooks] = useState([]);

  const [displayName, setDisplayName] = useState("");
  const [displayNameMsg, setDisplayNameMsg] = useState("");
  const [hasDisplayName, setHasDisplayName] = useState(false);

  const [showTextPopup, setShowTextPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [loginPolling, setLoginPolling] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [topScore, setTopScore] = useState(0);
  const [totalScore, setTotalScore] = useState(0);

  const getSpineFontSize = (title) => {
    if (!title) return 9;
    if (title.length <= 7) return 14;
    if (title.length <= 14) return 11;
    return 8;
  }
// function handleShareImage() {
//   const canvas = document.createElement("canvas");
//   const width = 620, height = 380;
//   canvas.width = width;
//   canvas.height = height;
//   const ctx = canvas.getContext("2d");

//   // بکگراند
//   ctx.fillStyle = "#fff9e3";
//   ctx.fillRect(0, 0, width, height);

//   // تیتر
//   ctx.font = "bold 26px Vazirmatn, IRANSans, Tahoma";
//   ctx.fillStyle = "#ad8300";
//   ctx.textAlign = "center";
//   ctx.fillText("مسابقه بزرگ مستر بوک زبان مهر", width / 2, 60);

//   // نام نمایشی
//   ctx.font = "22px Vazirmatn, IRANSans, Tahoma";
//   ctx.fillStyle = "#4a3700";
//   ctx.textAlign = "right";
//   ctx.fillText(`من ${displayName} با کد معرف ${referralCode}`, width - 40, 140);

//   // متن دعوت
//   ctx.font = "18px Vazirmatn, IRANSans, Tahoma";
//   ctx.fillStyle = "#805e29";
//   ctx.fillText("شما را به شرکت در این مسابقه دعوت می‌کنم.", width - 40, 190);

//   // لینک
//   ctx.font = "bold 17px monospace";
//   ctx.fillStyle = "#3d81d5";
//   ctx.fillText("لینک: www.zabanmehrpub.com", width - 40, 270);

//   // آیکن کتاب یا تزئینی هم می‌تونی اضافه کنی (اختیاری)

//   // تبدیل به عکس و دانلود
//   canvas.toBlob(function(blob) {
//     const link = document.createElement("a");
//     link.download = "zabanmehr-share.png";
//     link.href = URL.createObjectURL(blob);
//     link.click();
//   }, "image/png");
// }


function ShelfDraggable({ id, children }) {
  const { setNodeRef, listeners, attributes, isDragging } = useDraggable({ id });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{
        width: 38,
        height: 74,
        cursor: isDragging ? "grabbing" : "grab",
        touchAction: "none",      // برای موبایل حیاتی است
        userSelect: "none",
        zIndex: isDragging ? 60 : 2,
      }}
    >
      {children}
    </div>
  );
}

function handleShareImage() {
  if (!totalPlayers || totalPlayers <= 0) return;
  if (!topScore || topScore === 0) { alert('خطا: امتیاز برتر نامشخص است'); return; }

const pct = totalScore / topScore; // عددی بین 0 تا 1
let fileName;

if (pct === 1) {
  // دقیقاً امتیاز برتر
  fileName = 'share1.jpg';
} else if (pct > 0.75 && pct < 1) {
  // بین 75% تا کمتر از 100%
  fileName = 'share1.jpg';
} else if (pct > 0.50 && pct <= 0.75) {
  // بین بیش از 50% تا 75%
  fileName = 'share2.jpg';
} else if (pct > 0.25 && pct <= 0.50) {
  // بین بیش از 25% تا 50%
  fileName = 'share3.jpg';
} else {
  // 0% تا 25%
  fileName = 'share4.jpg';
}


  const imgUrl =
    window.location.origin +
    '/wp-content/plugins/gamify-library-ui-bookshelf-pro/' +
    fileName;

  const link = document.createElement('a');
  link.href = imgUrl;
  link.download = `bookmaster_score_${score}_of_${topScore}.jpg`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


function handleDisplayNameSubmit(e) {
  e.preventDefault();
  fetch('/wp-admin/admin-ajax.php?action=bookshelf_set_display_name', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({ display_name: displayName })
  })
    .then(r => r.json())
    .then(json => {
      if (json.success) {
        setHasDisplayName(true); // فرم را پنهان کن و دکمه شروع را نمایش بده
        setDisplayName(''); // اگر خواستی اینپوت را پاک کن
        setDisplayNameMsg("نام ثبت شد!");
      } else if (json.data && json.data.msg) {
        setDisplayNameMsg(json.data.msg);
      } else {
        setDisplayNameMsg("خطای ثبت!");
      }
    });
}



useEffect(() => {
  function onDigitsLoginMsg(e) {
   if (
     e.origin === 'https://zabanmehrpub.com' &&
     e.data?.success &&
     (
       e.data.type === "digits_login" ||
       e.data.type === "digits_signup"
     )
   ) {
      // بستن مودال و polling
      setLoginModalOpen(false);
      setLoginPolling(false);

      // 1. ساخت و نمایش overlay
      const overlay = document.createElement('div');
      Object.assign(overlay.style, {
        position: 'fixed',
        top: 0, left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        color: '#fff',
        fontSize: '1.5rem',
        fontFamily: 'sans-serif',
        textAlign: 'center',
        padding: '1rem'
      });
      overlay.id = 'bs_loading_overlay';
      overlay.innerText = 'در حال بارگذاری… لطفاً صبر کنید';
      document.body.appendChild(overlay);

      // 2. کمی تأخیر بده تا overlay رندر بشه
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }

  window.addEventListener('message', onDigitsLoginMsg);
  return () => window.removeEventListener('message', onDigitsLoginMsg);
}, []);


useEffect(() => {
  // هر وقت دیجیتس لاگین کرد، این فانکشن اجرا میشه
function onDigitsLogin() {
  fetchStatus();
  setLoginModalOpen(false);   // پاپ‌آپ رو ببند
  setLoginPolling(false);  
   window.location.reload();   // polling قطع بشه
}

  window.addEventListener('digits_login', onDigitsLogin);

  // پاک‌سازی زمانی که کامپوننت حذف شد
  return () => window.removeEventListener('digits_login', onDigitsLogin);
}, []);

function fetchStatus() {
  fetch('/wp-admin/admin-ajax.php?action=bookshelf_get_status')
    .then(res => res.json())
    .then(json => {
      if (json.success) {
        setScore(json.data.score);
        setChances(json.data.chances);
        setLastPlay(json.data.last_play);
        setNotLoggedIn(!!json.data.not_logged_in);
        setReferralCode(json.data.referral_code);
        setDisplayName(json.data.display_name || "");
        setHasDisplayName(!!json.data.display_name);
        setRank(json.data.rank);
        setTotalPlayers(json.data.total);
         setTotalScore(json.data.score);
          setTopScore(json.data.top_score);
      }
      setLoading(false);
    });
}

function handleOpenLoginPopup() {
  setLoginModalOpen(true);
  setLoginPolling(true);
}

useEffect(() => {
  fetchStatus();
}, []);

useEffect(() => {
  let interval = null;
  if (loginPolling) {
    interval = setInterval(() => {
      fetchStatus();
    }, 500); // هر 1.5 ثانیه
  }
  // اگر کاربر لاگین شد، polling متوقف شود:
  if (!notLoggedIn && loginPolling) {
    setLoginModalOpen(false);
    setLoginPolling(false);
     window.location.reload();
  }
  return () => clearInterval(interval);
}, [loginPolling, notLoggedIn]);


const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};


useEffect(() => {
  fetch('/wp-admin/admin-ajax.php?action=bookshelf_get_random_books')
    .then(r => r.json())
    .then(json => {
      if (!json.success || !Array.isArray(json.data)) return;

      const booksFromServer = json.data;   // 5 دسته

      /* ---------- 1) تولید قفسه‌ها ---------- */
      const shelvesCopy = booksFromServer.map((cat, rowIdx) => {

        // جداکردن کتاب slot و کتاب‌های ثابت
        const slotBook   = cat.books.find(b => b.slot);
        const fixedBooks = cat.books.filter(b => !b.slot);   // طول = 4

        // ایندکس برای حرکت روی fixedBooks
        let fixedIdx = 0;

        return initialShelves[rowIdx].map(cell => {

          /* خانهٔ ثابت → یکی از چهار کتابِ fixedBooks به‌ترتیب */
          if (cell.fixed) {
            const b = fixedBooks[fixedIdx++];     // به‌محض استفاده جلو می‌رود
            return {
              ...cell,
              book : getBookSVG(cat.category, b.id),
              title: b.title,
              label: cat.category
            };
          }

          /* خانهٔ droppable (= اسلات) → خالی ولی جوابِ صحیح را نگه می‌داریم */
          return {
            ...cell,
            book          : null,
            title         : '',
            label         : cat.category,
            expectedTitle : slotBook.title,
            expectedLabel : cat.category
          };
        });
      });
      setShelves(shelvesCopy);

      /* ---------- 2) ساخت بانک پایین ---------- */
      const newBank = booksFromServer.flatMap(cat =>
        cat.books
          .filter(b => b.slot)                 // فقط همان یک کتاب هر ردیف
          .map(b => ({
            id   : b.id,
            title: b.title,
            label: cat.category,
            book : getBookSVG(cat.category, b.id)
          }))
      );

for (let i = newBank.length - 1; i > 0; i--) {
  const j = Math.floor(Math.random() * (i + 1));
  [newBank[i], newBank[j]] = [newBank[j], newBank[i]];
}

      setBank(newBank);

      /* ---------- 3) ذخیره در state ---------- */
      setBooks(booksFromServer);
    });
}, []);



const getBookSVG = (category, id) => {
  const key = category.toLowerCase();
  const variants = categoryComponentMap[key];
  if (variants && variants.length > 0) {
    const idx = simpleHash(id) % variants.length;
    // اینجا باید prop ها رو پاس بدی:
    const Comp = variants[idx];
    return <Comp id={id} category={category} />;
  }

  const cat = category.toLowerCase();

  if (cat.includes('science'))    return <ScienceBook2 id={id} category={category} />;
  if (cat.includes('history'))    return <HistoryBook3 id={id} category={category} />;
  if (cat.includes('bio'))        return <BioBook id={id} category={category} />;
  if (cat.includes('math'))       return <MathBook3 id={id} category={category} />;
  if (cat.includes('literature')) return <LiteratureBook4 id={id} category={category} />;

  // پنج دسته‌ی جدید سرور:
  if (cat.includes('classic'))    return <LiteratureBook4 id={id} category={category} />;
  if (cat.includes('poetry'))     return <LiteratureBook2 id={id} category={category} />;
  if (cat.includes('self-help'))  return <BioBook4 id={id} category={category} />;
  if (cat.includes('psychology')) return <BioBook3 id={id} category={category} />;
  if (cat.includes('fiction'))    return <LiteratureBook5 id={id} category={category} />;

  return <DefaultBook id={id} category={category} />;
};



    // Drop کتاب روی اسلات
function handleDrop(rowIdx, colIdx) {
  if (!dragItem || !started || finished) return;
  // if (shelves[rowIdx][colIdx].book) return;

  // از قفسه به قفسه
  if (dragItem.from === 'shelf') {
    setShelves(prev => prev.map((row, i) =>
      row.map((cell, j) => {
        if (i === rowIdx && j === colIdx) {
          // اینجا book و title را منتقل کن
          return { ...cell, book: dragItem.book, title: dragItem.title, label: dragItem.label, fixed: false };
        }
        if (i === dragItem.row && j === dragItem.col) {
          // سلول قبلی خالی بشه (title هم خالی!)
          return { ...cell, book: null, title: "", fixed: false };
        }
        return cell;
      })
    ));
  }
  // از بانک به قفسه
  else if (dragItem.from === 'bank') {
    setShelves(prev => prev.map((row, i) =>
      row.map((cell, j) =>
        (i === rowIdx && j === colIdx)
          ? { ...cell, book: dragItem.book, title: dragItem.title, label: dragItem.label, fixed: false }
          : cell
      )
    ));
    setBank(prev => prev.filter(b => b.id !== dragItem.id));
  }
  setDragItem(null);
  setHighlighted({ row: null, col: null });
}



function renderRow(row, rowIdx, label) {
  return (
<div
  key={rowIdx}
  style={{
    display: "flex",
    alignItems: "flex-end",
    gap: isMobile ? 4 : 12, // فاصله کمتر برای موبایل
    marginBottom: 10,
    position: "relative",
    height: isMobile ? 90 : 80, // یا حتی auto
    direction: "ltr",
    flexWrap: "wrap", // حتما اضافه کن!
    minHeight: isMobile ? 90 : 80, // ارتفاع حداقلی برای موبایل
    width: "100%"
  }}
>

      <div
        style={{
          position: "absolute",
          right: -15,
          top: -6,
          fontWeight: 600,
          fontSize: 14,
          color: "#FFBB79",
          padding: "0 5px",
          borderRadius: 8,
          letterSpacing: 1,
          boxShadow: "0 1px 6px #0001",
          zIndex: 3,
          fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, Arial, sans-serif',
        }}
      >
        {label}
      </div>

      {row.map((cell, colIdx) =>
        isMobile && !cell.fixed ? (
          /* ───────────── شاخهٔ موبایل + سلول غیر فیکس ───────────── */
          <DroppableSlot id={cell.id} key={cell.id}>
            {/* Slot همیشه زیر کتاب */}
            <div style={{ position: "absolute", inset: 0, zIndex: 1 }}>
              <Slot
                highlight={
                  highlighted.row === rowIdx && highlighted.col === colIdx
                }
              />
            </div>

            {/* کتاب و عنوان – فقط اگر book وجود دارد */}
         {cell.book && (
        <ShelfDraggable id={`${cell.id}-book`}>
          <div
            style={{
              position: "relative",
              left: 0,
              top: 0,
              width: 38,
              height: 74,
              borderRadius: 7,
              background: "transparent",
              ...getBookTransform(rowIdx, colIdx),
            }}
          >
            {cell.book}

            {cell.title && (
              <span
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%) rotate(-90deg)",
                  width: 72,
                  fontSize: getSpineFontSize(cell.title),
                  color: "#ffffff",
                  fontWeight: 600,
                  pointerEvents: "none",
                  lineHeight: 1,
                  fontFamily:
                    '"Segoe UI", Tahoma, Geneva, Verdana, Arial, sans-serif',
                }}
              >
                {cell.title}
              </span>
            )}
          </div>
        </ShelfDraggable>
      )}
    </DroppableSlot>

        ) : (
          /* ───────────── شاخهٔ دسکتاپ یا سلول فیکس ───────────── */
          <div
            key={cell.id}
            style={{
              position: "relative",
              width: 38,
              height: 74,
              marginTop: 4,
              zIndex: 2,
              borderRadius: 7,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onDragOver={(e) => {
              e.preventDefault();
              setHighlighted({ row: rowIdx, col: colIdx });
            }}
            onDragLeave={() => setHighlighted({ row: null, col: null })}
            onDrop={() => handleDrop(rowIdx, colIdx)}
          >
            {/* Slot برای خانه‌های غیر فیکس */}
            {!cell.fixed && (
              <div style={{ position: "absolute", inset: 0, zIndex: 1 }}>
                <Slot
                  highlight={
                    highlighted.row === rowIdx && highlighted.col === colIdx
                  }
                />
              </div>
            )}

            {/* کتاب و عنوان – این‌جا هم اضافه شد */}
            {cell.book && (
              <div
                  draggable={started && !finished && !cell.fixed}
    onDragStart={() => setDragItem({
      id: cell.id,
      book: cell.book,
      title: cell.title,
      label: cell.label,
      from: "shelf",
      row: rowIdx,
      col: colIdx
    })}
                style={{
                  position: "relative",
                  left: 0,
                  top: 0,
                  zIndex: 2,
                  width: 38,
                  height: 74,
                  borderRadius: 7,
                  filter: cell.fixed ? "drop-shadow(0 2px 7px #0002)" : "",
                  cursor:
                    started && !finished && !cell.fixed
                      ? "grab"
                      : "not-allowed",
                  background: "transparent",
                  ...getBookTransform(rowIdx, colIdx),
                }}
              >
                {cell.book}

                {cell.title && (
                  <span
                    style={{
                      position: "absolute",
                      left: "50%",
                      top: "50%",
                      transform: "translate(-50%, -50%) rotate(-90deg)",
                      width: 72,
                      fontSize: getSpineFontSize(cell.title),
                      color: "#ffffff",
                      fontWeight: 600,
                      pointerEvents: "none",
                      lineHeight: 1,
                      fontFamily:
                        '"Segoe UI", Tahoma, Geneva, Verdana, Arial, sans-serif',
                    }}
                  >
                    {cell.title}
                  </span>
                )}
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
}

/* helper کوچک برای پراپ‌ست‌های چرخش/جابجایی طولانیِ قبلی */
  function getBookTransform(row, col) {
    // همین isMobile رو مستقیم استفاده می‌کنی!
    const desktopTransforms = {
      0: {
        3: { transform: "rotate(90deg) translate(25px, -10px)" },
        4: { transform: "rotate(90deg) translate(-6px, 25px)" },
      },
      1: { 1: { transform: "rotate(-25deg) translate(-5px, -7px)" } },
      2: { 3: { transform: "rotate(25deg) translate(6px, -3px)" } },
      3: {
        1: { transform: "rotate(-25deg) translate(-5px, -7px)" },
        3: { transform: "rotate(90deg) translate(26px, -24px)" },
        4: { transform: "rotate(-50deg) translate(20px, 22px)" },
      },
      4: {
        0: { transform: "rotate(90deg) translate(25px, -20px)" },
        1: { transform: "rotate(90deg) translate(-6px, 40px)" },
      },
    };

    const mobileTransforms = {

      1: { 1: { transform: "rotate(-15deg) translate(-2px, -2px)" } },
      2: { 3: { transform: "rotate(15deg) translate(3px, -1px)" } },
    4: {
        0: { transform: "rotate(90deg) translate(25px, -20px)" },
        1: { transform: "rotate(90deg) translate(-6px, 30px)" },
      },

    };

    const transforms = isMobile ? mobileTransforms : desktopTransforms;
    return transforms?.[row]?.[col] ?? {};
  }


  // تایمر و اتمام بازی
  React.useEffect(() => {
    // console.log("TIMER CHECK", started, finished, timeLeft);
    if (!started || finished) return;
    if (timeLeft === 0) {
      finishGame();
      return;
    }
    const t = setTimeout(() => setTimeLeft(t => t - 1), 1000);
    return () => clearTimeout(t);
  }, [started, finished, timeLeft]);

  // اتمام بازی و امتیازدهی
  function finishGame() {
    let correct = 0;
    // فرض: initialShelves و shelves هر دو همیشه ساختار ردیف-ستونی مشابه دارند.
    shelves.forEach((row, rowIdx) => {
      row.forEach((cell, colIdx) => {
        
        // فقط اسلات قابل‌جابجایی را بررسی کن (fixed: false)
        if (!cell.fixed) {
          const placed = shelves[rowIdx][colIdx];    // کتاب فعلی کاربر اینجاست
                  // console.log('cell:', cell, 'placed:', placed, 'placed.book:', placed.book);
          if (
            placed.book &&
            placed.title === cell.expectedTitle &&
            placed.label === cell.expectedLabel
          ) {
           correct += 5; 
          }
        }
      });
    });

  // جایزه اگر همه درست باشند و بانک خالی باشد
  // const finalScore = correct + ((bank.length === 0 && correct === bank.length) ? 25 : 0);
  const finalScore = correct ;


  setScore(finalScore);
  setFinished(true);
  // console.log("sending finalScore", finalScore);

  // ذخیره امتیاز
  fetch('/wp-admin/admin-ajax.php?action=bookshelf_save_score', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({ score: finalScore })
  })
    .then(r => r.json())
    .then(json => {
      // console.log("پاسخ ذخیره بازی:", json);
      if (json.success) {
        setChances(prev => Math.max(0, prev - 1));
      }
    });
}


  function labelOfRow(idx) {
     return books[idx]?.category || "-";
  }

  // شروع بازی
function startGame() {
  /* آرایه نهایی بانک و مجموعه‌ی عنوان‌های انتخاب‌شده */
  const bankItems   = [];
  const usedTitles  = new Set();

  /* ۱) ابتدا از هر قفسه کم‌کلمه‌ترین کتاب slot=true را برمی‌داریم
        ولی  فقط اگر عنوانش یکتا باشد */
  books.forEach(shelf => {
    if (bankItems.length >= 5) return;   // بانک پر شد

    // کاندیداهای اسلات
    const candidates = shelf.books.filter(b => b.slot);

    if (candidates.length === 0) return;
    const chosen = candidates.reduce((a, b) =>
      b.title.trim().split(/\s+/).length <
      a.title.trim().split(/\s+/).length ? b : a
    );

    const key = chosen.title.trim().toLowerCase();
    if (!usedTitles.has(key)) {
      bankItems.push({
        id:    chosen.id,
        label: chosen.category,
        title: chosen.title,
        book:  getBookSVG(chosen.category, chosen.id),
      });
      usedTitles.add(key);
    }
  });

  /* ۲) اگر هنوز کمتر از ۵ شد، همهٔ کتاب‌های slot=true را
        به ترتیب کم‌کلمه‌ترین مرور و جاهای خالی را پر می‌کنیم */
  if (bankItems.length < 5) {
    const backups = books
      .flatMap(shelf => shelf.books)
      .filter(b => b.slot)
      .sort(
        (a, b) =>
          a.title.trim().split(/\s+/).length -
          b.title.trim().split(/\s+/).length
      );

    for (const bk of backups) {
      if (bankItems.length >= 5) break;
      const key = bk.title.trim().toLowerCase();
      if (!usedTitles.has(key)) {
        bankItems.push({
          id:    bk.id,
          label: bk.category,
          title: bk.title,
          book:  getBookSVG(bk.category, bk.id),
        });
        usedTitles.add(key);
      }
    }
  }

  /* ست‌کردن بانک و ریست بازی */
  setBank(shuffle(bankItems));         // همیشه دقیقاً ۵ کتاب یکتا
  setStarted(true);
  setFinished(false);
  setTimeLeft(30);
}



//end of startGame

function handleReferralSubmit(e) {
  e.preventDefault();
  // console.log("Referral submitted:", inputReferral);
  fetch('/wp-admin/admin-ajax.php?action=bookshelf_use_referral', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({ code: inputReferral })
  })
    .then(r => r.json())
    .then(json => {
      if (json.success) {
        setReferralMsg("ثبت شد!! شانس شما افزایش یافت.");
        setChances(c => c + 5);
      } else if (json.data && json.data.msg) {
        setReferralMsg(json.data.msg);
      } else if (json.data && typeof json.data === "string") {
        setReferralMsg(json.data); // اگر پیام مستقیم string بود
      } else {
        setReferralMsg("خطای ناشناخته از سرور.");
      }
    })
    .catch(() => {
      setReferralMsg("ارتباط با سرور برقرار نشد.");
    });
}


const handleDragEnd = (event) => {
    console.log("DragEnd!", event);
  const { active, over } = event;
  if (!over) return;

  // ۱. استخراج ID اسلات مبدأ (یا بانک)
  const sourceSlotId = active.id.endsWith("-book")
    ? active.id.replace("-book", "")
    : active.id;

  // ۲. استخراج ID اسلات مقصد
  const destSlotId = over.id;

  // ۳. پیدا کردن مختصات مقصد در ماتریس shelves
  let destRow = -1, destCol = -1;
  shelves.forEach((row, rIdx) =>
    row.forEach((cell, cIdx) => {
      if (cell.id === destSlotId) {
        destRow = rIdx;
        destCol = cIdx;
      }
    })
  );
  if (destRow === -1 || destCol === -1) return;

  const destCell = shelves[destRow][destCol];
  // اگر سلول مقصد ثابت یا پر است، کاری نکن
  if (destCell.fixed || destCell.book) return;

  // ۴. استخراج شیء کتاب (کتاب + عنوان)
  let bookObj;
  const bankIdx = bank.findIndex(b => b.id === sourceSlotId);

  if (bankIdx !== -1) {
    // کتاب از بانک آمده: حذفش از بانک
    bookObj = bank[bankIdx];
    setBank(prev => prev.filter((_, i) => i !== bankIdx));
  } else {
    // کتاب از قفسه آمده: اول مبدأ را خالی کن
    setShelves(prev =>
      prev.map(row =>
        row.map(cell =>
          cell.id === sourceSlotId && cell.book
            ? { ...cell, book: null, title: null }
            : cell
        )
      )
    );
    // سپس شیء کتاب را از اسلات مبدأ استخراج کن
    shelves.forEach(row =>
      row.forEach(cell => {
        if (cell.id === sourceSlotId && cell.book) {
          bookObj = {
            id:    cell.id,
            book:  cell.book,
            title: cell.title
          };
        }
      })
    );
  }

  // ۵. قرار دادن کتاب در مقصد
  setShelves(prev =>
    prev.map(row =>
      row.map(cell =>
        cell.id === destSlotId
          ? { ...cell, book: bookObj.book, title: bookObj.title }
          : cell
      )
    )
  );
};




  return (

    <div style={{
      background:"#f8f1e3",
      borderRadius:24,
      padding:"24px 0 14px 0",
      minHeight: "min(570px, 90vh)",
      display:'flex',
      flexDirection:'column',
      alignItems:'center',
      gap:5
    }}>
      <h2
  style={{
    marginTop: 0,
    // marginBottom: 12,
    fontWeight: 800,
    fontSize: "clamp(17px, 5vw, 24px)",
    textAlign: "center",
    width: "100%",
    lineHeight: 1.2,
    wordBreak: "break-word",
    letterSpacing: 0.3,
    color: "#4a3700"
  }}
>
  Book Master
</h2>

    <DndContext
     sensors={sensors}
  collisionDetection={closestCenter}
    onDragStart={event => {
  console.log("DragStart!", event);
  console.log("ActivatorEvent Type:", event.activatorEvent?.type);
  if (
    event.activatorEvent &&
    ['touchstart', 'touchend'].includes(event.activatorEvent.type)
  ) {
    // یعنی فقط tap بوده، نه drag واقعی
    console.log("Tap detected, ignore drag!");
    return;
  }
    // این کد رو اضافه کن:
    // هم بانک و هم اسلات‌ها رو بگرد پیدا کن!
    let dragItem = bank.find(item => item.id === event.active.id);
    if (!dragItem) {
      // شاید داره کتاب قفسه رو می‌کشه
      for (let row of shelves) {
        for (let cell of row) {
          if (cell.id === event.active.id && cell.book) {
            dragItem = { id: cell.id, book: cell.book, title: cell.title }; // اگر title یا چیز دیگری داری اضافه کن
          }
        }
      }
    }
    setActiveDragItem(dragItem || null);
  }}
  onDragEnd={handleDragEnd}
>
      {/* کنترل تایمر و شروع */}
      <div style={{
        margin: "28px 0 40px 0px", 
        background: "#fff9e3", 
         padding: "12px 8vw", 
      borderRadius: 14, 
        maxWidth:550,
        width:'95%',
        boxShadow: "0 2px 8px #0001"
      }}
        >
<div 
style={{
  marginBottom:14}}>
{notLoggedIn && (
  <div style={{textAlign:'center', color:'#b62', margin:'32px 0 0 0', fontSize: 18}}>
    برای شروع بازی لطفاً ابتدا{" "}
    <span
      style={{color:'#0a8', fontWeight:'bold', cursor:'pointer', textDecoration:'underline'}}
      onClick={() => {
        setShowLoginPopup(true);
        setLoginPolling(true);
      }}
    >
      وارد سایت
    </span>
    {" "}شوید.
    {/* اینجا خط جدید */}
    <div style={{marginTop: 8, fontSize: 14, color: '#555'}}>
      بسته به کیفیت اینترنت، لطفاً صبر کنید تا پنجرهٔ ورود بسته شود.
    </div>
  </div>
)}

{!notLoggedIn &&!hasDisplayName && (
 <div
  style={{
    color: "#e14c2a",
    background: "#fff3e6",
    margin: "12px 0",
    padding: "10px 18px 10px 10px",
    borderRadius: "10px",
    textAlign: "right",
    fontFamily: `"Vazirmatn", "IRANSans", "Tahoma", sans-serif`,
    fontWeight: 500,
    fontSize: "14px",
    letterSpacing: 0,
    boxShadow: "0 2px 8px #f4c8b166",
    borderRight: "4px solid #fd8a4a",
    lineHeight: 2,
    direction: "rtl"
  }}
>
  برای بازی باید <span style={{color:"#c22700"}}>نام نمایشی</span> خود را ثبت کنید.
</div>

)}
  {/* {hasDisplayName && !started && !notLoggedIn && ( */}
{hasDisplayName && !started && !notLoggedIn && (
  <button
    onClick={startGame}
    disabled={chances === 0}
    style={{
      background: chances === 0 ? "#ddd" : "#fdc85c",
      color: chances === 0 ? "#aaa" : "#704700",
      fontWeight: "bold",
      fontSize: 18,
      border: 0,
      borderRadius: 8,
      padding: "7px 36px",
      cursor: chances === 0 ? "not-allowed" : "pointer",
      boxShadow: "0 2px 10px #0001"
    }}
  >
    شروع بازی
  </button>
)}

{!notLoggedIn && !hasDisplayName && (
  <form
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      marginBottom: 18,
      gap: 10,
      fontFamily: `"Vazirmatn", "IRANSans", "Tahoma", sans-serif`,
      direction: "rtl"
    }}
    onSubmit={handleDisplayNameSubmit}
  >
    {/* <label style={{ 
      fontWeight: 500,
        minWidth: 80,

       fontSize: 12,
       whiteSpace: "nowrap",
        fontFamily: `"Vazirmatn", "IRANSans", "Tahoma", sans-serif`,
        marginLeft: 6 }}>نام نمایشی:</label> */}
    <input
      type="text"
      maxLength={15}
      required
        placeholder="نام نمایشی"

      value={displayName}
      onChange={e => setDisplayName(e.target.value.replace(/[^\w\u0600-\u06FF\s]/g, ""))}
      style={{
        margin: "0 2px",
        padding: "12px 18px",
        borderRadius: 7,
        border: "1.5px solid #e0c189",
        fontSize: 13,
         width: "100%", 
           minWidth: 0, 
           boxSizing: "border-box",
        fontFamily: `"Vazirmatn", "IRANSans", "Tahoma", sans-serif`
      }}
    />
    <button
      type="submit"
      style={{
        background: "#8cbe48",
        color: "#fff",
        padding: "7px 22px",
        border: 0,
        borderRadius: 7,
        fontWeight: 700,
        fontSize: 15,
        marginLeft: 8,
        cursor: "pointer",
        transition: "background 0.2s",
        minWidth: 70,             
        whiteSpace: "nowrap",       
        letterSpacing: 0,           
        textAlign: "center",       
        lineHeight: 1.8  
      }}
    >
      ثبت
    </button>
    {displayNameMsg && (
      <span
        style={{
          color: "#e14c2a",
          background: "#fff3e6",
          borderRadius: "8px",
          padding: "4px 10px",
          fontWeight: 600,
          fontSize: 14,
          fontFamily: `"Vazirmatn", "IRANSans", "Tahoma", sans-serif`,
          marginLeft: 10,
          boxShadow: "0 1px 4px #f4c8b133",
          borderRight: "3px solid #fd8a4a"
        }}
      >
        {displayNameMsg}
      </span>
    )}
  </form>
)}


{chances === 0 && !notLoggedIn && (

  <div
  style={{
    color: "#e14c2a",
    background: "#fff3e6",
    margin: "16px 0",
    padding: "10px 18px 10px 10px",
    borderRadius: "10px",
    textAlign: "right",
    fontFamily: `"Vazirmatn", "IRANSans", "Tahoma", sans-serif`,
    fontWeight: 500,
    fontSize: "14px",
    letterSpacing: 0,
    boxShadow: "0 2px 8px #f4c8b166",
    borderRight: "4px solid #fd8a4a",
    lineHeight: 2,
    direction: "rtl"
  }}
>   شانس شما برای امروز تمام شده!

</div>

)}

  {/* {chances === 0 && (
    <div style={{color: "red", fontWeight: 600, marginTop: 8}}>
      شما امروز شانسی برای بازی ندارید.
    </div>
  )} */}




  {finished &&
    <span style={{color:"#268f4c",fontWeight:"bold",fontSize:18}}>امتیاز شما: {score}</span>
  }
</div>
</div>
      {/* بکگراند قفسه و طبقات */}
<BookshelfFrameSVG
style={{
  width: "100%",
 maxWidth: 420,
  minHeight: 400,
  minWidth: 220,
  height: "auto",
  margin: "0 auto",
  position: "relative"
}}>
        {/* خطوط طبقات */}
        <div style={{position:"absolute",left:0,right:0,top:"23%",height:0,borderBottom:"6px solid #936037",borderRadius:0,zIndex:1}}/>
        <div style={{position:"absolute",left:0,right:0,top:"42%",height:0,borderBottom:"6px solid #936037",borderRadius:0,zIndex:1}}/>
        <div style={{position:"absolute",left:0,right:0,top:"62%",height:0,borderBottom:"6px solid #936037",borderRadius:0,zIndex:1}}/>
        <div style={{position:"absolute",left:0,right:0,top:"81%",height:0,borderBottom:"6px solid #936037",borderRadius:0,zIndex:1}}/>
        <div style={{position:"absolute",left:0,right:0,top:"100%",height:0,borderBottom:"6px solid #936037",borderRadius:0,zIndex:1}}/>

  <div style={{
    position: "absolute",
      top: isMobile ? "11%" : 43,
    right: isMobile ? "0%" : "-38px",
    zIndex: 12
  }}>
      <FlowerPot width={isMobile ? 90 : 180} height={isMobile ? 64 : 70} />
  </div>

  <div style={{
    position: "absolute",
     top: isMobile ? "31%" : 53,
  right: isMobile ? "4%" : 28, 
    zIndex: 12
  }}>

        <FigmaBook width={isMobile ? 65 : 70} height={isMobile ? 100 : 275} />
  </div>

    <div style={{
    position: "absolute",
   top: isMobile ? "14%" : 53,
  right: isMobile ? "4%" : 28, 
    zIndex: 12
  }}>
    <FigmaBook1
     width={70} height={237}
      />
  </div>
      <div style={{
    position: "absolute",
  top: isMobile ? "14%" : 53,
  right: isMobile ? "4%" : 28, 
    zIndex: 12
  }}>
    <FigmaBook2
     width={70} height={198}
      />
  </div>
        {/* <div style={{
    position: "absolute",
    top: 53,     
    right: 120,  
    zIndex: 12
  }}>
    <FigmaBook3
     width={100} height={324}
      />
        </div> */}
        <div style={{
    position: "absolute",
    top: 53,     
    right: 90,  
    zIndex: 12
  }}>
    {/* <FigmaBook4
     width={100} height={324}
      /> */}
      
        {/* <div style={{
    position: "absolute",
    top: 270.5,     
    right: 5,  
    zIndex: 12
  }}>
    <FigmaBook
     width={70} height={275}
      />
  </div> */
  }
  </div>
  {showLoginPopup && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.35)",
      zIndex: 1000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
    onClick={() => setShowLoginPopup(false)} // کلیک رو پس‌زمینه می‌بنده
  >
    <div
      style={{
        background: "#fff",
        borderRadius: 13,
        padding: 0,
        width: "95vw",
        maxWidth: 410,
        height: "77vh",
        boxShadow: "0 8px 32px #0002",
         zIndex: 10001, 
        position: "relative",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
      onClick={e => e.stopPropagation()} // کلیک داخل پاپ‌آپ رو نمی‌بنده
    >
      {/* دکمه بستن */}
      <button
        onClick={() => setShowLoginPopup(false)}
        style={{
          position: "absolute",
          left: 10,
          top: 7,
          fontSize: 23,
          border: "none",
          background: "none",
          cursor: "pointer",
          color: "#b22",
          zIndex: 2,
        }}
      >×</button>
      {/* iframe لاگین */}
      <iframe
        src="https://zabanmehrpub.com/?login=true&page=2&redirect_to=https%3A%2F%2Fzabanmehrpub.com%2F"
      //  src="https://stage-webapp.petboom.co/profile/?login=true&back=profile=1"

        style={{
          width: "100%",
          height: "100%",
          border: "none",
          borderRadius: "0 0 13px 13px",
        }}
        title="ورود"
      />
    </div>
  </div>
)}

        {/* ردیف‌ها */}
        <div style={{position:'relative',zIndex:3}}>
         {renderRow(shelves[0],0,labelOfRow(0))}
         {renderRow(shelves[1],1,labelOfRow(1))}
         {renderRow(shelves[2],2,labelOfRow(2))}
         {renderRow(shelves[3],3,labelOfRow(3))}
         {renderRow(shelves[4],4,labelOfRow(4))}
        </div>
        <div
    style={{
      position: "absolute",
      right: -48, // با توجه به عرض قفسه و دلخواه تنظیم کن
      top: 130,   // ارتفاع مورد نظر
      width: 75,  // سایز دلخواه گلدان
      height: 180,
      zIndex: 4,
      pointerEvents: "none"
    }}
  >

  </div>
     </BookshelfFrameSVG>
      {/* بانک کتاب‌ها پایین */}
         <div 
        style={{
          width: '100%',             // عرض کامل به والد داده شود
          padding: '0 10px',         // کمی فاصله از طرفین صفحه
          boxSizing: 'border-box',   // برای اینکه پدینگ به عرض اضافه نشود
          marginTop: 0,
          marginBottom: 0,
          minHeight: 140             // یک ارتفاع حداقلی برای جلوگیری از پرش
        }}>
{started && (
    isMobile ? (
          <BookBankCarousel
            bookBank={bank}
            onDragStart={(e, item) => {
              if (started && !finished) {
                setDragItem(item);
              }
            }}
          />
        ) : (
          // --- حالت دسکتاپ (بدون تغییر) ---
          <div style={{ display:'flex', gap:30, justifyContent:'center' }}>
        {bank.map((item, i) => {
    // ۱) تیتر را با فاصله جدا کن
    const parts = item.title.trim().split(" ");
    // ۲) اگر دقیقاً دو کلمه است آن‌ها را با newline به هم بچسبان
    const twoLineTitle = parts.length === 2
      ? `${parts[0]}\n${parts[1]}`
      : item.title;

    return (
      <div
        key={item.id}
        draggable={started && !finished}
        onDragStart={() => setDragItem({ ...item, from: "bank" })}
        style={{
          cursor: started && !finished ? "grab" : "not-allowed",
          borderRadius: 11,
          boxShadow: "0 4px 18px #0002",
          opacity: started && !finished ? 1 : 0.3,
          width: 100, 
          height: 130,
          position: 'relative',
          background: "none"
        }}
      >
        <BookIconCartoon
          title={twoLineTitle}
          color={getBookColor(item.label).color}
          stroke={getBookColor(item.label).stroke}
          width={90}
          height={120}
        />
      </div>
    );
  })}
</div>
       )
)}
    
      </div>
        {started && !finished &&
    <span style={{fontSize:19,color:'#be5e00',fontWeight:'bold',margin:-30}}>زمان باقی‌مانده: {timeLeft}</span>
  }

 <div
  style={{
    margin: "28px 0 10px",
    background: "#fff9e3",
    padding: "16px 24px",
    borderRadius: "14px",
    maxWidth: 320,
    width: "95%",
    boxShadow: "0 2px 8px #0001",
    direction: "rtl",
    fontFamily: `"Vazirmatn", "IRANSans", "Tahoma", sans-serif`
  }}
>
  {/* خط اول: امتیاز و رتبه شما */}
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 9,
      flexWrap: "wrap",
      fontSize: "clamp(12px, 3vw, 10px)",
      marginBottom: 10,
      fontWeight: 700,
      textAlign: "center"
    }}
  >
    <span>
      امتیاز کل: <span style={{ color: "#e89b00" }}>{score}</span>
    </span>
    <span style={{ borderRight: "2px solid #fae3ad", height: 16, margin: "0 8px" }} />
    <span>
      رتبه: <span style={{ color: "#4a3700" }}>{rank}</span>
    </span>

      <span style={{ borderRight: "2px solid #fae3ad", height: 16, margin: "0 8px" }} />

  <span>
    تعداد شانس: <span style={{ color: "#d14d72" }}>{chances}</span>
  </span>

  <span style={{ borderRight: "2px solid #fae3ad", height: 16, margin: "0 8px" }} />


  {/* دکمه اشتراک‌گذاری */}
  <button
    style={{
      border: "none",
      background: "none",
      cursor: "pointer",
      marginRight: 8,
      display: 'flex',
      alignItems: 'center',
      padding: 10,
      fontFamily: "Vazir, Tahoma, Arial, sans-serif"
    }}
    onClick={handleShareImage}
  >
    <svg width="28" height="28" fill="#d79917" viewBox="0 0 24 24">
      <path d="M17 8.5a2.5 2.5 0 0 0-1.98.98l-6.35-2.54A2.497 2.497 0 0 0 6.5 3a2.5 2.5 0 1 0 0 5c.43 0 .84-.11 1.2-.29l6.35 2.54c-.03.13-.05.26-.05.4s.02.27.05.4l-6.35 2.54A2.5 2.5 0 1 0 6.5 21a2.497 2.497 0 0 0 2.17-1.44l6.35-2.54A2.5 2.5 0 1 0 17 8.5zm0 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-10-15a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0 15a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
    </svg>
    کاراکتر من
  </button>

<button
  onClick={() => setShowTextPopup(true)}
  style={{
    marginRight: 8,
     background: "none",
    padding: "8px 14px",
    border: "none",
    cursor: "pointer",
    fontFamily: "Vazir, Tahoma, Arial, sans-serif"
  }}
>
  <svg
  width="18"
  height="18"
  viewBox="0 0 24 24"
  fill="#d79917"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="9" y="9" width="13" height="13" rx="2.5" fill="#fff" stroke="#d79917" strokeWidth="1.7"/>
  <rect x="3" y="3" width="13" height="13" rx="2.5" fill="none" stroke="#d79917" strokeWidth="1.7"/>
  <path d="M13 12.5h4m-2-2v4" stroke="#d79917" strokeWidth="1.7" strokeLinecap="round"/>
</svg>
  اشتراک‌گذاری
</button>
{showTextPopup && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 99,
      background: "rgba(0,0,0,0.35)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Vazir, Tahoma, Arial, sans-serif"
    }}
  >
    <div
      style={{
        background: "#fff",
        borderRadius: 13,
        padding: "30px 20px 18px 18px",
        minWidth: 320,
        boxShadow: "0 8px 32px #0002",
        direction: "rtl",
        position: "relative"
      }}
    >
      {/* دکمه بستن */}
      <button
        onClick={() => setShowTextPopup(false)}
        style={{
          position: "absolute",
          left: 10,
          top: 7,
          fontSize: 23,
          border: "none",
          background: "none",
          cursor: "pointer",
          color: "#a66"
        }}
      >
        ×
      </button>

      {/* متن قابل کپی */}
      <div
        style={{
          border: "1px solid #eee",
          borderRadius: 8,
          padding: 14,
          background: "#f9f9f9",
          marginBottom: 18,
          fontSize: 15,
          lineHeight: "2",
          fontFamily: "Vazir, Tahoma, Arial, sans-serif"
        }}
      >
        من <b>{displayName}</b> شما رو به شرکت در  مسابقه  bookmaster دعوت میکنم.<br />
 کد معرف: <b>{referralCode}</b><br />
        لینک شرکت در مسابقه: <a href="https://zabanmehrpub.com/bookmaster/" style={{ color: "#4a6bf7" }} target="_blank" rel="noopener noreferrer">www.zabanmehrpub.com/bookmaster</a>
      </div>

      {/* دکمه کپی */}
      <button
        onClick={() => {
          navigator.clipboard.writeText(
            `من ${displayName} شما رو به شرکت در مسابقه  bookmaster دعوت میکنم.
\n:کد معرف ${referralCode}
\nلینک: https://zabanmehrpub.com/`
          );
          setCopied(true);
          setTimeout(() => setCopied(false), 1300);
        }}
        style={{
          background: "#fdc35b",
          border: "none",
          borderRadius: 8,
          padding: "7px 16px",
          fontWeight: 700,
          fontSize: 15,
          color: "#664400",
          cursor: "pointer",
          minWidth: 70
        }}
      >
        {copied ? "کپی شد!" : (
          <>
            <span style={{ verticalAlign: "middle", marginLeft: 6, marginRight: -3 }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="#d79917">
                <rect x="9" y="9" width="13" height="13" rx="2.5" fill="#fff" stroke="#d79917" strokeWidth="1.7"/>
                <rect x="3" y="3" width="13" height="13" rx="2.5" fill="none" stroke="#d79917" strokeWidth="1.7"/>
                <path d="M13 12.5h4m-2-2v4" stroke="#d79917" strokeWidth="1.7" strokeLinecap="round"/>
              </svg>
            </span>
            کپی متن
          </>
        )}
      </button>
    </div>
  </div>
)}

  </div>
  
  {/* خط دوم: کد معرف با آیکن */}
 <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    background: "#fff6e2",
    borderRadius: 10,
    padding: "8px 10px",
    fontSize: 15,
    fontWeight: 500,
    boxShadow: "0 1px 4px #eed1ad44"
  }}
>
  <svg width="22" height="22" fill="none" style={{ marginLeft: 3 }}>
    <circle cx="11" cy="11" r="10" fill="#f1cb75" stroke="#ebaa34" strokeWidth="2"/>
    <path d="M9 14.5l4-3-4-3v6z" fill="#fff" />
  </svg>
  <span style={{ color: "#ae7105" }}>کد معرف شما:</span>
  <span
    style={{
      userSelect: "all",
      fontFamily: "monospace",
      background: "#fff9e8",
      padding: "3px 8px",
      borderRadius: 6,
      fontSize: 15,
      fontWeight: 700,
      letterSpacing: 1.1
    }}
  >
    {referralCode}
  </span>

</div>

</div>

{/* فرم ثبت کد معرف دیگران */}
{chances === 0 && (
<div style={{background:"#ffe", padding:"12px 22px", borderRadius:12, margin:"0 0 20px 0"}}>
  <form onSubmit={handleReferralSubmit} style={{ display: "flex", alignItems: "center" }}>
    <label style={{ marginLeft: 8 }}>کد معرف </label>
    <input 
     id="invitations-and-score" 
      type="text" 
      value={inputReferral} 
      onChange={e => setInputReferral(e.target.value)} 
      style={{ margin: "0 8px", padding: "6px 14px", borderRadius: 6, border: "1px solid #ccc" }} 
    />
  
       <button 
      type="submit" 
      style={{ 
        background: "#57c777", 
        color: "#fff", 
        padding: "7px 22px", 
        border: 0, 
        borderRadius: 6, 
        cursor: "pointer" 
      }}
    >
      دریافت شانس
    </button>
  </form>
  {referralMsg && <div style={{color:"red",marginTop:8}}>{referralMsg}</div>}
</div>

)}
  {finished && (
  <div style={{marginTop:22}}>
    <button
      onClick={() => window.location.reload()}
      disabled={chances === 0}
      style={{
        background: chances === 0 ? "#eee" : "#f4d24a",
        color: "#444",
        fontWeight: "bold",
        fontSize: 16,
        border: 0,
        borderRadius: 8,
        padding: "7px 32px",
        cursor: chances === 0 ? "not-allowed" : "pointer",
        boxShadow: "0 2px 10px #0001"
      }}
    >
      دوباره بازی کن
    </button>
    {/* {chances === 0 &&
      <div style={{ color: "red", fontWeight: 600, marginTop: 8 }}>
        شانس شما برای امروز تمام شده!
      </div>
    } */}
	
  </div>
  
)}
  
{/* <div style={{ position: "relative", width: 180, margin: "50px auto", height: 98, background: "#fff9e3", borderRadius: 14, boxShadow: "0 2px 8px #0001", display: "flex", alignItems: "center", justifyContent: "center" }}>
  <ArrowButton direction="left" onClick={slideLeft} disabled={carouselIndex === 0} />
  <div style={{ overflow: "hidden", width: 120, display: "flex" }}>
    <div style={{
      display: "flex",
      transform: `translateX(-${carouselIndex * 56}px)`,
      transition: "transform 0.35s"
    }}>
      {bank.slice(carouselIndex, carouselIndex + visibleCount).map(item => (
        <DraggableBook id={item.id} key={item.id}>{item.book}</DraggableBook>
      ))}
    </div>
  </div>
  <ArrowButton direction="right" onClick={slideRight} disabled={carouselIndex >= bank.length - visibleCount} />
</div> */}

<DragOverlay>
    {activeDragItem ? (
      <BookIconCartoon
        title={activeDragItem.title}
        width={BOOK_WIDTH}
        height={120}
      />
    ) : null}
  </DragOverlay>
</DndContext>

    </div>
    
  );


}


